// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { DocsSchemaData, DocsSchemaErrors, HealthCheckData, HealthCheckErrors, HealthCheckLiveData, HealthCheckLiveErrors, HealthCheckLiveResponses, HealthCheckResponses, HealthCheckServicesData, HealthCheckServicesErrors, HealthCheckServicesResponses, V1AppConfigGetClientsData, V1AppConfigGetClientsErrors, V1AppConfigGetClientsResponses, V1AppConfigGetLoginBrandingData, V1AppConfigGetLoginBrandingErrors, V1AppConfigGetLoginBrandingImageData, V1AppConfigGetLoginBrandingImageErrors, V1AppConfigGetLoginBrandingImageResponses, V1AppConfigGetLoginBrandingResponses, V1AppConfigGetStatusData, V1AppConfigGetStatusErrors, V1AppConfigGetStatusResponses, V1AssetsCreateAssetsData, V1AssetsCreateAssetsErrors, V1AssetsCreateAssetsResponses, V1AssetsGetAssetData, V1AssetsGetAssetErrors, V1AssetsGetAssetResponses, V1AuditListEventsData, V1AuditListEventsErrors, V1AuditListEventsResponses, V1AuditListMyEventsData, V1AuditListMyEventsErrors, V1AuditListMyEventsResponses, V1AuthActivateInviteData, V1AuthActivateInviteErrors, V1AuthActivateInviteResponses, V1AuthConfirmEmailChangeData, V1AuthConfirmEmailChangeErrors, V1AuthConfirmEmailChangeResponses, V1AuthDeleteUserData, V1AuthDeleteUserErrors, V1AuthDeleteUserResponses, V1AuthGetSessionData, V1AuthGetSessionErrors, V1AuthGetSessionResponses, V1AuthListSessionsData, V1AuthListSessionsErrors, V1AuthListSessionsResponses, V1AuthNativeSessionsCurrentData, V1AuthNativeSessionsCurrentErrors, V1AuthNativeSessionsCurrentResponses, V1AuthNativeSessionsData, V1AuthNativeSessionsErrors, V1AuthNativeSessionsRenewalsData, V1AuthNativeSessionsRenewalsErrors, V1AuthNativeSessionsRenewalsResponses, V1AuthNativeSessionsResponses, V1AuthOidcCallbackData, V1AuthOidcCallbackErrors, V1AuthOidcLogoutData, V1AuthOidcLogoutErrors, V1AuthOidcLogoutResponses, V1AuthOidcNativeAccountActionsData, V1AuthOidcNativeAccountActionsErrors, V1AuthOidcNativeAccountActionsResponses, V1AuthOidcNativeAuthorizationsData, V1AuthOidcNativeAuthorizationsErrors, V1AuthOidcNativeAuthorizationsOpenData, V1AuthOidcNativeAuthorizationsOpenErrors, V1AuthOidcNativeAuthorizationsResponses, V1AuthRefreshData, V1AuthRefreshErrors, V1AuthRefreshResponses, V1AuthRequestEmailChangeData, V1AuthRequestEmailChangeErrors, V1AuthRequestEmailChangeResponses, V1AuthRevokeSessionData, V1AuthRevokeSessionErrors, V1AuthRevokeSessionResponses, V1AuthRevokeSessionsData, V1AuthRevokeSessionsErrors, V1AuthRevokeSessionsResponses, V1AuthSignOutData, V1AuthSignOutErrors, V1AuthSignOutResponses, V1AuthStartAccountActionData, V1AuthStartAccountActionErrors, V1AuthStartAccountActionResponses, V1AuthStartOidcLoginData, V1AuthStartOidcLoginErrors, V1AuthStartOidcLoginResponses, V1AuthValidateInviteData, V1AuthValidateInviteErrors, V1AuthValidateInviteResponses, V1BackofficeActivateOperatorInvitationData, V1BackofficeActivateOperatorInvitationErrors, V1BackofficeActivateOperatorInvitationResponses, V1BackofficeAuthGetSessionData, V1BackofficeAuthGetSessionErrors, V1BackofficeAuthGetSessionResponses, V1BackofficeAuthOidcCallbackData, V1BackofficeAuthOidcCallbackErrors, V1BackofficeAuthOidcLogoutData, V1BackofficeAuthOidcLogoutErrors, V1BackofficeAuthOidcLogoutResponses, V1BackofficeAuthSignOutData, V1BackofficeAuthSignOutErrors, V1BackofficeAuthSignOutResponses, V1BackofficeAuthStartOidcLoginData, V1BackofficeAuthStartOidcLoginErrors, V1BackofficeAuthStartOidcLoginResponses, V1BackofficeChangeOperatorInvitationEmailData, V1BackofficeChangeOperatorInvitationEmailErrors, V1BackofficeChangeOperatorInvitationEmailResponses, V1BackofficeCheckSlugAvailabilityData, V1BackofficeCheckSlugAvailabilityErrors, V1BackofficeCheckSlugAvailabilityResponses, V1BackofficeCreateOrganizationData, V1BackofficeCreateOrganizationErrors, V1BackofficeCreateOrganizationResponses, V1BackofficeDeactivateOperatorData, V1BackofficeDeactivateOperatorErrors, V1BackofficeDeactivateOperatorResponses, V1BackofficeExportsIdData, V1BackofficeExportsIdErrors, V1BackofficeExportsIdResponses, V1BackofficeExportUsersData, V1BackofficeExportUsersErrors, V1BackofficeExportUsersResponses, V1BackofficeGetClientPolicyData, V1BackofficeGetClientPolicyErrors, V1BackofficeGetClientPolicyResponses, V1BackofficeGetFirstAdminInvitationData, V1BackofficeGetFirstAdminInvitationErrors, V1BackofficeGetFirstAdminInvitationResponses, V1BackofficeGetNotificationRecipientsData, V1BackofficeGetNotificationRecipientsErrors, V1BackofficeGetNotificationRecipientsResponses, V1BackofficeGetOrganizationData, V1BackofficeGetOrganizationErrors, V1BackofficeGetOrganizationResponses, V1BackofficeGetUserNotificationPreferencesData, V1BackofficeGetUserNotificationPreferencesErrors, V1BackofficeGetUserNotificationPreferencesResponses, V1BackofficeGetUserPushRegistrationsData, V1BackofficeGetUserPushRegistrationsErrors, V1BackofficeGetUserPushRegistrationsResponses, V1BackofficeGetUserSessionsData, V1BackofficeGetUserSessionsErrors, V1BackofficeGetUserSessionsResponses, V1BackofficeGrantOrganizationOwnershipData, V1BackofficeGrantOrganizationOwnershipErrors, V1BackofficeGrantOrganizationOwnershipResponses, V1BackofficeInviteOperatorData, V1BackofficeInviteOperatorErrors, V1BackofficeInviteOperatorResponses, V1BackofficeInviteOrganizationOwnerData, V1BackofficeInviteOrganizationOwnerErrors, V1BackofficeInviteOrganizationOwnerResponses, V1BackofficeListAuditEventsData, V1BackofficeListAuditEventsErrors, V1BackofficeListAuditEventsResponses, V1BackofficeListOperatorsData, V1BackofficeListOperatorsErrors, V1BackofficeListOperatorsResponses, V1BackofficeListOrganizationPeopleData, V1BackofficeListOrganizationPeopleErrors, V1BackofficeListOrganizationPeopleResponses, V1BackofficeListOrganizationsData, V1BackofficeListOrganizationsErrors, V1BackofficeListOrganizationsResponses, V1BackofficeListSentNotificationsData, V1BackofficeListSentNotificationsErrors, V1BackofficeListSentNotificationsResponses, V1BackofficeListUsersData, V1BackofficeListUsersErrors, V1BackofficeListUsersResponses, V1BackofficePurgeOrganizationData, V1BackofficePurgeOrganizationErrors, V1BackofficePurgeOrganizationResponses, V1BackofficeReactivateOperatorData, V1BackofficeReactivateOperatorErrors, V1BackofficeReactivateOperatorResponses, V1BackofficeRemoveOperatorData, V1BackofficeRemoveOperatorErrors, V1BackofficeRemoveOperatorResponses, V1BackofficeRemoveOrganizationOwnerData, V1BackofficeRemoveOrganizationOwnerErrors, V1BackofficeRemoveOrganizationOwnerResponses, V1BackofficeResendFirstAdminInvitationData, V1BackofficeResendFirstAdminInvitationErrors, V1BackofficeResendFirstAdminInvitationResponses, V1BackofficeResendOperatorInvitationData, V1BackofficeResendOperatorInvitationErrors, V1BackofficeResendOperatorInvitationResponses, V1BackofficeRetryProvisioningData, V1BackofficeRetryProvisioningErrors, V1BackofficeRetryProvisioningResponses, V1BackofficeRevokeOperatorInvitationData, V1BackofficeRevokeOperatorInvitationErrors, V1BackofficeRevokeOperatorInvitationResponses, V1BackofficeRevokeOrganizationOwnershipData, V1BackofficeRevokeOrganizationOwnershipErrors, V1BackofficeRevokeOrganizationOwnershipResponses, V1BackofficeSendNotificationData, V1BackofficeSendNotificationErrors, V1BackofficeSendNotificationResponses, V1BackofficeSetClientPlatformVersionsData, V1BackofficeSetClientPlatformVersionsErrors, V1BackofficeSetClientPlatformVersionsResponses, V1BackofficeSetMaintenanceData, V1BackofficeSetMaintenanceErrors, V1BackofficeSetMaintenanceResponses, V1BackofficeSetOrganizationQuotaData, V1BackofficeSetOrganizationQuotaErrors, V1BackofficeSetOrganizationQuotaResponses, V1BackofficeSuspendOrganizationData, V1BackofficeSuspendOrganizationErrors, V1BackofficeSuspendOrganizationResponses, V1BackofficeValidateOperatorInvitationData, V1BackofficeValidateOperatorInvitationErrors, V1BackofficeValidateOperatorInvitationResponses, V1DirectoryAbandonUploadBatchData, V1DirectoryAbandonUploadBatchErrors, V1DirectoryAbandonUploadBatchResponses, V1DirectoryAbandonUploadsData, V1DirectoryAbandonUploadsErrors, V1DirectoryAbandonUploadsResponses, V1DirectoryAddFavoritesData, V1DirectoryAddFavoritesErrors, V1DirectoryAddFavoritesResponses, V1DirectoryAnnounceBatchFilesData, V1DirectoryAnnounceBatchFilesErrors, V1DirectoryAnnounceBatchFilesResponses, V1DirectoryAuthorizeDownloadData, V1DirectoryAuthorizeDownloadErrors, V1DirectoryAuthorizeDownloadResponses, V1DirectoryAuthorizeDownloadsData, V1DirectoryAuthorizeDownloadsErrors, V1DirectoryAuthorizeDownloadsResponses, V1DirectoryAuthorizeVersionDownloadData, V1DirectoryAuthorizeVersionDownloadErrors, V1DirectoryAuthorizeVersionDownloadResponses, V1DirectoryCompleteBatchFilesData, V1DirectoryCompleteBatchFilesErrors, V1DirectoryCompleteBatchFilesResponses, V1DirectoryCompleteUploadData, V1DirectoryCompleteUploadErrors, V1DirectoryCompleteUploadResponses, V1DirectoryConfirmPartData, V1DirectoryConfirmPartErrors, V1DirectoryConfirmPartResponses, V1DirectoryCopyNodesData, V1DirectoryCopyNodesErrors, V1DirectoryCopyNodesResponses, V1DirectoryCreateDownloadPlanData, V1DirectoryCreateDownloadPlanErrors, V1DirectoryCreateDownloadPlanResponses, V1DirectoryCreateFolderData, V1DirectoryCreateFolderErrors, V1DirectoryCreateFolderResponses, V1DirectoryDeletePermanentlyData, V1DirectoryDeletePermanentlyErrors, V1DirectoryDeletePermanentlyResponses, V1DirectoryDeleteVersionData, V1DirectoryDeleteVersionErrors, V1DirectoryDeleteVersionResponses, V1DirectoryEmptyTrashData, V1DirectoryEmptyTrashErrors, V1DirectoryEmptyTrashResponses, V1DirectoryGetChangesHeadData, V1DirectoryGetChangesHeadErrors, V1DirectoryGetChangesHeadResponses, V1DirectoryGetNodeData, V1DirectoryGetNodeErrors, V1DirectoryGetNodeResponses, V1DirectoryGetNodesData, V1DirectoryGetNodesErrors, V1DirectoryGetNodesResponses, V1DirectoryGetThumbnailsData, V1DirectoryGetThumbnailsErrors, V1DirectoryGetThumbnailsResponses, V1DirectoryIssuePartUrlsData, V1DirectoryIssuePartUrlsErrors, V1DirectoryIssuePartUrlsResponses, V1DirectoryListAncestorsData, V1DirectoryListAncestorsErrors, V1DirectoryListAncestorsResponses, V1DirectoryListChangesData, V1DirectoryListChangesErrors, V1DirectoryListChangesResponses, V1DirectoryListChildrenData, V1DirectoryListChildrenErrors, V1DirectoryListChildrenResponses, V1DirectoryListFavoritesData, V1DirectoryListFavoritesErrors, V1DirectoryListFavoritesResponses, V1DirectoryListFolderUploadsData, V1DirectoryListFolderUploadsErrors, V1DirectoryListFolderUploadsResponses, V1DirectoryListGrantsData, V1DirectoryListGrantsErrors, V1DirectoryListGrantsResponses, V1DirectoryListRecentData, V1DirectoryListRecentErrors, V1DirectoryListRecentResponses, V1DirectoryListSharedWithMeData, V1DirectoryListSharedWithMeErrors, V1DirectoryListSharedWithMeResponses, V1DirectoryListTrashData, V1DirectoryListTrashErrors, V1DirectoryListTrashResponses, V1DirectoryListUploadBatchesData, V1DirectoryListUploadBatchesErrors, V1DirectoryListUploadBatchesResponses, V1DirectoryListUploadsInProgressData, V1DirectoryListUploadsInProgressErrors, V1DirectoryListUploadsInProgressResponses, V1DirectoryListVersionsData, V1DirectoryListVersionsErrors, V1DirectoryListVersionsResponses, V1DirectoryMoveNodeData, V1DirectoryMoveNodeErrors, V1DirectoryMoveNodeResponses, V1DirectoryOpenMultipartData, V1DirectoryOpenMultipartErrors, V1DirectoryOpenMultipartResponses, V1DirectoryOpenUploadData, V1DirectoryOpenUploadErrors, V1DirectoryOpenUploadResponses, V1DirectoryPreviewMoveData, V1DirectoryPreviewMoveErrors, V1DirectoryPreviewMoveResponses, V1DirectoryPreviewTrashData, V1DirectoryPreviewTrashEmptyingData, V1DirectoryPreviewTrashEmptyingErrors, V1DirectoryPreviewTrashEmptyingResponses, V1DirectoryPreviewTrashErrors, V1DirectoryPreviewTrashResponses, V1DirectoryRemoveFavoritesData, V1DirectoryRemoveFavoritesErrors, V1DirectoryRemoveFavoritesResponses, V1DirectoryRenameNodeData, V1DirectoryRenameNodeErrors, V1DirectoryRenameNodeResponses, V1DirectoryRestoreFromTrashData, V1DirectoryRestoreFromTrashErrors, V1DirectoryRestoreFromTrashResponses, V1DirectoryRestoreVersionData, V1DirectoryRestoreVersionErrors, V1DirectoryRestoreVersionResponses, V1DirectoryResumeUploadData, V1DirectoryResumeUploadErrors, V1DirectoryResumeUploadResponses, V1DirectorySearchData, V1DirectorySearchErrors, V1DirectorySearchResponses, V1DirectorySetGrantsData, V1DirectorySetGrantsErrors, V1DirectorySetGrantsResponses, V1DirectorySetOrgLinkData, V1DirectorySetOrgLinkErrors, V1DirectorySetOrgLinkResponses, V1DirectoryTrashData, V1DirectoryTrashErrors, V1DirectoryTrashResponses, V1GroupsAddMembersData, V1GroupsAddMembersErrors, V1GroupsAddMembersResponses, V1GroupsCreateData, V1GroupsCreateErrors, V1GroupsCreateResponses, V1GroupsDeleteData, V1GroupsDeleteErrors, V1GroupsDeleteResponses, V1GroupsGetData, V1GroupsGetErrors, V1GroupsGetResponses, V1GroupsListCandidatesData, V1GroupsListCandidatesErrors, V1GroupsListCandidatesResponses, V1GroupsListData, V1GroupsListErrors, V1GroupsListMembersData, V1GroupsListMembersErrors, V1GroupsListMembersResponses, V1GroupsListResponses, V1GroupsRemoveMemberData, V1GroupsRemoveMemberErrors, V1GroupsRemoveMemberResponses, V1GroupsUpdateData, V1GroupsUpdateErrors, V1GroupsUpdateResponses, V1LinksBulkRevokeLinksData, V1LinksBulkRevokeLinksErrors, V1LinksBulkRevokeLinksResponses, V1LinksCreateLinkData, V1LinksCreateLinkErrors, V1LinksCreateLinkResponses, V1LinksGetNodeLinksData, V1LinksGetNodeLinksErrors, V1LinksGetNodeLinksResponses, V1LinksListActiveLinksData, V1LinksListActiveLinksErrors, V1LinksListActiveLinksResponses, V1LinksListMyLinksData, V1LinksListMyLinksErrors, V1LinksListMyLinksResponses, V1LinksRevokeLinkData, V1LinksRevokeLinkErrors, V1LinksRevokeLinkResponses, V1LinksUpdateLinkData, V1LinksUpdateLinkErrors, V1LinksUpdateLinkResponses, V1NotificationsConnectionTokenData, V1NotificationsConnectionTokenErrors, V1NotificationsConnectionTokenResponses, V1NotificationsDirectoryConnectionTokenData, V1NotificationsDirectoryConnectionTokenErrors, V1NotificationsDirectoryConnectionTokenResponses, V1NotificationsGetBadgeCountData, V1NotificationsGetBadgeCountErrors, V1NotificationsGetBadgeCountResponses, V1NotificationsListNotificationsData, V1NotificationsListNotificationsErrors, V1NotificationsListNotificationsResponses, V1NotificationsListPreferencesData, V1NotificationsListPreferencesErrors, V1NotificationsListPreferencesResponses, V1NotificationsMarkAsReadData, V1NotificationsMarkAsReadErrors, V1NotificationsMarkAsReadResponses, V1NotificationsUpdatePreferencesData, V1NotificationsUpdatePreferencesErrors, V1NotificationsUpdatePreferencesResponses, V1OrganizationsChangeInvitationEmailData, V1OrganizationsChangeInvitationEmailErrors, V1OrganizationsChangeInvitationEmailResponses, V1OrganizationsChangeRoleData, V1OrganizationsChangeRoleErrors, V1OrganizationsChangeRoleResponses, V1OrganizationsDeactivatePersonData, V1OrganizationsDeactivatePersonErrors, V1OrganizationsDeactivatePersonResponses, V1OrganizationsGetAssetData, V1OrganizationsGetAssetErrors, V1OrganizationsGetAssetResponses, V1OrganizationsGetQuotaData, V1OrganizationsGetQuotaErrors, V1OrganizationsGetQuotaResponses, V1OrganizationsInvitePersonData, V1OrganizationsInvitePersonErrors, V1OrganizationsInvitePersonResponses, V1OrganizationsListOrganizationSessionsData, V1OrganizationsListOrganizationSessionsErrors, V1OrganizationsListOrganizationSessionsResponses, V1OrganizationsListPeopleData, V1OrganizationsListPeopleErrors, V1OrganizationsListPeopleResponses, V1OrganizationsRemovePersonData, V1OrganizationsRemovePersonErrors, V1OrganizationsRemovePersonResponses, V1OrganizationsResendInvitationData, V1OrganizationsResendInvitationErrors, V1OrganizationsResendInvitationResponses, V1OrganizationsRevokeInvitationData, V1OrganizationsRevokeInvitationErrors, V1OrganizationsRevokeInvitationResponses, V1OrganizationsSetPersonQuotaData, V1OrganizationsSetPersonQuotaErrors, V1OrganizationsSetPersonQuotaResponses, V1PoliciesListPoliciesData, V1PoliciesListPoliciesErrors, V1PoliciesListPoliciesResponses, V1PoliciesSetPolicyData, V1PoliciesSetPolicyErrors, V1PoliciesSetPolicyResponses, V1PublicLinksAbandonUploadData, V1PublicLinksAbandonUploadErrors, V1PublicLinksAbandonUploadResponses, V1PublicLinksCompleteUploadData, V1PublicLinksCompleteUploadErrors, V1PublicLinksCompleteUploadResponses, V1PublicLinksConfirmPartData, V1PublicLinksConfirmPartErrors, V1PublicLinksConfirmPartResponses, V1PublicLinksGetFileUrlData, V1PublicLinksGetFileUrlErrors, V1PublicLinksGetFileUrlResponses, V1PublicLinksGetLinkData, V1PublicLinksGetLinkErrors, V1PublicLinksGetLinkResponses, V1PublicLinksGetThumbnailsData, V1PublicLinksGetThumbnailsErrors, V1PublicLinksGetThumbnailsResponses, V1PublicLinksIssuePartUrlsData, V1PublicLinksIssuePartUrlsErrors, V1PublicLinksIssuePartUrlsResponses, V1PublicLinksListFolderData, V1PublicLinksListFolderErrors, V1PublicLinksListFolderResponses, V1PublicLinksOpenUploadData, V1PublicLinksOpenUploadErrors, V1PublicLinksOpenUploadResponses, V1PublicLinksUnlockData, V1PublicLinksUnlockErrors, V1PublicLinksUnlockResponses, V1PushDevicesDeleteData, V1PushDevicesDeleteErrors, V1PushDevicesRegisterData, V1PushDevicesRegisterErrors, V1PushDevicesRegisterResponses, V1ShareNotificationsCreateData, V1ShareNotificationsCreateErrors, V1ShareNotificationsCreateResponses, V1UsersGetMeData, V1UsersGetMeErrors, V1UsersGetMePreferencesData, V1UsersGetMePreferencesErrors, V1UsersGetMePreferencesResponses, V1UsersGetMeResponses, V1UsersGetMeSecurityData, V1UsersGetMeSecurityErrors, V1UsersGetMeSecurityResponses, V1UsersGetMeStorageData, V1UsersGetMeStorageErrors, V1UsersGetMeStorageResponses, V1UsersSearchUsersData, V1UsersSearchUsersErrors, V1UsersSearchUsersResponses, V1UsersUpdateMeData, V1UsersUpdateMeErrors, V1UsersUpdateMePreferencesData, V1UsersUpdateMePreferencesErrors, V1UsersUpdateMePreferencesResponses, V1UsersUpdateMeResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Schema
 *
 * Returns the OpenAPI JSON schema
 */
export const docsSchema = <ThrowOnError extends boolean = true>(options?: Options<DocsSchemaData, ThrowOnError>) => (options?.client ?? client).get<unknown, DocsSchemaErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/docs/schema',
    ...options
});

/**
 * Status
 *
 * Returns the instance's limits and a computed `status` telling the client whether it can carry on (`ok`), must update (`force_update`), or is held by maintenance (`maintenance`).
 *
 * Public, no authentication required.
 *
 * `status` is computed for a native app, from its `X-DS3-Client` header; without one it is `ok`, because neither rule ever refuses the web. The `maintenance` details are present whenever maintenance is on. `GET /app-config/clients` is the full version policy, for all four platforms.
 *
 * It also carries the per-instance limits a client applies before it calls anything else: the two `naming` length rules, and the `presignedUrls` durations saying how long an authorization to transfer file bytes stays usable. Read those from here rather than hardcoding them, an operator changes them without a client release.
 */
export const v1AppConfigGetStatus = <ThrowOnError extends boolean = true>(options?: Options<V1AppConfigGetStatusData, ThrowOnError>) => (options?.client ?? client).get<V1AppConfigGetStatusResponses, V1AppConfigGetStatusErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/app-config/status',
    ...options
});

/**
 * Clients
 *
 * The minimum and the latest version of each native app, by platform, and whether maintenance is on.
 *
 * Public, no session required: a native app reads it at start and whenever a request answers `426` or `503`, signed in or not.
 *
 * It is the one request a native app may make during maintenance. Every other one answers `503 maintenance` with `Retry-After`; the web is never refused. Below its platform's `minimumVersion` an app's writes answer `426 client_upgrade_required` and its reads still answer. A change the operator makes is served here at once, and enforced by every server within ten seconds.
 */
export const v1AppConfigGetClients = <ThrowOnError extends boolean = true>(options?: Options<V1AppConfigGetClientsData, ThrowOnError>) => (options?.client ?? client).get<V1AppConfigGetClientsResponses, V1AppConfigGetClientsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/app-config/clients',
    ...options
});

/**
 * Login Branding
 *
 * Returns the instance's login-branding content — the one call the Keycloak login theme makes.
 *
 * Public, no authentication required. It answers the same for every realm and says nothing about which organizations exist. The content is always present, even when nothing is configured (`version` is then `unpublished`, and so it is when `branding.json` is missing or invalid and there is no earlier valid version to fall back to).
 *
 * It is read from the instance bucket through a Redis cache: an edit reaches this response within `branding.cache.ttlSeconds` (60 by default), and an invalid edit never does — the last valid content is served instead. Each image's `url` is the image route with `v=<ETag of the file>`, so a changed file is a changed URL.
 *
 * Carries `Cache-Control: public, max-age=60` (`no-store` when the cache is switched off for testing) and a strong `ETag` over the published version; send `If-None-Match` back to get a `304` with no body.
 */
export const v1AppConfigGetLoginBranding = <ThrowOnError extends boolean = true>(options?: Options<V1AppConfigGetLoginBrandingData, ThrowOnError>) => (options?.client ?? client).get<V1AppConfigGetLoginBrandingResponses, V1AppConfigGetLoginBrandingErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/app-config/login-branding',
    ...options
});

/**
 * Login Branding Images :slot
 *
 * Streams the image file the instance's branding names for a slot — `logo`, `logo-dark`, `mark`, `mark-dark`, `favicon` or `background` or `background-dark` — exactly as it is in the instance bucket, which stays private.
 *
 * Public, no authentication required. The address of a slot never changes, so it is the one to embed where a URL has to last, such as an image in an email; the branding response's image `url`s are the same route with `v=<ETag of the file>`. PNG, JPEG, WebP and SVG only, told by the file's bytes; an SVG is sent with a sandboxing `Content-Security-Policy` so opening it directly cannot run script.
 *
 * `Cache-Control` is `public, max-age=31536000, immutable` when `v` is the file's current ETag and `public, max-age=60` otherwise (`no-store` when the branding cache is switched off for testing). Send `If-None-Match` back to get a `304` with no body.
 *
 * Refused when:
 *
 * - `asset_not_found` (404): nothing is configured, the branding names no image for this slot, the file is gone from the bucket, or it is not a supported image.
 */
export const v1AppConfigGetLoginBrandingImage = <ThrowOnError extends boolean = true>(options: Options<V1AppConfigGetLoginBrandingImageData, ThrowOnError>) => (options.client ?? client).get<V1AppConfigGetLoginBrandingImageResponses, V1AppConfigGetLoginBrandingImageErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/app-config/login-branding/images/{slot}',
    ...options
});

/**
 * Assets
 *
 * Registers a new asset for the file described in `data` and returns where to send its bytes.
 *
 * Authenticated users only; the caller becomes the owner and the asset belongs to the caller's own organization. Accepts the `user_photo` scope, served only to members of that organization once uploaded.
 *
 * The response carries an `upload` instruction describing exactly how to send the file bytes. The asset stays pending until you attach it to a resource, so upload promptly and reference the returned `id`: an asset nothing refers to is eventually discarded.
 *
 * Refused when:
 *
 * - `asset_mime_type_not_allowed`: `mimeType` is not allowed for this `scope`.
 * - `asset_size_too_large`: `sizeInBytes` is over the limit for this `scope`.
 * - `asset_organization_required`: the session carries no organization to own the asset.
 */
export const v1AssetsCreateAssets = <ThrowOnError extends boolean = true>(options: Options<V1AssetsCreateAssetsData, ThrowOnError>) => (options.client ?? client).post<V1AssetsCreateAssetsResponses, V1AssetsCreateAssetsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/assets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * :assetId :variant
 *
 * Streams the bytes of an instance-level asset — a reseller's logo, the platform operator's own avatar — such as those created with `admin_avatar`. No session is required: every instance-level asset is public.
 *
 * Answers `304` with no body when `If-None-Match` names the asset's current `ETag`. Otherwise carries `Content-Type` and `Content-Disposition` derived from the asset record and a `Cache-Control` bounded by this install's configured max age — there is no invalidation, so a replaced or deleted asset can still answer from a cache for up to that long.
 *
 * Refused when:
 *
 * - `asset_not_found` (404): no such asset, it has been permanently removed, or it is an organization-level asset — those are only served through `GET /organizations/{orgId}/assets/{assetId}/{variant}`.
 * - `asset_variant_not_available` (404): the asset exists but this rendition has not been generated yet.
 */
export const v1AssetsGetAsset = <ThrowOnError extends boolean = true>(options: Options<V1AssetsGetAssetData, ThrowOnError>) => (options.client ?? client).get<V1AssetsGetAssetResponses, V1AssetsGetAssetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/assets/{assetId}/{variant}',
    ...options
});

/**
 * Sessions Current
 *
 * Ends a session and clears the session cookie.
 *
 * Public and idempotent. Name the session either by putting its `token` in the body (a `DELETE` that carries JSON) or by relying on the session cookie together with a valid `x-csrf-token` header. With no recognised credentials it is a no-op, and it always answers success.
 *
 * Signing out a guest account deletes it permanently; a full account only has its session ended.
 *
 * Pass `pushToken` to deregister that device's push token in the same call. It is removed only when the credentials verify, and only when it belongs to the user being signed out.
 *
 * This ends the local session and does not reach Keycloak. Call `POST /auth/oidc/logouts` instead when the person presses sign out, so the identity provider session ends too.
 */
export const v1AuthSignOut = <ThrowOnError extends boolean = true>(options: Options<V1AuthSignOutData, ThrowOnError>) => (options.client ?? client).delete<V1AuthSignOutResponses, V1AuthSignOutErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/auth/sessions/current',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sessions Current
 *
 * Returns the caller's current auth context. `sessionType` is `anonymous` when no valid session is present and `authenticated` otherwise, with the `session`, `user`, `organization` and `role` blocks filled in.
 *
 * Public: it works with or without credentials, which makes it the call to make on app start or after a page reload to recover the signed-in state.
 *
 * When authenticated it also returns a fresh `csrfToken` to attach to later mutating requests.
 */
export const v1AuthGetSession = <ThrowOnError extends boolean = true>(options?: Options<V1AuthGetSessionData, ThrowOnError>) => (options?.client ?? client).get<V1AuthGetSessionResponses, V1AuthGetSessionErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/auth/sessions/current',
    ...options
});

/**
 * Tokens
 *
 * Renews the session behind the access token in `token` and answers with a fresh `token`, `csrfToken` and `expiresAt`, so the person stays signed in without authenticating again.
 *
 * Public: the token to renew is read from the body alone, never from the session cookie. Meant for mobile and API clients that hold the token directly; a browser client recovers its state after a reload with `GET /auth/sessions/current` instead.
 *
 * Only remember-me sessions can be renewed: a short-lived session has to be authenticated again once it expires. The `csrfToken` is stable across renewals.
 *
 * Refused when:
 *
 * - `auth_jwt_invalid`: the token does not belong to a renewable session. A revoked session, an expired one, a session that is not remember-me, and an owner who was banned or deleted all answer this same code, so there is nothing to tell apart.
 * - `rate_limited`: too many calls from this caller.
 */
export const v1AuthRefresh = <ThrowOnError extends boolean = true>(options: Options<V1AuthRefreshData, ThrowOnError>) => (options.client ?? client).post<V1AuthRefreshResponses, V1AuthRefreshErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/auth/tokens',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sessions
 *
 * Ends sessions at one of four granularities, chosen with `scope`: a single session, every session of one person except the one making the call, every session of one person, or every session in the organization. `scope=other_sessions` is the "sign out everywhere else" action: it ends the caller's own sessions and leaves the one driving the request alive.
 *
 * Authorization is decided on the server. The organization scope belongs to the platform operator alone, and only an organization administrator can end another person's sessions.
 *
 * Idempotent: ending a session that is already revoked, expired or unknown succeeds with no effect, so callers cannot probe which sessions exist.
 *
 * The response carries how many sessions were closed, the residual window in seconds during which an already-signed download URL can still complete, and whether the person's live connection actually closed.
 *
 * Refused when:
 *
 * - `insufficient_role` (403): the caller can see the scope and is not entitled to it: a tenant session asking for the organization scope, or somebody who is not an administrator asking to end another person's sessions.
 * - `not_found` (404): the session or the person belongs to another organization. Reported as absent rather than as forbidden, on purpose.
 */
export const v1AuthRevokeSessions = <ThrowOnError extends boolean = true>(options: Options<V1AuthRevokeSessionsData, ThrowOnError>) => (options.client ?? client).delete<V1AuthRevokeSessionsResponses, V1AuthRevokeSessionsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/auth/sessions',
    ...options
});

/**
 * Sessions
 *
 * Lists the authenticated user's own sessions, most recent activity first, one page at a time. Each carries its approximate location, its device details and its lifecycle `status`.
 *
 * Authenticated users only, and never another person's sessions.
 *
 * Revoked and expired sessions stay in the list and are told apart by `status`; the session the request was made with is flagged `isCurrent`. Pass `status` (repeat it for several) to keep only sessions in a given lifecycle state.
 *
 * End one with `DELETE /auth/sessions/{sessionId}`.
 */
export const v1AuthListSessions = <ThrowOnError extends boolean = true>(options?: Options<V1AuthListSessionsData, ThrowOnError>) => (options?.client ?? client).get<V1AuthListSessionsResponses, V1AuthListSessionsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/auth/sessions',
    ...options
});

/**
 * Sessions :sessionId
 *
 * Revokes the session named by `sessionId`, signing that device out.
 *
 * Authenticated users only, and only their own sessions, the one driving the request included. Revoking that one signs the caller out at once: every later request fails until they authenticate again.
 *
 * Idempotent and always successful. Revoking a session that does not exist, is not yours, or is already revoked answers success with no effect, so callers cannot probe which sessions exist.
 *
 * List what there is to revoke with `GET /auth/sessions`.
 */
export const v1AuthRevokeSession = <ThrowOnError extends boolean = true>(options: Options<V1AuthRevokeSessionData, ThrowOnError>) => (options.client ?? client).delete<V1AuthRevokeSessionResponses, V1AuthRevokeSessionErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/auth/sessions/{sessionId}',
    ...options
});

/**
 * Email Changes
 *
 * Starts changing the authenticated user's email to `newEmail` by sending a one-time code to that address. When the account already has an email, a second code goes to the current address and both are needed to confirm; `currentEmailVerificationRequired` in the response says whether that happened.
 *
 * Authenticated users only.
 *
 * The codes are single-use and expire shortly after they are sent. Submit them, with `newEmail` and the `emailOtpToken` returned here, to `POST /auth/email-changes/confirmation`. The one `emailOtpToken` covers both codes when two were issued; confirming without it, or with a stale one from an earlier call, is refused there without consuming either code.
 *
 * The answer is the same whether or not `newEmail` already belongs to another account, so a caller cannot learn which addresses are registered. A clash surfaces only at confirmation, once the caller has proven they hold the new mailbox.
 *
 * Refused when:
 *
 * - `new_email_same_as_current` (400): `newEmail` is the address already on the account. This is the only reason this call answers 400.
 * - `auth_credentials_missing` (401): no session.
 * - `otp_issuance_throttled` (429): a code was issued less than a minute ago for the current or the new address. The wait is in `details.retryAfterSeconds`.
 */
export const v1AuthRequestEmailChange = <ThrowOnError extends boolean = true>(options: Options<V1AuthRequestEmailChangeData, ThrowOnError>) => (options.client ?? client).post<V1AuthRequestEmailChangeResponses, V1AuthRequestEmailChangeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/auth/email-changes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Email Changes Confirmation
 *
 * Completes the change started by `POST /auth/email-changes`: the account switches to `newEmail`, which becomes the address the person signs in with, and the address is marked verified.
 *
 * Authenticated users only.
 *
 * Send `newOtp`, the code sent to `newEmail`, and, when the account already had an email, `currentOtp` as well: both must match. Send `emailOtpToken` too, the signed token the request call returned, which binds the codes to that one request. An account with no email yet confirms with `newOtp` alone and `currentOtp` is ignored; when that account was a guest, binding an email promotes it to a regular account and it is a guest no longer.
 *
 * No new session is issued.
 *
 * Refused when:
 *
 * - `email_change_token_invalid` (400): a code is wrong, expired, already used, missing, or does not match its counterpart. Nothing is applied.
 * - `email_otp_token_invalid` (401): `emailOtpToken` is missing, expired, or belongs to another request. Neither code is consumed, so a retry with the right companion still works.
 * - `auth_credentials_missing` (401): no session.
 * - `email_already_in_use` (409): another account holds the address, here or on the identity provider.
 * - `rate_limited` (429): too many calls from this caller.
 * - `identity_provider_unavailable` (503): the identity provider did not answer. The address here is unchanged and the codes are spent: start again from `POST /auth/email-changes`.
 */
export const v1AuthConfirmEmailChange = <ThrowOnError extends boolean = true>(options: Options<V1AuthConfirmEmailChangeData, ThrowOnError>) => (options.client ?? client).post<V1AuthConfirmEmailChangeResponses, V1AuthConfirmEmailChangeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/auth/email-changes/confirmation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Me
 *
 * Permanently deletes the authenticated user's own account, resolved from the session. Irreversible from the person's point of view.
 *
 * Authenticated users only.
 *
 * An account with no verified email (anonymous accounts, social sign-ups carrying no address, addresses never confirmed) is deleted straight away and the answer is `status: success`.
 *
 * An account with a verified email takes two calls. The first, without `token`, emails a one-time code to that address and answers `status: requires_otp` with an `emailOtpToken`; make the same call again with the code as `token` and that `emailOtpToken` echoed back to finish.
 *
 * On `success` every session on the account ends, the session cookie is cleared, and the email address is released so it can register a brand-new account later.
 *
 * Refused when:
 *
 * - `invalid_delete_account_otp` (400): the code is wrong or expired.
 * - `email_otp_token_invalid` (401): `emailOtpToken` is missing or stale. The code is not burned, so a legitimate retry with the right companion still succeeds.
 * - `auth_credentials_missing` (401): no session.
 * - `otp_issuance_throttled` (429): this user asked for a deletion code less than a minute ago. The wait is in `details.retryAfterSeconds`.
 */
export const v1AuthDeleteUser = <ThrowOnError extends boolean = true>(options: Options<V1AuthDeleteUserData, ThrowOnError>) => (options.client ?? client).delete<V1AuthDeleteUserResponses, V1AuthDeleteUserErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/auth/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Oidc Authorizations
 *
 * Starts a Keycloak sign-in for the organization named by `slug` and returns the authorization URL. The caller navigates the browser there; Keycloak sends it back to `GET /auth/oidc-callback`, which finishes the sign-in.
 *
 * Public: this is how a visitor with no session begins.
 *
 * Refused when:
 *
 * - `organization_login_unavailable`: the same answer whether the slug belongs to no organization or to one that cannot be signed into yet, so it cannot be used to find out which organizations exist.
 * - `rate_limited`: too many attempts from this caller.
 */
export const v1AuthStartOidcLogin = <ThrowOnError extends boolean = true>(options: Options<V1AuthStartOidcLoginData, ThrowOnError>) => (options.client ?? client).post<V1AuthStartOidcLoginResponses, V1AuthStartOidcLoginErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/auth/oidc/authorizations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Oidc Native Authorizations
 *
 * Starts a native app's Keycloak sign-in for the organization named by `slug` and returns the `startUrl` to open in the system's browser sheet. The sheet ends on the app's return URL with a one-time `code`, or with `error` and `requestId`.
 *
 * Public: this is how an app with no session begins. The web's twin is `POST /auth/oidc/authorizations`.
 *
 * Refused when:
 *
 * - `organization_login_unavailable` (404): the same answer whether the slug belongs to no organization or to one that cannot be signed into yet, so it cannot be used to find out which organizations exist.
 * - `rate_limited` (429): too many attempts from this caller.
 */
export const v1AuthOidcNativeAuthorizations = <ThrowOnError extends boolean = true>(options: Options<V1AuthOidcNativeAuthorizationsData, ThrowOnError>) => (options.client ?? client).post<V1AuthOidcNativeAuthorizationsResponses, V1AuthOidcNativeAuthorizationsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/auth/oidc/native-authorizations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Oidc Native Authorizations :startId
 *
 * Opens a native sign-in started with `POST /auth/oidc/native-authorizations`: the system's browser sheet navigates here and is redirected (302) to the organization's sign-in page, with a cookie that ties the attempt to that sheet.
 *
 * No client calls this with a request of its own; the app opens the `startUrl` it was given in an ephemeral browser sheet.
 *
 * A start works once and for ten minutes. An unknown, expired or already opened one redirects to the app's return URL with `error=oidc_callback_state_invalid` and `requestId`.
 *
 * Refused with a JSON body only when the caller never reaches this handler: `rate_limited` (429), too many attempts from this caller.
 */
export const v1AuthOidcNativeAuthorizationsOpen = <ThrowOnError extends boolean = true>(options: Options<V1AuthOidcNativeAuthorizationsOpenData, ThrowOnError>) => (options.client ?? client).get<unknown, V1AuthOidcNativeAuthorizationsOpenErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/auth/oidc/native-authorizations/{startId}',
    ...options
});

/**
 * Native Sessions
 *
 * Redeems the one-time `code` a native app's sign-in ended with, and opens the app's session: an access token for every call and a refresh token to renew it.
 *
 * Public: the code is the credential. The request carries a `DPoP` header, a proof signed with the device key the app keeps (RFC 9449, ES256, the public key in the header), made for `POST` on this address. The session is bound to that key from here on.
 *
 * The code works once and for sixty seconds. If the answer is lost, send the same request again with a fresh proof from the same key within that minute: it answers with the same session.
 *
 * Refused when:
 *
 * - `oidc_native_code_invalid` (401): the code is unknown, expired or redeemed by another device, the verifier is not the one its challenge was made from, or the proof is missing or does not hold. One answer for all of them; start the sign-in again.
 * - `user_deleted` (401), `user_banned` (403): this person may not sign in.
 * - `organization_suspended` (403): the organization was deactivated while the sign-in was under way.
 * - `rate_limited` (429): this code was presented too many times.
 */
export const v1AuthNativeSessions = <ThrowOnError extends boolean = true>(options: Options<V1AuthNativeSessionsData, ThrowOnError>) => (options.client ?? client).post<V1AuthNativeSessionsResponses, V1AuthNativeSessionsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/auth/native-sessions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Native Sessions Renewals
 *
 * Renews a native app's session: a new access token, and the refresh token to present next time.
 *
 * Public: the refresh token is the credential. The request carries a `DPoP` header, a proof signed with the device key the session was opened with, made for `POST` on this address. The refresh token renews nothing without it.
 *
 * Each renewal replaces the refresh token. Presenting the one just replaced, until its successor has been used, answers the same successor again, minutes or hours later: a lost answer or two renewals sent together never sign the person out. Presenting it after the successor was used ends the session.
 *
 * Refused when:
 *
 * - `native_session_invalid` (401): the refresh token is not valid, the proof is missing or does not hold, the session was revoked or went unused too long, or a replaced token came back after its successor was used. Sign in again.
 * - `user_deleted` (401), `user_banned` (403): this person may no longer use the product.
 * - `organization_suspended` (403): the organization was deactivated.
 * - `rate_limited` (429): this session renewed too many times in a minute. Keep the tokens and try again later.
 */
export const v1AuthNativeSessionsRenewals = <ThrowOnError extends boolean = true>(options: Options<V1AuthNativeSessionsRenewalsData, ThrowOnError>) => (options.client ?? client).post<V1AuthNativeSessionsRenewalsResponses, V1AuthNativeSessionsRenewalsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/auth/native-sessions/renewals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Native Sessions Current
 *
 * Signs a native app out: ends the session the refresh token belongs to.
 *
 * Public and idempotent, and it works when the access token has already expired, which is when an app most often needs it. The refresh token is the credential, together with a `DPoP` header: a proof signed with the device key the session was opened with, made for `DELETE` on this address. Without the key nothing is ended.
 *
 * It always answers success, whether or not a session was ended: a token that does not read, a proof that does not hold, a session that is already over and a token older than the last two all end nothing and say nothing. Forget the tokens either way.
 *
 * This is the native app's sign out; `DELETE /auth/sessions/current` stays the web's. `rate_limited` (429) means this session asked too many times in a minute; try again later.
 */
export const v1AuthNativeSessionsCurrent = <ThrowOnError extends boolean = true>(options: Options<V1AuthNativeSessionsCurrentData, ThrowOnError>) => (options.client ?? client).delete<V1AuthNativeSessionsCurrentResponses, V1AuthNativeSessionsCurrentErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/auth/native-sessions/current',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Oidc Callback
 *
 * Finishes an OIDC sign-in: Keycloak redirects the browser here once the person has authenticated.
 *
 * No client ever calls this. It is the `redirectUri` registered in each organization's Keycloak client, so the path is fixed from outside and cannot be renamed. It appears in this list because it is part of the contract, not because there is something to call: the call a client makes is `POST /auth/oidc/authorizations`.
 *
 * On success it issues the session cookie and redirects the browser back to the path the sign-in started from. On any failure it redirects (302) to the client's login page instead of answering with a JSON body — nothing is reading the response of a top-level browser navigation — carrying `error` (one of the codes below) and `requestId` in the query string, so a half-finished sign-in is never mistaken for a session and the failure can still be shown and looked up.
 *
 * If a valid session for a different person or organization is already present when this completes, that session is revoked and the new sign-in wins.
 *
 * `error` is one of:
 *
 * - `oidc_callback_state_invalid`: the attempt expired, was already completed, or was started in one browser tab and finished in another. Start again from `POST /auth/oidc/authorizations`.
 * - `oidc_callback_exchange_failed`: the exchange with Keycloak did not complete.
 * - `organization_suspended`: the organization was deactivated while the sign-in was under way. No session is issued.
 *
 * An account action started with `POST /auth/oidc/account-actions` ends here too, and differently: no session is issued, and the browser is sent to the profile page with `action` and `status` (`success`, `cancelled` or `error`) in the query string. It is `error` when Keycloak sent back a different person than the one who started it, or that person's session has ended since. One started from a native app with `POST /auth/oidc/native-account-actions` ends on the app's return URL instead, with the same `action` and `status`.
 *
 * A native app's sign-in, started with `POST /auth/oidc/native-authorizations`, ends here too and issues no session: the browser is sent to the app's return URL with a one-time `code` for the app to redeem, and any failure goes to that same URL with `error` and `requestId`, never to the web's login page.
 *
 * Refused with a JSON body only when the caller never reaches this handler: `rate_limited` (429), too many attempts from this caller.
 */
export const v1AuthOidcCallback = <ThrowOnError extends boolean = true>(options?: Options<V1AuthOidcCallbackData, ThrowOnError>) => (options?.client ?? client).get<unknown, V1AuthOidcCallbackErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/auth/oidc-callback',
    ...options
});

/**
 * Oidc Logouts
 *
 * Ends the current session and, when it was opened through OIDC, ends the Keycloak session too. The propagation happens server-side, so there is nothing further for the client to navigate to.
 *
 * Authenticated users only.
 *
 * This is the sign-out to call when the person presses sign out. `DELETE /auth/sessions/current` ends only the local session and does not reach Keycloak.
 */
export const v1AuthOidcLogout = <ThrowOnError extends boolean = true>(options?: Options<V1AuthOidcLogoutData, ThrowOnError>) => (options?.client ?? client).post<V1AuthOidcLogoutResponses, V1AuthOidcLogoutErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/auth/oidc/logouts',
    ...options
});

/**
 * Invitations Validation
 *
 * Checks an invitation code and returns what the activation page needs to render: the organization, the address the invitation was sent to, the role it confers, when it lapses, and the password rules the chosen password will have to satisfy.
 *
 * Public: the person holding the link has no session yet. Attempts are limited per caller, and the code travels in the body rather than in the URL so it stays out of access logs.
 *
 * Follow with `POST /auth/invitations/activation` once the person has chosen a password.
 *
 * The five invitation refusals all answer 404 and all mean the same thing to a stranger probing codes, that the link is not usable. The `code` is what the page branches on to say which.
 *
 * Refused when:
 *
 * - `invite_code_invalid`: no such code.
 * - `invite_expired`: the invitation lapsed. Only whoever sent it can issue a new one.
 * - `invite_already_used`: the invitation was already activated.
 * - `invite_organization_not_ready`: the organization is not ready yet. Trying again shortly works.
 * - `invite_organization_suspended`: the organization is suspended.
 * - `rate_limited` (429): too many attempts from this caller.
 */
export const v1AuthValidateInvite = <ThrowOnError extends boolean = true>(options: Options<V1AuthValidateInviteData, ThrowOnError>) => (options.client ?? client).post<V1AuthValidateInviteResponses, V1AuthValidateInviteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/auth/invitations/validation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Invitations Activation
 *
 * Sets the password an invited person chose and signs them in.
 *
 * Public: the person has no session yet. Attempts are limited per caller.
 *
 * The names given here become the person's display name from their first sign-in onwards, in place of anything the invitation carried. The password is checked by the organization's own identity realm rather than by this server, against the policy `POST /auth/invitations/validation` returned.
 *
 * When the identity provider accepts the password on its own, this call signs the person in, accepts the invitation and sets the session cookie, and `signedIn` is true. Otherwise `signedIn` is false, the invitation is not consumed yet, and it is consumed when the sign-in on the organization's page completes, so an abandoned sign-in leaves the link usable.
 *
 * Refused when:
 *
 * - `invite_code_invalid`, `invite_expired`, `invite_already_used`, `invite_organization_not_ready`, `invite_organization_suspended` (404), the code is re-checked first and refused exactly as `POST /auth/invitations/validation` refuses it, so a link revoked in the meantime is refused here too.
 * - `invite_password_rejected` (422): the password breaks the organization's password policy.
 * - `rate_limited` (429): too many attempts from this caller.
 * - `invite_activation_failed` (503): the identity provider gave no usable answer. Nothing the person typed is wrong and the invitation is not spent, so resubmitting the same form completes it.
 */
export const v1AuthActivateInvite = <ThrowOnError extends boolean = true>(options: Options<V1AuthActivateInviteData, ThrowOnError>) => (options.client ?? client).post<V1AuthActivateInviteResponses, V1AuthActivateInviteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/auth/invitations/activation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Oidc Account Actions
 *
 * Starts a change to the signed-in person's own credentials on the organization's sign-in pages and returns the URL to send the browser to. The password and the authenticator's secret are typed there and never pass through this API.
 *
 * Signed-in users only, on their own account.
 *
 * The browser comes back to the profile page with `action` and `status` (`success`, `cancelled` or `error`) in the query string; the session is the same one, and no new sign-in happens. The sign-in pages may ask for the password again first.
 *
 * A successful `update-password` signs the person out on every other device, browsers and apps alike, and keeps this session.
 *
 * Refused when:
 *
 * - `otp_device_not_found` (404): `deviceId` is not one of the caller's authenticators, including when they have none.
 * - `identity_provider_unavailable` (503): the identity provider did not answer. Nothing was started; try again.
 * - `rate_limited` (429): too many attempts from this caller.
 */
export const v1AuthStartAccountAction = <ThrowOnError extends boolean = true>(options: Options<V1AuthStartAccountActionData, ThrowOnError>) => (options.client ?? client).post<V1AuthStartAccountActionResponses, V1AuthStartAccountActionErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/auth/oidc/account-actions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Oidc Native Account Actions
 *
 * Starts a change to the signed-in person's own credentials from a native app, on the organization's sign-in pages drawn for the app's `platform`, and returns the `startUrl` to open in the system's browser sheet. The password and the authenticator's secret are typed there and never pass through this API.
 *
 * Signed-in users only, on their own account, with the app's access token. The web's twin is `POST /auth/oidc/account-actions`.
 *
 * The sheet ends on the app's return URL with `action` and `status` (`success`, `cancelled` or `error`); the session is the same one. A successful `update-password` signs the person out on every other device, web and apps, and keeps this session.
 *
 * Refused when:
 *
 * - `native_session_invalid` (401): the access token is not a native app's session. A browser's session changes its credentials with `POST /auth/oidc/account-actions`.
 * - `otp_device_not_found` (404): `deviceId` is not one of the caller's authenticators, including when they have none.
 * - `identity_provider_unavailable` (503): the identity provider did not answer. Nothing was started; try again.
 * - `rate_limited` (429): too many attempts from this caller.
 */
export const v1AuthOidcNativeAccountActions = <ThrowOnError extends boolean = true>(options: Options<V1AuthOidcNativeAccountActionsData, ThrowOnError>) => (options.client ?? client).post<V1AuthOidcNativeAccountActionsResponses, V1AuthOidcNativeAccountActionsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/auth/oidc/native-account-actions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Events
 *
 * Read your organization's audit trail, newest first: who did what, to what, when, and whether it worked, mixed with the accumulating batch summaries of its transfers — one row per upload, download or preview batch rather than one per file. Requires an organization administrator, and answers only about their own organization — there is no way to ask about another. Each row carries `entry`, `"event"` or `"batch"`, so a client can tell the two apart. Narrow it with the querystring: a date range with `from` and `to`, one person with `personId`, which matches both what they did and what was done to them for an event and a batch's own actor for a batch (this is how the per-person view is built — it is this list, not a second endpoint), kinds of act with `actions` or kinds of batch with `batchKinds`, each repeated once per value, or one thing with `objectType` and `objectId`. Setting `actions`, `objectType` or `objectId` excludes batches from the page unless `batchKinds` is also set, since none of those three name anything a batch carries. `meta.total` counts everything the same filters match — both events and batches, when both are eligible — not just this page. Page with `cursor` from the previous response; changing the filters means starting a new listing, and a cursor older than a day or built by hand is refused with `cursor_invalid` rather than answered — restart from the first page, silently when `details.reason` is `expired`. Rows carry identifiers, names and counts, never the content or location of a file, and an event's `metadata` shows only the keys the catalogue declares for that kind of act. The list is bounded by the organization's retention window: rows older than it have been removed, and the removal is itself in the trail. `meta.retention` says how long that window is and where the range you asked for sits against it — a range wholly older than the window answers 200 with an empty list and `requestedRange: entirely_beyond`, which is what lets the screen say the events are gone rather than that nothing happened.
 */
export const v1AuditListEvents = <ThrowOnError extends boolean = true>(options?: Options<V1AuditListEventsData, ThrowOnError>) => (options?.client ?? client).get<V1AuditListEventsResponses, V1AuditListEventsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/audit/events',
    ...options
});

/**
 * Me Events
 *
 * Read your own activity on files and folders, newest first: your transfer batches, your share acts, the versions you deleted and what you purged, and the share acts that name you as the one shared with, whoever made them. A share to a group you are in is not one of these, and neither is anything that is not about a file — a sign-in, an invitation, an address change.
 *
 * Any member may call it, the administrator included, and it answers only about the caller: there is no parameter that names somebody else.
 *
 * The rows are the ones `GET /audit/events` returns, in the same shape. They name a node by `objectId` and never by its name, and a row somebody else acted in carries no `userAgent`. Pages hold at most fifty rows; page on with `cursor` from `meta.nextCursor`. `meta.retention` is the organization's window, as on the organization's trail.
 *
 * Refused when:
 *
 * - `cursor_invalid` (422): the cursor is older than a day or was built by hand. Restart from the first page, silently when `details.reason` is `expired`.
 */
export const v1AuditListMyEvents = <ThrowOnError extends boolean = true>(options?: Options<V1AuditListMyEventsData, ThrowOnError>) => (options?.client ?? client).get<V1AuditListMyEventsResponses, V1AuditListMyEventsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/audit/me/events',
    ...options
});

/**
 * Me
 *
 * Returns the authenticated user's own profile: display name, primary verified email, avatar image, and whether multi-factor authentication is enabled.
 *
 * Authenticated users only. The account is always resolved from the session, so there is nothing to send.
 *
 * `hasPassword` and `emailStatus` are there so the client can decide whether to offer "set password" or "change password", and whether the person must first add or verify an email before doing either.
 *
 * `personalFolderId` is the root of the person's own files: the entry point a file manager needs before any listing, and the one root `GET /directory/shared-with-me` does not return. Reading it never creates that folder, signing in does.
 *
 * Change the editable fields with `PATCH /users/me`.
 *
 * Refused when:
 *
 * - `user_not_found` (400): the session points at an account that is no longer there.
 */
export const v1UsersGetMe = <ThrowOnError extends boolean = true>(options?: Options<V1UsersGetMeData, ThrowOnError>) => (options?.client ?? client).get<V1UsersGetMeResponses, V1UsersGetMeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/users/me',
    ...options
});

/**
 * Me
 *
 * Updates the authenticated user's own profile and returns the updated record.
 *
 * Authenticated users only; the account is resolved from the session. Only `name` and `image` can be changed, and a field you omit stays as it is. Pass `image` as the id of an asset registered with `POST /assets`, or null to clear the avatar.
 *
 * Refused when:
 *
 * - `user_not_found` (400): the session points at an account that is no longer there.
 * - `asset_ownership_error` (403): the asset belongs to somebody else.
 * - `asset_not_found` (404): no asset with that id.
 * - `asset_storage_missing` (422): the asset was registered but its bytes were never uploaded.
 * - `asset_corrupted` (422): the uploaded bytes do not match the size declared when the asset was registered.
 */
export const v1UsersUpdateMe = <ThrowOnError extends boolean = true>(options: Options<V1UsersUpdateMeData, ThrowOnError>) => (options.client ?? client).patch<V1UsersUpdateMeResponses, V1UsersUpdateMeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/users/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Me Preferences
 *
 * Returns the authenticated user's interface preferences: preferred `language` and `theme`, the tutorials they have finished or skipped (`completedTutorials`), and whether they turned the tutorials off (`tutorialsDismissed`).
 *
 * Authenticated users only; the preferences are resolved from the session.
 *
 * Somebody who has never set them gets the defaults, `en`, `system`, no tutorial done and tutorials on. Change them with `PATCH /users/me/preferences`.
 */
export const v1UsersGetMePreferences = <ThrowOnError extends boolean = true>(options?: Options<V1UsersGetMePreferencesData, ThrowOnError>) => (options?.client ?? client).get<V1UsersGetMePreferencesResponses, V1UsersGetMePreferencesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/users/me/preferences',
    ...options
});

/**
 * Me Preferences
 *
 * Updates the authenticated user's interface preferences and returns the new values.
 *
 * Authenticated users only; the preferences are resolved from the session.
 *
 * `language`, `theme` and `tutorialsDismissed` can be changed, and a field you omit stays as it is. `completedTutorial` records that the person finished or skipped the tutorial of one section.
 */
export const v1UsersUpdateMePreferences = <ThrowOnError extends boolean = true>(options: Options<V1UsersUpdateMePreferencesData, ThrowOnError>) => (options.client ?? client).patch<V1UsersUpdateMePreferencesResponses, V1UsersUpdateMePreferencesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/users/me/preferences',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Me Security
 *
 * Returns what protects the authenticated user's account: when the password was last changed, whether two-step verification is on, the enrolled authenticators and how many recovery codes are left. Never a secret, and never the codes themselves.
 *
 * Authenticated users only, about their own account.
 *
 * Read from the identity provider on every call, separately from `GET /users/me`, so the profile loads when the provider is slow or down. Change any of it with `POST /auth/oidc/account-actions`.
 *
 * Refused when:
 *
 * - `identity_provider_unavailable` (503): the identity provider did not answer. Show the section as unavailable, never as off; retry.
 * - `rate_limited` (429): too many reads from this caller.
 */
export const v1UsersGetMeSecurity = <ThrowOnError extends boolean = true>(options?: Options<V1UsersGetMeSecurityData, ThrowOnError>) => (options?.client ?? client).get<V1UsersGetMeSecurityResponses, V1UsersGetMeSecurityErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/users/me/security',
    ...options
});

/**
 * Me Storage
 *
 * Returns how much space you use and how much more you can upload: your own quota, if your organization's administrators set one, and how much your files take, the bin included.
 *
 * Authenticated users only; the person is resolved from the session.
 *
 * `availableBytes` is what an upload may still declare before it is refused with `storage_quota_exceeded`: the smaller of what is left of your quota and what is left of the organization's, or null when there is no limit at all. Read it again after an upload completes or a file is deleted for good: it moves with every file you create.
 */
export const v1UsersGetMeStorage = <ThrowOnError extends boolean = true>(options?: Options<V1UsersGetMeStorageData, ThrowOnError>) => (options?.client ?? client).get<V1UsersGetMeStorageResponses, V1UsersGetMeStorageErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/users/me/storage',
    ...options
});

/**
 * Users
 *
 * Searches the people directory. Each match carries the person's `id`, display name, avatar, and the `email` that identifies them to other authenticated callers.
 *
 * Authenticated users only.
 *
 * Matches the trimmed `q` (at least one character) as a case-insensitive substring of display name or email. Without `q` the whole directory answers, in the same order and with the same exclusions. The caller themselves, and deleted, banned, anonymous, emailless and not-yet-active (invited but not accepted) people, are never returned either way.
 *
 * Send `ids` instead of `q` to ask who a set of identifiers belongs to — the question a client holding identifiers off a shareable address has, and the one `q` cannot express, since the name is what it is missing. The same exclusions apply, with one exception: asked for by identifier, the caller is returned. The two parameters are refused together.
 *
 * Newest first; page with `cursor` from the previous response's `meta.nextCursor`.
 */
export const v1UsersSearchUsers = <ThrowOnError extends boolean = true>(options?: Options<V1UsersSearchUsersData, ThrowOnError>) => (options?.client ?? client).get<V1UsersSearchUsersResponses, V1UsersSearchUsersErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/users',
    ...options
});

/**
 * Push Devices
 *
 * Deregisters a device's push token, so that device stops receiving pushes.
 *
 * Authenticated users only, and only tokens belonging to the caller are removed.
 *
 * Idempotent: deleting a token that is unknown, or already gone, still succeeds. The token travels in the body rather than in the path, because a path reaches every access log in the chain.
 *
 * Signing out with `DELETE /auth/sessions/current` already deregisters the token you pass it, so this call is not needed there.
 */
export const v1PushDevicesDelete = <ThrowOnError extends boolean = true>(options: Options<V1PushDevicesDeleteData, ThrowOnError>) => (options.client ?? client).delete<unknown, V1PushDevicesDeleteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/push-devices',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Push Devices
 *
 * Registers a device for the authenticated user, so pushes reach it through its platform's push service: Apple's for an iPhone or a Mac, Firebase Cloud Messaging for Android. The app keeps no connection open for them. A Windows app registers nothing here: it reads its notifications from the realtime connection it keeps while it runs (`POST /notifications/connection-tokens`).
 *
 * Authenticated users only.
 *
 * Sending the same `token` again refreshes it and marks it valid, so calling this on every app start, and whenever the system hands the app a new token, is safe. A token registered by another account moves to the caller.
 *
 * Remove a token with `DELETE /push-devices`.
 */
export const v1PushDevicesRegister = <ThrowOnError extends boolean = true>(options: Options<V1PushDevicesRegisterData, ThrowOnError>) => (options.client ?? client).post<V1PushDevicesRegisterResponses, V1PushDevicesRegisterErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/push-devices',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Links
 *
 * Lists the caller's own links, newest first — every one they created, whatever its current state and of both kinds, download and upload, unless `kind` narrows it. `token` is included: this is how "my active links" shows a link again after the page that created it is gone. Search by the name of the linked file or folder with `search`. Filter by one or more `state` values — `state=active&state=policy_blocked` is the links that still exist for someone holding them, what the page opens on. Page with `cursor` from the previous response; a cursor older than a day or built by hand is refused with `cursor_invalid`.
 */
export const v1LinksListMyLinks = <ThrowOnError extends boolean = true>(options?: Options<V1LinksListMyLinksData, ThrowOnError>) => (options?.client ?? client).get<V1LinksListMyLinksResponses, V1LinksListMyLinksErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/links',
    ...options
});

/**
 * Links
 *
 * Creates a public link on a file or folder, within the organization's link policy. A `download` link lets whoever holds it view and download what it points to; an `upload` link, on a folder only, lets whoever holds it send files into it without seeing anything there. Requires at least `editor` on the node, directly or inherited from a folder above it.
 *
 * A person holds at most one link of each kind per node. When the caller's previous link of that kind on it has expired, that one is revoked and replaced by this one in the same call.
 *
 * Refused when:
 *
 * - `link_not_allowed` (422): the organization's policy does not allow links at all.
 * - `link_password_required` (422): the organization's policy requires a password and none was given.
 * - `link_expiry_out_of_range` (422): the chosen expiry — or no expiry, sent as `null`, while the organization has a ceiling — falls outside what the policy allows, with the bound in `details.bounds`.
 * - `link_already_exists` (409): the caller already has a link of this kind on this node that has not been revoked or expired — one of each kind per person per node. Read it with `GET /links/nodes/{nodeId}?kind=…`; revoke it first to make a new one.
 * - `parent_not_folder` (422): an `upload` link was asked for on a file.
 * - `validation_error` (422): `description` named on a `download` link.
 * - `insufficient_role` (403): the caller can see the node but holds less than `editor` on it.
 * - `not_found` (404): the node does not exist, or the caller cannot see it.
 */
export const v1LinksCreateLink = <ThrowOnError extends boolean = true>(options: Options<V1LinksCreateLinkData, ThrowOnError>) => (options.client ?? client).post<V1LinksCreateLinkResponses, V1LinksCreateLinkErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/links',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Nodes :nodeId
 *
 * Reads the public links of one kind on one file or folder as the share panel shows them: the caller's own link in full, and other people's as a count and a list of who holds them, never with a token. `kind` picks download links, the default, or upload links. Requires at least `editor` on the node, the same authority creating a link asks for.
 *
 * Answers whatever the organization's link policy says, so an own link the policy has paused comes back as `policy_blocked` rather than disappearing.
 *
 * Refused when:
 *
 * - `insufficient_role` (403): the caller can see the node but holds less than `editor` on it.
 * - `not_found` (404): the node does not exist, or the caller cannot see it.
 */
export const v1LinksGetNodeLinks = <ThrowOnError extends boolean = true>(options: Options<V1LinksGetNodeLinksData, ThrowOnError>) => (options.client ?? client).get<V1LinksGetNodeLinksResponses, V1LinksGetNodeLinksErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/links/nodes/{nodeId}',
    ...options
});

/**
 * :linkId
 *
 * Revokes a link: whoever holds it loses access at once, and the grant a download link carried is removed the same way any other share revocation is (`share.revoked`'s counterpart for links). An upload link stops taking files: none starts and none finishes once this has answered.
 *
 * Callable by the link's own creator, on any of their own links, or by an organization administrator, on any link in the organization — the administrator's authority here is `tenantRole`, not a grant on the node, the same boundary `GET /links/organization` draws. Anyone else gets the same refusal as a link that does not exist.
 *
 * Idempotent. Revoking a link that is already revoked answers success with no further effect. Revoking one that does not exist, or that the caller may not act on, answers `not_found` (404) rather than success, so a caller cannot use this to probe which links exist in the organization.
 */
export const v1LinksRevokeLink = <ThrowOnError extends boolean = true>(options: Options<V1LinksRevokeLinkData, ThrowOnError>) => (options.client ?? client).delete<V1LinksRevokeLinkResponses, V1LinksRevokeLinkErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/links/{linkId}',
    ...options
});

/**
 * :linkId
 *
 * Changes the constraints on one of the caller's own links: when it stops working, its password, the message of an upload link, or several in one call. A field left out is left as it is. Only the link's own creator may change it — not an organization administrator, whose equivalent power is revoking it outright.
 *
 * A new or removed password takes effect for every visitor at once: whoever unlocked the link with the previous one is asked again.
 *
 * Refused when:
 *
 * - `link_expiry_out_of_range` (422): the new expiry falls outside `link.max_expiry_days` from now, with the bound in `details.bounds`.
 * - `validation_error` (422): `description` named for a `download` link.
 * - `link_password_required` (422): `password` is `null` while the organization's policy requires a password on every link.
 * - `insufficient_role` (403): the caller can still see the link's node but no longer holds `editor` on it, which creating the link required. Revoking the link is still theirs.
 * - `not_found` (404): the link does not exist, is not the caller's own, is already revoked, or its node is no longer one the caller can see.
 */
export const v1LinksUpdateLink = <ThrowOnError extends boolean = true>(options: Options<V1LinksUpdateLinkData, ThrowOnError>) => (options.client ?? client).patch<V1LinksUpdateLinkResponses, V1LinksUpdateLinkErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/links/{linkId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Organization
 *
 * Lists every link in the organization, whoever created it — the admin-facing half of public links. Reserved to an organization administrator; acts only on their own organization. `resourceName` names what a link points to; nothing about the resource's content is ever included. Both kinds are listed, download and upload, each row saying which in `kind`. Filter by `creatorId`, one or more `state` values (`state=active&state=policy_blocked` is the links still standing, what the page opens on), `expiresWithinDays`, `hasPassword` or `kind`. Page with `cursor` from the previous response.
 */
export const v1LinksListActiveLinks = <ThrowOnError extends boolean = true>(options?: Options<V1LinksListActiveLinksData, ThrowOnError>) => (options?.client ?? client).get<V1LinksListActiveLinksResponses, V1LinksListActiveLinksErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/links/organization',
    ...options
});

/**
 * Revocations
 *
 * Revokes every active link `creatorId` created in the organization, download and upload links alike — the "shut off everything this person shared" action. Reserved to an organization administrator. Idempotent: a person with no active links answers success with `revokedCount: 0`.
 *
 * Each link is revoked in its own transaction, so one failing partway through does not undo the ones already revoked.
 */
export const v1LinksBulkRevokeLinks = <ThrowOnError extends boolean = true>(options: Options<V1LinksBulkRevokeLinksData, ThrowOnError>) => (options.client ?? client).post<V1LinksBulkRevokeLinksResponses, V1LinksBulkRevokeLinksErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/links/revocations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Notifications
 *
 * Lists the authenticated user's notification-center entries, newest first.
 *
 * Authenticated users only.
 *
 * Filter by `type`, by read `status` (`read` or `unread`), or fetch specific entries with `ids` for a detail view. Each row carries `seenAt` and `readAt`.
 *
 * Page with `cursor` from the previous response; `meta.total` counts the same filter.
 */
export const v1NotificationsListNotifications = <ThrowOnError extends boolean = true>(options?: Options<V1NotificationsListNotificationsData, ThrowOnError>) => (options?.client ?? client).get<V1NotificationsListNotificationsResponses, V1NotificationsListNotificationsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/notifications',
    ...options
});

/**
 * Notifications
 *
 * Updates the read and seen state of the authenticated user's notifications.
 *
 * Authenticated users only. Ids belonging to somebody else are ignored rather than refused.
 *
 * Send `{ ids, read: true }` to mark specific notifications read: they stop being highlighted, and any that had never been seen are marked seen as well, so a notification opened straight from a push also clears the bell badge.
 *
 * Send `{ scope: "all", read: true }` to clear every unread highlight at once, or `{ scope: "all", seen: true }` when the person opens the notification center, which clears the bell badge without touching per-item read state.
 *
 * Idempotent: re-marking never moves a timestamp that is already set.
 *
 * Read the resulting counts back from `GET /notifications/badge-count`.
 */
export const v1NotificationsMarkAsRead = <ThrowOnError extends boolean = true>(options: Options<V1NotificationsMarkAsReadData, ThrowOnError>) => (options.client ?? client).patch<V1NotificationsMarkAsReadResponses, V1NotificationsMarkAsReadErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/notifications',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Badge Count
 *
 * Returns the authenticated user's two notification counts.
 *
 * `unseen` drives the bell badge. It is cleared by `PATCH /notifications` with `{ scope: "all", seen: true }`, and marking specific notifications read marks them seen too, so that lowers it as well.
 *
 * `unread` drives the per-item highlight and is cleared by `PATCH /notifications`.
 */
export const v1NotificationsGetBadgeCount = <ThrowOnError extends boolean = true>(options?: Options<V1NotificationsGetBadgeCountData, ThrowOnError>) => (options?.client ?? client).get<V1NotificationsGetBadgeCountResponses, V1NotificationsGetBadgeCountErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/notifications/badge-count',
    ...options
});

/**
 * Connection Tokens
 *
 * Mints what a client needs to open the realtime notification feed: the socket URL in `wsUrl`, the person's own `channel`, a connection `token` for the socket, and a `subscriptionToken` bound to that one channel.
 *
 * Authenticated users only. The channel is derived from the session, so the call takes no input and there is no way to ask for somebody else's.
 *
 * Open a Centrifugo connection to `wsUrl` with `token`, then subscribe to `channel` with `subscriptionToken`.
 *
 * The connection token is short-lived. Wire your SDK's token callback to this same endpoint and hand back the fresh `token`; a connection whose token is not renewed is closed shortly after it expires, which is the expected ending rather than an error.
 *
 * The file tree has its own separate feed: `POST /notifications/directory-connection-tokens`.
 */
export const v1NotificationsConnectionToken = <ThrowOnError extends boolean = true>(options?: Options<V1NotificationsConnectionTokenData, ThrowOnError>) => (options?.client ?? client).post<V1NotificationsConnectionTokenResponses, V1NotificationsConnectionTokenErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/notifications/connection-tokens',
    ...options
});

/**
 * Directory Connection Tokens
 *
 * Mints what a client needs to open the directory change feed: the socket URL in `wsUrl`, the `channel`, a connection `token` for the socket, a `subscriptionToken` bound to that one channel, and `recoveryWindowSeconds`.
 *
 * Authenticated users only. Both halves of the channel name come from the session, so the call takes no input: a body sent anyway is ignored, and there is no request that returns a channel belonging to another organization.
 *
 * Open a Centrifugo connection to `wsUrl` with `token`, then subscribe to `channel` with `subscriptionToken`. The connection token is short-lived: wire your SDK's token callback to this same endpoint and hand back the fresh `token`.
 *
 * `recoveryWindowSeconds` is how far back the server can replay when a client resubscribes from its last position. Read it rather than hardcoding it, an instance can be configured with a longer one, and branch on the SDK's `recovered` flag: false means the gap was not filled and the tree has to be reloaded.
 *
 * This is not the notification center. It carries changes to the file tree and to sharing, and it does not feed the bell badge.
 */
export const v1NotificationsDirectoryConnectionToken = <ThrowOnError extends boolean = true>(options?: Options<V1NotificationsDirectoryConnectionTokenData, ThrowOnError>) => (options?.client ?? client).post<V1NotificationsDirectoryConnectionTokenResponses, V1NotificationsDirectoryConnectionTokenErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/notifications/directory-connection-tokens',
    ...options
});

/**
 * Preferences
 *
 * Lists the authenticated user's push preferences, one entry per configurable notification type with its `push` flag.
 *
 * Authenticated users only.
 *
 * Always the full resolved set: a type the person has never touched comes back enabled. The in-app feed is always on and has no toggle here.
 *
 * Change them with `PATCH /notifications/preferences`.
 */
export const v1NotificationsListPreferences = <ThrowOnError extends boolean = true>(options?: Options<V1NotificationsListPreferencesData, ThrowOnError>) => (options?.client ?? client).get<V1NotificationsListPreferencesResponses, V1NotificationsListPreferencesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/notifications/preferences',
    ...options
});

/**
 * Preferences
 *
 * Updates the authenticated user's push preferences and returns the full resolved set, identical in shape to `GET /notifications/preferences`.
 *
 * Authenticated users only.
 *
 * Send a partial object keyed by configurable notification type, each with an optional `push` flag; an omitted flag keeps the value it had. The in-app feed is always on and cannot be switched off.
 */
export const v1NotificationsUpdatePreferences = <ThrowOnError extends boolean = true>(options: Options<V1NotificationsUpdatePreferencesData, ThrowOnError>) => (options.client ?? client).patch<V1NotificationsUpdatePreferencesResponses, V1NotificationsUpdatePreferencesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/notifications/preferences',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Current People
 *
 * Lists the people of your organization, newest first: those who are here and those who have been invited and have not arrived, in one list rather than two.
 *
 * Organization administrators only, and always on their own organization: there is no way to ask about another.
 *
 * Each row carries the person's name and address, the role they hold, their `status` (`active`, `invited`, `deactivated` or `removed`), when they were last seen, `isOwner` (disable role, deactivate and remove for that row — those calls refuse on the owner for every caller), and, for somebody still expected, when the invitation was sent and when it stops working.
 *
 * Narrow the page with `status` and search names and addresses with `search`; `meta.total` counts everything the same filters match, not just this page. Page with `cursor` from the previous response. Changing the filters means starting a new listing.
 *
 * Send `ids` instead of `search` to ask for a specific set of identifiers — the question a filter chip built from an address holds and cannot answer by name, since the name is exactly what is missing. Unlike `search`, this reaches a removed or deactivated person too, because a chip naming somebody must still be able to name them after they leave. The two parameters are refused together.
 *
 * Act on a row still waiting with `POST /organizations/current/invitations/{inviteId}/deliveries`, `PATCH /organizations/current/invitations/{inviteId}` or `DELETE /organizations/current/invitations/{inviteId}`.
 *
 * Refused when:
 *
 * - `cursor_invalid`: the cursor is older than a day, was built by hand, or belongs to a different set of filters. Restart from the first page, silently when `details.reason` is `expired`.
 */
export const v1OrganizationsListPeople = <ThrowOnError extends boolean = true>(options?: Options<V1OrganizationsListPeopleData, ThrowOnError>) => (options?.client ?? client).get<V1OrganizationsListPeopleResponses, V1OrganizationsListPeopleErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/organizations/current/people',
    ...options
});

/**
 * Current Sessions
 *
 * Lists the active sessions of your organization, most recently active first, each with where it is used from, when it started, and whether that person's realtime channel is open. One page at a time, with `page` and `limit`.
 *
 * Organization administrators only, and always on their own organization: no field names one. A person without an administrator role lists their own sessions with `GET /auth/sessions` instead.
 *
 * `channel` is `connected`, `disconnected`, or `unknown` when the realtime server could not be reached. `unknown` is not a synonym for disconnected and should not be shown as one.
 *
 * End any of these sessions with `DELETE /auth/sessions`.
 */
export const v1OrganizationsListOrganizationSessions = <ThrowOnError extends boolean = true>(options?: Options<V1OrganizationsListOrganizationSessionsData, ThrowOnError>) => (options?.client ?? client).get<V1OrganizationsListOrganizationSessionsResponses, V1OrganizationsListOrganizationSessionsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/organizations/current/sessions',
    ...options
});

/**
 * Current Invitations
 *
 * Invites somebody into your organization, at a role and in a language you choose. Optionally under a `name` that stands in for them until they arrive.
 *
 * Organization administrators only, and always on their own organization: no field names one.
 *
 * Success means the invitation was accepted for delivery, not that it arrived.
 *
 * Refused when:
 *
 * - `email_already_in_use`: the address already belongs to a member
 * - `already_exists`: an invitation is already waiting. Send that one again with `POST /organizations/current/invitations/{inviteId}/deliveries` rather than calling this. An address whose earlier invitations lapsed or were taken back is invited afresh.
 * - `rate_limited`: the same address was invited under a minute ago. The wait is in `details.retryAfterSeconds`.
 * - `quota_pool_exceeded` (429): the organization's quota cannot cover `quotaBytes`. `details.availableBytes` is the most this person can be given right now. Nothing is written.
 * - `quota_required` (422): `quotaBytes` was `null` and this installation does not allow storage without a limit.
 * - `invite_delivery_not_queued`: the message could not be handed over at all. No invitation is issued, so trying again is safe and immediate.
 */
export const v1OrganizationsInvitePerson = <ThrowOnError extends boolean = true>(options: Options<V1OrganizationsInvitePersonData, ThrowOnError>) => (options.client ?? client).post<V1OrganizationsInvitePersonResponses, V1OrganizationsInvitePersonErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/organizations/current/invitations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Current Invitations :inviteId Deliveries
 *
 * Sends an invitation again, to the same address.
 *
 * Organization administrators only, on an invitation of their own organization.
 *
 * A new code is issued and the previous one stops working at that instant, not when it would have expired and not at the recipient's next attempt, so any earlier message is useless the moment this call succeeds. No second account is ever created: the person is found, not made, however many times this is called. An invitation that has lapsed is the ordinary case and is sent again normally.
 *
 * Success means the invitation was accepted for delivery, not that it arrived. An invitation that was already accepted is not sent again: the answer is `requires_deactivation`, naming the person, because they are active and what ends an active person's access is deactivation.
 *
 * Refused when:
 *
 * - `state_conflict`: the invitation was taken back. Invite the address again instead.
 * - `rate_limited`: the same address was written to under a minute ago. The wait is in `details.retryAfterSeconds`.
 * - `invite_delivery_not_queued`: the message could not even be handed over. Nothing is issued, the previous code still works, and the call can be repeated at once.
 */
export const v1OrganizationsResendInvitation = <ThrowOnError extends boolean = true>(options: Options<V1OrganizationsResendInvitationData, ThrowOnError>) => (options.client ?? client).post<V1OrganizationsResendInvitationResponses, V1OrganizationsResendInvitationErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/organizations/current/invitations/{inviteId}/deliveries',
    ...options
});

/**
 * Current Invitations :inviteId
 *
 * Takes an invitation back: the person it named will not be part of the organization.
 *
 * Organization administrators only, on an invitation of their own organization.
 *
 * It is one act with several consequences and they either all happen or none does: the invitation is closed, the person's account here is removed, their sign-in is disabled, their membership is dropped, and anything shared with them in advance is taken back. The count of those shares comes back as `grantsRemoved`. The record of the invitation and of this removal stays in the organization's audit trail, and the address becomes free to invite again.
 *
 * Revoking one that is already revoked changes nothing and is not an error, unless a resend or a corrected address is what closed it (`state_conflict`, below). An invitation that was already accepted is not revoked here: the answer is `requires_deactivation`, naming the person, because ending an active person's access is deactivation.
 *
 * Refused when:
 *
 * - `last_owner_of_nodes`: the person is the only owner of a shared folder or file, and `details.nodeIds` lists them: a shared node is never left without an owner. This is the one refusal to build a screen around. Nothing at all is changed by it, so give each of those nodes another owner and call again.
 * - `owner_protected`: the invitation makes the person an owner of the organization, and an owner is not removed from inside it. Only the platform operator can take ownership back, after which the invitation can be revoked here. Nothing is changed.
 * - `state_conflict`: a resend or a corrected address replaced this invitation, before this call or at the same moment, and the person still holds the newer one, open. Nothing is changed. Refresh the list and revoke the invitation it shows for that person.
 */
export const v1OrganizationsRevokeInvitation = <ThrowOnError extends boolean = true>(options: Options<V1OrganizationsRevokeInvitationData, ThrowOnError>) => (options.client ?? client).delete<V1OrganizationsRevokeInvitationResponses, V1OrganizationsRevokeInvitationErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/organizations/current/invitations/{inviteId}',
    ...options
});

/**
 * Current Invitations :inviteId
 *
 * Corrects the address a pending invitation was sent to, and sends it again there.
 *
 * Organization administrators only, on an invitation of their own organization. The invited person may never do it themselves, because the address is what identifies them.
 *
 * The address is changed first and the new code issued afterwards, and the code sent to the wrong address stops working as soon as the change is recorded, before the replacement exists: a message sitting in a stranger's inbox is dead even if the second half of the call fails. No second account is created, the same person keeps the same identity with a new address on it, and the change is recorded in the organization's audit trail. The one-a-minute limit is counted against the new address, so correcting a typo is never made to wait.
 *
 * Success means the invitation was accepted for delivery, not that it arrived. An invitation that was already accepted is not changed here: the answer is `requires_deactivation`, and an active person changes their own address.
 *
 * Refused when:
 *
 * - `email_already_in_use`: somebody else in the organization holds that address
 * - `new_email_same_as_current`: it is the address already on file
 */
export const v1OrganizationsChangeInvitationEmail = <ThrowOnError extends boolean = true>(options: Options<V1OrganizationsChangeInvitationEmailData, ThrowOnError>) => (options.client ?? client).patch<V1OrganizationsChangeInvitationEmailResponses, V1OrganizationsChangeInvitationEmailErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/organizations/current/invitations/{inviteId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Current People :userId Status
 *
 * Bars somebody in your organization from signing in, or lets them back in, according to `status`.
 *
 * Organization administrators only, and always on people of their own organization: anybody else is reported as not found.
 *
 * Barring closes every session and live connection they have open, deletes nothing, and keeps their place in the people list reading `deactivated`. The answer carries how many sessions were closed and, in `residualWindowSeconds`, how long a download already under way can still finish.
 *
 * Letting them back in restores nothing but sign-in: their role, the folders and files shared with them and any invitation still outstanding were never touched, and sessions closed by the bar stay closed, so the person signs in afresh. Asking for the state somebody is already in is not an error, and repeating the bar closes anything they have opened since.
 *
 * Refused when:
 *
 * - `state_conflict`: the person is the organization's last administrator (`details.reason` `last_administrator`), or they have been removed from the organization (`person_removed`). Removal is refused in either direction: it is not reversible, and today there is no way back from it.
 * - `owner_protected`: the person is the organization's owner. Refused for every caller, including the owner themself — disable this control on that row rather than let the call fail (see `isOwner` on the people list).
 */
export const v1OrganizationsDeactivatePerson = <ThrowOnError extends boolean = true>(options: Options<V1OrganizationsDeactivatePersonData, ThrowOnError>) => (options.client ?? client).put<V1OrganizationsDeactivatePersonResponses, V1OrganizationsDeactivatePersonErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/organizations/current/people/{userId}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Current People :userId
 *
 * Takes somebody out of your organization: their membership ends, they can no longer sign in, and every session and live connection they have open is closed.
 *
 * Organization administrators only, and always on people of their own organization: anybody else is reported as not found.
 *
 * There is no call that puts a removed person back directly, and if there is any chance they might come back, `PUT /organizations/current/people/{userId}/status` is the reversible act that closes the same things. The way back after this one is `POST /organizations/current/invitations`: inviting the same address again reaches the same person rather than a new one, with their role and membership rebuilt fresh.
 *
 * The record of them stays: the row remains in the people list reading `removed`, and everything they did stays in the organization's history. Folders and files shared with them are **not** taken back. A shared node they are the only owner of would be left with nobody able to manage it, so the removal is refused until each such node has another owner. Repeating the call on somebody already removed is not an error.
 *
 * To take back an invitation nobody has accepted yet, use `DELETE /organizations/current/invitations/{inviteId}` instead.
 *
 * Refused when:
 *
 * - `state_conflict`: the person is the organization's last administrator
 * - `last_owner_of_nodes`: the person is the only owner of shared folders or files, listed in `details.nodeIds`. Nothing was changed: give each of them another owner, then repeat the call.
 * - `owner_protected`: the person is the organization's owner. Refused for every caller, including the owner themself — disable this control on that row rather than let the call fail (see `isOwner` on the people list).
 */
export const v1OrganizationsRemovePerson = <ThrowOnError extends boolean = true>(options: Options<V1OrganizationsRemovePersonData, ThrowOnError>) => (options.client ?? client).delete<V1OrganizationsRemovePersonResponses, V1OrganizationsRemovePersonErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/organizations/current/people/{userId}',
    ...options
});

/**
 * Current People :userId Role
 *
 * Puts somebody in your organization into a different tenant role: `org_admin` or `member`.
 *
 * Organization administrators only, and always on people of their own organization: anybody else is reported as not found.
 *
 * Takes effect on that person's very next request — the role is resolved fresh every time rather than carried in a token, so there is nothing to revoke. No session is closed and no file permission changes: the tenant role and the grants on a node are two separate planes, and this route touches only the first.
 *
 * Asking for the role somebody already holds is not an error and changes nothing; repeating the call answers the same way.
 *
 * Refused when:
 *
 * - `insufficient_role`: `role` is not `org_admin` or `member`
 * - `state_conflict`: the change would leave the organization with nobody able to administer it (`details.reason` `last_administrator`), or the person has been removed from the organization (`person_removed`)
 * - `owner_protected`: the person is the organization's owner. Refused for every caller, including the owner themself — disable this control on that row rather than let the call fail (see `isOwner` on the people list).
 */
export const v1OrganizationsChangeRole = <ThrowOnError extends boolean = true>(options: Options<V1OrganizationsChangeRoleData, ThrowOnError>) => (options.client ?? client).put<V1OrganizationsChangeRoleResponses, V1OrganizationsChangeRoleErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/organizations/current/people/{userId}/role',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Current Quota
 *
 * Reads your organization's storage: the quota the platform operator set (null when there is none), how much of it is assigned to people, and how much the organization stores right now.
 *
 * Organization administrators only, and always on their own organization.
 *
 * What is left to give somebody is `quotaBytes` less `assignedBytes`, plus whatever that person already has. Each person's own quota and use are on `GET /organizations/current/people`; set one with `PUT /organizations/current/people/{userId}/quota`.
 */
export const v1OrganizationsGetQuota = <ThrowOnError extends boolean = true>(options?: Options<V1OrganizationsGetQuotaData, ThrowOnError>) => (options?.client ?? client).get<V1OrganizationsGetQuotaResponses, V1OrganizationsGetQuotaErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/organizations/current/quota',
    ...options
});

/**
 * Current People :userId Quota
 *
 * Sets how much space somebody in your organization may use, or takes their limit away with `quotaBytes: null` when the installation allows it.
 *
 * Organization administrators only, and always on people of their own organization: anybody else is reported as not found.
 *
 * The space comes out of the organization's own quota when it has one: everybody's quotas together may not exceed it, so giving somebody more than what the others leave is refused; lower somebody else's first. Lowering is always allowed, also below what the person already stores: they then cannot upload until they are under it again, so ask before doing that. Read what is left to assign from `GET /organizations/current/quota`.
 *
 * Asking for the quota somebody already has changes nothing and is not an error.
 *
 * Refused when:
 *
 * - `quota_pool_exceeded` (429): the organization's quota cannot cover it. `details.availableBytes` is the most this person can be given right now.
 * - `quota_required` (422): `quotaBytes` was `null` and this installation does not allow storage without a limit.
 * - `state_conflict` (409): the person has been removed from the organization (`details.reason` `person_removed`).
 */
export const v1OrganizationsSetPersonQuota = <ThrowOnError extends boolean = true>(options: Options<V1OrganizationsSetPersonQuotaData, ThrowOnError>) => (options.client ?? client).put<V1OrganizationsSetPersonQuotaResponses, V1OrganizationsSetPersonQuotaErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/organizations/current/people/{userId}/quota',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * :orgId Assets :assetId :variant
 *
 * Streams the bytes of one organization's asset — a member's profile photo, such as those created with `user_photo`.
 *
 * Public-visibility assets need no session. A private one — `user_photo` today — is only served to a caller whose own session belongs to `orgId`; every other caller, signed in or not, is answered the same `404` as an asset that does not exist, so a guess never confirms a real id.
 *
 * Answers `304` with no body when `If-None-Match` names the asset's current `ETag`. Otherwise carries `Content-Type` and `Content-Disposition` derived from the asset record, and a `Cache-Control` that is either bounded by this install's configured max age (public) or `private, no-cache` — there is no invalidation, so a replaced public asset can still answer from a cache for up to that long.
 *
 * Refused when:
 *
 * - `asset_not_found` (404): no such asset in `orgId`, it has been permanently removed, it is an instance-level asset, or it is private and the caller's session is not in `orgId`.
 * - `asset_variant_not_available` (404): the asset exists but this rendition has not been generated yet.
 */
export const v1OrganizationsGetAsset = <ThrowOnError extends boolean = true>(options: Options<V1OrganizationsGetAssetData, ThrowOnError>) => (options.client ?? client).get<V1OrganizationsGetAssetResponses, V1OrganizationsGetAssetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/organizations/{orgId}/assets/{assetId}/{variant}',
    ...options
});

/**
 * Policies
 *
 * List the rules the organization runs by, one entry per setting. Each carries the value in force, the value this instance ships with, and whether the organization has changed it — so the screen can say 'you changed this' rather than leaving an administrator who inherited the organization to guess. Numeric settings also carry the floor and ceiling the instance allows, which are the same bounds `PUT /policies/{key}` refuses outside of. Readable by any signed-in member of the organization — changing a value stays reserved to an organization administrator — and answers only for the caller's own organization: there is no field naming one. Credential rules — passwords, multi-factor, lockout — are not here; they belong to the identity provider.
 */
export const v1PoliciesListPolicies = <ThrowOnError extends boolean = true>(options?: Options<V1PoliciesListPoliciesData, ThrowOnError>) => (options?.client ?? client).get<V1PoliciesListPoliciesResponses, V1PoliciesListPoliciesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/policies',
    ...options
});

/**
 * :key
 *
 * Change one of the organization's rules. Takes effect on the very next request from anyone in the organization — there is no release, no restart, and no interval to wait out. Reserved to an organization administrator, and acts only on their own organization: there is no field naming one. A key this instance does not evaluate is refused (`unknown_policy_key`) rather than stored, and a value outside what the instance allows is refused with the floor and ceiling in `details.bounds` (`policy_value_rejected`) — so a client can correct it without guessing. Instance-wide settings are not reachable here and answer 403. The change is recorded with the value before and after it, so two administrators changing the same rule leave two readable entries rather than one mystery.
 */
export const v1PoliciesSetPolicy = <ThrowOnError extends boolean = true>(options: Options<V1PoliciesSetPolicyData, ThrowOnError>) => (options.client ?? client).put<V1PoliciesSetPolicyResponses, V1PoliciesSetPolicyErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/policies/{key}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Groups
 *
 * Lists the organization's groups the caller can see, by name: every public group, the private ones the caller is in, and all of them for an administrator. Send `q` to search by name, as a share picker does, and `member=true` for only the groups the caller is in (an administrator too).
 *
 * Any member of the organization.
 *
 * Page with `cursor` from the previous response's `meta.nextCursor`.
 *
 * Refused when:
 *
 * - `cursor_invalid` (422): the cursor is older than a day, belongs to another search or filter, or was altered. Restart from the first page.
 */
export const v1GroupsList = <ThrowOnError extends boolean = true>(options?: Options<V1GroupsListData, ThrowOnError>) => (options?.client ?? client).get<V1GroupsListResponses, V1GroupsListErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/groups',
    ...options
});

/**
 * Groups
 *
 * Creates a group in the caller's organization. Add people with `POST /groups/{groupId}/members`; share with it from the sharing panel like with a person.
 *
 * Any member of the organization. An administrator's group starts empty and public unless `visibility` says otherwise. Anyone else creates a private group with themselves as its first member, and manages it while they are in it.
 *
 * Refused when:
 *
 * - `insufficient_role` (403): the caller is not an administrator and asked for a public group.
 * - `already_exists` (409): another group already has this name, in any case. Pick another.
 */
export const v1GroupsCreate = <ThrowOnError extends boolean = true>(options: Options<V1GroupsCreateData, ThrowOnError>) => (options.client ?? client).post<V1GroupsCreateResponses, V1GroupsCreateErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * :groupId
 *
 * Deletes a group and every share made to it. Its members lose what they reached through the group and keep anything they reach another way: a share of their own, another group, the whole organization. `GET /groups/{groupId}` tells whoever may delete it beforehand how many shares this takes away.
 *
 * An administrator, on any group. Anyone else, on a private group they created and are still in.
 *
 * Deleting a group that is already gone, or that the caller cannot see, answers success.
 *
 * Refused when:
 *
 * - `insufficient_role` (403): the caller sees the group and may not delete it.
 */
export const v1GroupsDelete = <ThrowOnError extends boolean = true>(options: Options<V1GroupsDeleteData, ThrowOnError>) => (options.client ?? client).delete<V1GroupsDeleteResponses, V1GroupsDeleteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/groups/{groupId}',
    ...options
});

/**
 * :groupId
 *
 * Reads one group. Whoever may delete it (`canManage`) also gets `shareCount`, how many files and folders are shared with the group, which is what deleting it would take away.
 *
 * Any member of the organization who can see the group: a public group, a private one they are in, or any group for an administrator.
 *
 * Refused when:
 *
 * - `not_found` (404): there is no such group, or it is private and the caller is not in it.
 */
export const v1GroupsGet = <ThrowOnError extends boolean = true>(options: Options<V1GroupsGetData, ThrowOnError>) => (options.client ?? client).get<V1GroupsGetResponses, V1GroupsGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/groups/{groupId}',
    ...options
});

/**
 * :groupId
 *
 * Renames a group or changes who can see it. Its members and what is shared with it stay as they are: making a group private hides it from everyone outside it, it takes nobody's access away.
 *
 * An administrator, on any group. Anyone else, on a private group they created and are still in, and never to make it public.
 *
 * Refused when:
 *
 * - `insufficient_role` (403): the caller sees the group and may not change it, or is not an administrator and asked to make it public.
 * - `not_found` (404): there is no such group, or it is private and the caller is not in it.
 * - `already_exists` (409): another group already has this name, in any case.
 */
export const v1GroupsUpdate = <ThrowOnError extends boolean = true>(options: Options<V1GroupsUpdateData, ThrowOnError>) => (options.client ?? client).patch<V1GroupsUpdateResponses, V1GroupsUpdateErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/groups/{groupId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * :groupId Members
 *
 * Lists who is in a group, most recently added first, with the same fields the people directory returns. Send `q` to search them by name or email.
 *
 * Any member of the organization who can see the group: a public group, a private one they are in, or any group for an administrator.
 *
 * Page with `cursor` from the previous response's `meta.nextCursor`.
 *
 * Refused when:
 *
 * - `not_found` (404): there is no such group, or it is private and the caller is not in it.
 * - `cursor_invalid` (422): the cursor is older than a day, belongs to another group or search, or was altered. Restart from the first page.
 */
export const v1GroupsListMembers = <ThrowOnError extends boolean = true>(options: Options<V1GroupsListMembersData, ThrowOnError>) => (options.client ?? client).get<V1GroupsListMembersResponses, V1GroupsListMembersErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/groups/{groupId}/members',
    ...options
});

/**
 * :groupId Members
 *
 * Adds people to a group. From their next request they reach everything shared with it, at the group's role, alongside whatever they reach already. Adding someone who is already in the group changes nothing, so the call can be retried safely.
 *
 * An administrator, on any group. Anyone else, on a private group they created and are still in. Only active members of the organization can be added: not removed, not deactivated, and past their invitation.
 *
 * Refused when:
 *
 * - `insufficient_role` (403): the caller sees the group and may not change who is in it.
 * - `not_found` (404): there is no such group, it is private and the caller is not in it, or someone in `userIds` is not an active member of the organization. Nobody is added.
 */
export const v1GroupsAddMembers = <ThrowOnError extends boolean = true>(options: Options<V1GroupsAddMembersData, ThrowOnError>) => (options.client ?? client).post<V1GroupsAddMembersResponses, V1GroupsAddMembersErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/groups/{groupId}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * :groupId Candidates
 *
 * Lists the people who can be added to a group, newest first, each with `isMember` saying whether they are already in it. The same people `GET /users` returns, the caller included. Send `q` to search them by name or email.
 *
 * Whoever manages the group: an administrator, or the member who created a private group and is still in it.
 *
 * Page with `cursor` from the previous response's `meta.nextCursor`.
 *
 * Refused when:
 *
 * - `insufficient_role` (403): the caller sees the group and does not manage it.
 * - `not_found` (404): there is no such group, or it is private and the caller is not in it.
 * - `cursor_invalid` (422): the cursor is older than a day, belongs to another group or search, or was altered. Restart from the first page.
 */
export const v1GroupsListCandidates = <ThrowOnError extends boolean = true>(options: Options<V1GroupsListCandidatesData, ThrowOnError>) => (options.client ?? client).get<V1GroupsListCandidatesResponses, V1GroupsListCandidatesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/groups/{groupId}/candidates',
    ...options
});

/**
 * :groupId Members :userId
 *
 * Takes a person out of a group. From their next request they no longer reach what is shared with the group, and keep anything they reach another way. Taking out someone who is not in the group answers success.
 *
 * An administrator, on any group. Anyone else, on a private group they created and are still in. Anyone who sees the group may take themselves out of it; a creator who does leaves the group to the administrators.
 *
 * Refused when:
 *
 * - `insufficient_role` (403): the caller sees the group and may not take someone else out of it.
 * - `not_found` (404): there is no such group, or it is private and the caller is not in it.
 */
export const v1GroupsRemoveMember = <ThrowOnError extends boolean = true>(options: Options<V1GroupsRemoveMemberData, ThrowOnError>) => (options.client ?? client).delete<V1GroupsRemoveMemberResponses, V1GroupsRemoveMemberErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/groups/{groupId}/members/{userId}',
    ...options
});

/**
 * Share Notifications
 *
 * Queues a share-notification email for people who were just given access to a node, one per qualifying recipient.
 *
 * Any signed-in member of your organization may call it, but only for a `nodeId` they hold `editor` or `owner` on, directly, through a folder above it or through a group. Each `userId` is checked again here and skipped without explanation unless they are an active member of the same organization and hold a grant on `nodeId` right now — the answer never says which of the requested ids were skipped or why, so it cannot be used to learn who has access to something. A group in `groupIds` notifies its active members, except the caller, when the group itself holds a grant on `nodeId`.
 *
 * Fire-and-forget: a `200` means the qualifying messages were accepted for delivery, not that they arrived.
 *
 * Refused when:
 *
 * - `not_found` (404): `nodeId` does not exist, or is not visible to the caller.
 * - `insufficient_role` (403): the caller can see `nodeId` but holds less than `editor` on it.
 */
export const v1ShareNotificationsCreate = <ThrowOnError extends boolean = true>(options: Options<V1ShareNotificationsCreateData, ThrowOnError>) => (options.client ?? client).post<V1ShareNotificationsCreateResponses, V1ShareNotificationsCreateErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/share-notifications/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Users
 *
 * Lists the people of one organization (`organizationId`), one page at a time.
 *
 * Administrators with the `users.manage` ability only. Only that organization's users are ever returned.
 *
 * Narrow the page with the filter parameters, each usable on its own:
 *
 * - `ids`: an explicit list, for a known set or for a single user
 * - `search`: free text over name and email, which also matches a full user id pasted in
 * - `status`, `banned`, `emailVerified`, the account's lifecycle state, its ban state, and whether its address is verified
 * - `createdAtFrom` and `createdAtTo`, a creation-date range, with inclusive bounds
 *
 * Order the page with `sortBy` and `sortDirection`, and repeat `ids` and `status` to pass more than one value. Read `meta` for the total count and the total page count, and request successive `page` values to page through the result.
 *
 * Refused when:
 *
 * - `admin_organization_not_found`: nothing holds that `organizationId`. An unknown organization is refused rather than answered with an empty page.
 */
export const v1BackofficeListUsers = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeListUsersData, ThrowOnError>) => (options.client ?? client).get<V1BackofficeListUsersResponses, V1BackofficeListUsersErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/users',
    ...options
});

/**
 * Exports
 *
 * Exports users, using the same filters and sort that `GET /admin/users` supports, sent here as the nested `filters` and `sort` objects rather than as query parameters.
 *
 * Administrators with the `users.manage` ability only.
 *
 * Small exports can be downloaded synchronously and large ones are queued. This dataset spans every organization, so its size is not knowable before it runs and it is always queued, answering `202` whatever `mode` asks for. Follow a queued export with `GET /admin/exports/{id}`.
 *
 * Refused when:
 *
 * - `export_too_large_for_sync`: a forced `sync` download over the row limit, with `details.rowCount` and `details.limit`. Declared for completeness: this dataset is never sized in advance, so it is queued instead.
 */
export const v1BackofficeExportUsers = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeExportUsersData, ThrowOnError>) => (options.client ?? client).post<V1BackofficeExportUsersResponses, V1BackofficeExportUsersErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/exports',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Exports :id
 *
 * Reads how an export queued by `POST /backoffice/exports` is getting on: its `status` (`pending`, `running`, `completed`, `failed` or `expired`), the row count once known, and `errorMessage` when it failed.
 *
 * Administrators only, and always on their own exports: one requested by another administrator is reported as not found.
 *
 * `downloadUrl` is a short-lived link, and it is filled in only while the export is `completed` and has not passed its `expiresAt`. It is null in every other state, and an export that has outlived `expiresAt` reads as `expired` however it ended. Ask again for a fresh link rather than storing the one you were given.
 *
 * Refused when:
 *
 * - `export_not_found`: no export of yours has that id
 */
export const v1BackofficeExportsId = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeExportsIdData, ThrowOnError>) => (options.client ?? client).get<V1BackofficeExportsIdResponses, V1BackofficeExportsIdErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/exports/{id}',
    ...options
});

/**
 * Users :userId Notification Preferences
 *
 * Returns the fully resolved notification preference matrix for the user named in the path: every user-configurable notification type with its push state.
 *
 * Administrators with the `users.manage` ability only.
 *
 * Defaults are already applied, so a channel the user never disabled reads as enabled. The in-app feed is always on and has no toggle.
 *
 * Refused when:
 *
 * - `admin_target_user_not_found`: no user matches the id in the path
 */
export const v1BackofficeGetUserNotificationPreferences = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeGetUserNotificationPreferencesData, ThrowOnError>) => (options.client ?? client).get<V1BackofficeGetUserNotificationPreferencesResponses, V1BackofficeGetUserNotificationPreferencesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/users/{userId}/notification-preferences',
    ...options
});

/**
 * Users :userId Push Registrations
 *
 * Returns push-registration counts for the user named in the path: how many currently valid devices (Apple and Android) they have registered for pushes. Counts only, never the tokens.
 *
 * Administrators with the `users.manage` ability only.
 *
 * Refused when:
 *
 * - `admin_target_user_not_found`: no user matches the id in the path
 */
export const v1BackofficeGetUserPushRegistrations = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeGetUserPushRegistrationsData, ThrowOnError>) => (options.client ?? client).get<V1BackofficeGetUserPushRegistrationsResponses, V1BackofficeGetUserPushRegistrationsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/users/{userId}/push-registrations',
    ...options
});

/**
 * Users :userId Sessions
 *
 * Lists the sessions of the user named in the path, newest first, one page at a time. Active, expired and revoked sessions alike, each with its device, IP, approximate location, creation source, and lifecycle `status`.
 *
 * Administrators with the `users.manage` ability only.
 *
 * Pass `status` to keep only sessions in a given lifecycle state, repeating the parameter for more than one. Read `meta` for the total count and the page count.
 *
 * Refused when:
 *
 * - `admin_target_user_not_found`: no user matches the id in the path
 */
export const v1BackofficeGetUserSessions = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeGetUserSessionsData, ThrowOnError>) => (options.client ?? client).get<V1BackofficeGetUserSessionsResponses, V1BackofficeGetUserSessionsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/users/{userId}/sessions',
    ...options
});

/**
 * Notifications
 *
 * Lists all manually-sent notification broadcasts, newest first, each with its resolved recipient count and how many recipients have seen and opened it. One page at a time, with `page` and `limit`.
 *
 * Administrators with the `notifications.manage` ability only.
 *
 * Drill into a single broadcast's recipients with `GET /admin/notifications/{broadcastId}/recipients`.
 */
export const v1BackofficeListSentNotifications = <ThrowOnError extends boolean = true>(options?: Options<V1BackofficeListSentNotificationsData, ThrowOnError>) => (options?.client ?? client).get<V1BackofficeListSentNotificationsResponses, V1BackofficeListSentNotificationsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/notifications',
    ...options
});

/**
 * Notifications
 *
 * Sends a manual notification of the chosen `type`, a title and a plain-text body, to an explicit list of users or to every active user, optionally over push as well. `type` must be one of the admin-broadcastable types.
 *
 * Administrators with the `notifications.manage` ability only.
 *
 * Delivery is asynchronous: the response returns the broadcast in `pending` or `sending` state, and targeted recipients receive a notification-center entry, and any selected push, shortly after. People who have silenced that type's push channels in their preferences are skipped for push; the center entry is always delivered.
 *
 * Review delivery with `GET /admin/notifications`, and see who received it with `GET /admin/notifications/{broadcastId}/recipients`.
 *
 * Refused when:
 *
 * - `broadcast_recipients_not_found`: `target.userIds` names an id no user holds. Every id must reference an existing user, and one unknown id rejects the whole request.
 */
export const v1BackofficeSendNotification = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeSendNotificationData, ThrowOnError>) => (options.client ?? client).post<V1BackofficeSendNotificationResponses, V1BackofficeSendNotificationErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/notifications',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Notifications :broadcastId Recipients
 *
 * Lists the recipients of the broadcast named in the path, newest first, with each recipient's seen and read state.
 *
 * Administrators with the `notifications.manage` ability only.
 *
 * Page with `cursor` from the previous response. `meta.total` is the broadcast's recorded recipient count, which is filled in once delivery completes: it reads 0 while the broadcast is still `pending` or `sending`, even though the first entries are already listable.
 */
export const v1BackofficeGetNotificationRecipients = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeGetNotificationRecipientsData, ThrowOnError>) => (options.client ?? client).get<V1BackofficeGetNotificationRecipientsResponses, V1BackofficeGetNotificationRecipientsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/notifications/{broadcastId}/recipients',
    ...options
});

/**
 * Organizations
 *
 * Lists the instance's organizations for the operator console, newest first by default.
 *
 * Platform operators only.
 *
 * Narrow the page with `status`, search on the display name with `name`, and order by `sortBy`: when the customer was created, or how much it holds. Page with `cursor` from the previous response; `meta.total` counts everything the same filters match, not just this page. Changing the order or the filters means starting a new listing.
 *
 * Each row carries `usageBytes` with the date it was measured and how many people could sign in today. Open one with `GET /organizations/{id}` for its provisioning detail, which is also the call to poll after creating an organization.
 *
 * Refused when:
 *
 * - `cursor_invalid`: the cursor comes from a different order or different filters, or is older than a day. Restart from the first page, silently when `details.reason` is `expired`.
 */
export const v1BackofficeListOrganizations = <ThrowOnError extends boolean = true>(options?: Options<V1BackofficeListOrganizationsData, ThrowOnError>) => (options?.client ?? client).get<V1BackofficeListOrganizationsResponses, V1BackofficeListOrganizationsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/organizations',
    ...options
});

/**
 * Organizations
 *
 * Creates an organization and starts provisioning it.
 *
 * Platform operators only, and the `idempotency-key` header is mandatory here rather than optional, because a repeated click on a create button is the expected case and not an edge one.
 *
 * Answers `202` as soon as the organization exists, with its `id` and a `status` of `pending`: identity, storage and the first administrator's invitation are prepared afterwards, so poll `GET /organizations/{id}` to follow them. Repeating the call with the same key returns the same organization and the same `202`, never a second one; repeating it with the same key and a different body is refused.
 *
 * Refused when:
 *
 * - `quota_required`: `quotaBytes` was `null` and this installation does not allow storage without a limit.
 * - `organization_slug_taken`: the `slug` is already in use. Check it first with `GET /organizations/slug-availability`, which does not make it reserved.
 */
export const v1BackofficeCreateOrganization = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeCreateOrganizationData, ThrowOnError>) => (options.client ?? client).post<V1BackofficeCreateOrganizationResponses, V1BackofficeCreateOrganizationErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/organizations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Organizations Slug Availability
 *
 * Reports whether `slug` is free, so the creation form can say so while the operator types.
 *
 * Platform operators only.
 *
 * A malformed slug is rejected by validation rather than reported unavailable, so the form can tell "that is not a valid address" from "that address is taken". Availability is a snapshot and not a reservation: `POST /organizations` still refuses a slug taken in between, and is where the guarantee lives.
 */
export const v1BackofficeCheckSlugAvailability = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeCheckSlugAvailabilityData, ThrowOnError>) => (options.client ?? client).get<V1BackofficeCheckSlugAvailabilityResponses, V1BackofficeCheckSlugAvailabilityErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/organizations/slug-availability',
    ...options
});

/**
 * Organizations :id
 *
 * Destroys a deactivated organization's data permanently: its stored files and every past version of them, its directory of files and folders, its people and their accounts, and its sign-in realm.
 *
 * Platform operators only.
 *
 * **Nothing here can be undone and nothing brings the data back**: there is no recycle bin, no grace period and no restore.
 *
 * Work continues in the background: follow `purgedObjectVersions` and `purgedNodes` on `GET /organizations/{id}` and wait for `status` to become `purged`. A destruction that stopped part-way stays in `purging` and is resumed by repeating this call, which continues from where it got to rather than starting over; repeating it on an organization that is already `purged` changes nothing and is not an error.
 *
 * The organization stays in the list afterwards, cannot be reactivated, and keeps its history: the record of what was done to it is not part of what is destroyed.
 *
 * Refused when:
 *
 * - `state_conflict`: the organization has not been deactivated yet with `PUT /organizations/{id}/status`, which is the deliberate step before this one
 */
export const v1BackofficePurgeOrganization = <ThrowOnError extends boolean = true>(options: Options<V1BackofficePurgeOrganizationData, ThrowOnError>) => (options.client ?? client).delete<V1BackofficePurgeOrganizationResponses, V1BackofficePurgeOrganizationErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/organizations/{id}',
    ...options
});

/**
 * Organizations :id
 *
 * Reads one organization, including how far its provisioning got and, when it stopped, which step stopped and why.
 *
 * Platform operators only.
 *
 * This is the endpoint to poll after creating an organization: the creation answers `202` immediately with a `pending` organization, and `status` moves through the ladder from there.
 *
 * It carries the whole record: the `slug`, the provisioning ladder and its failure reason, the usage figure with the date it was measured, the purge counters, and the storage quota with what is assigned of it and what the organization stores right now. That is what makes it the detail read; `GET /organizations` is the browse and answers narrower rows. Returns `404` when there is no such organization.
 */
export const v1BackofficeGetOrganization = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeGetOrganizationData, ThrowOnError>) => (options.client ?? client).get<V1BackofficeGetOrganizationResponses, V1BackofficeGetOrganizationErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/organizations/{id}',
    ...options
});

/**
 * Organizations :id Provisioning Attempts
 *
 * Starts provisioning again for an organization that stopped part-way, from the step that stopped it rather than from the beginning.
 *
 * Platform operators only.
 *
 * Answers `queued` when this call is the one that started it, and `already_in_progress` when provisioning was already running: two operators pressing at the same moment produce one run, and the second is told so rather than refused. An organization that stopped before its first administrator was invited has that address recorded nowhere, and the answer is `requires_admin_email`: send `adminEmail` and `language` and repeat the call.
 *
 * Follow the run with `GET /organizations/{id}`, which also carries `provisioningAttempts`: the same step failing repeatedly with the same reason is a fault that retrying will not clear.
 *
 * Refused when:
 *
 * - `state_conflict`: the organization is already finished, or it has been deactivated, or its data is being destroyed
 */
export const v1BackofficeRetryProvisioning = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeRetryProvisioningData, ThrowOnError>) => (options.client ?? client).post<V1BackofficeRetryProvisioningResponses, V1BackofficeRetryProvisioningErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/organizations/{id}/provisioning-attempts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Organizations :id Status
 *
 * Deactivates an organization or brings it back, according to `status`.
 *
 * Platform operators only.
 *
 * Deactivating blocks every sign-in and closes every open session at once. Nothing is deleted: files, members and history stay exactly where they are, and the organization's people meet `organization_suspended` on the next call they make, which is the code to render the branded support page from. An organization still being created can be deactivated too, and resumes from the same step when it comes back.
 *
 * Bringing one back reopens sign-in immediately and returns the organization to the `status` it held before, but sessions closed by the deactivation are **not** restored: everyone signs in again. Asking for the state an organization is already in changes nothing and is not an error.
 *
 * Refused when:
 *
 * - `state_conflict`: destruction of the organization's data has begun. It refuses in either direction from there.
 */
export const v1BackofficeSuspendOrganization = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeSuspendOrganizationData, ThrowOnError>) => (options.client ?? client).put<V1BackofficeSuspendOrganizationResponses, V1BackofficeSuspendOrganizationErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/organizations/{id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Organizations :id Quota
 *
 * Sets how much the organization may store in all, or takes the limit away with `quotaBytes: null` when the installation allows it.
 *
 * Platform operators only.
 *
 * The organization's administrators assign their people's quotas out of this one. Setting it below what is already assigned or stored is allowed: from then on administrators can only lower assignments, and every upload is refused until the organization is under it again, so ask before doing that, using `quotaAssignedBytes` and `quotaUsedBytes` from the detail read.
 *
 * Asking for the quota the organization already has changes nothing and is not an error. Returns `404` when there is no such organization.
 */
export const v1BackofficeSetOrganizationQuota = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeSetOrganizationQuotaData, ThrowOnError>) => (options.client ?? client).put<V1BackofficeSetOrganizationQuotaResponses, V1BackofficeSetOrganizationQuotaErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/organizations/{id}/quota',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Organizations :id First Admin Invitation
 *
 * Reads what became of an organization's invitation to its first administrator: the state the code is in, the address it was sent to, when the most recent message went out, when it stops working, and how many times it has been sent again.
 *
 * Platform operators only.
 *
 * This is the read to show beside `POST /organizations/{id}/first-admin-invitation/deliveries`, which sends without reporting: an organization that is `ready` with an invitation still `pending` from a week ago is one nobody ever entered, and no one inside it can notice, because the only person who could is the one waiting for the message.
 *
 * `data` is null when the organization has never had such an invitation, which is an ordinary state for one whose provisioning stopped before the invite step. The answer carries no invitation code and no digest of one, and it says nothing about the people of the organization beyond that one invitation. Answers `404` when there is no such organization.
 */
export const v1BackofficeGetFirstAdminInvitation = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeGetFirstAdminInvitationData, ThrowOnError>) => (options.client ?? client).get<V1BackofficeGetFirstAdminInvitationResponses, V1BackofficeGetFirstAdminInvitationErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/organizations/{id}/first-admin-invitation',
    ...options
});

/**
 * Organizations :id First Admin Invitation Deliveries
 *
 * Sends the first administrator's invitation again, for an organization whose invitation never arrived.
 *
 * Platform operators only. It exists for the one case nobody inside the organization can resolve: until that person activates, there is no one there who could sign in and press resend.
 *
 * A new code is issued to the same address and the previous one stops working at that instant; no second account is created, however many times this is called. To correct a mistyped address, the organization's own administrator route is the one that does it: this endpoint only sends the invitation again as it stands. Answers `404` when the organization has no administrator invitation to resend.
 *
 * Success means the invitation was accepted for delivery, not that it arrived. If that administrator has already activated, the answer is `requires_deactivation` and nothing is sent, because they are active and have their own way in.
 *
 * Refused when:
 *
 * - `rate_limited`: the same address was written to under a minute ago. The wait is in `details.retryAfterSeconds`.
 * - `invite_delivery_not_queued`: the message could not be handed over at all, and nothing is issued.
 */
export const v1BackofficeResendFirstAdminInvitation = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeResendFirstAdminInvitationData, ThrowOnError>) => (options.client ?? client).post<V1BackofficeResendFirstAdminInvitationResponses, V1BackofficeResendFirstAdminInvitationErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/organizations/{id}/first-admin-invitation/deliveries',
    ...options
});

/**
 * Organizations :id Owners
 *
 * Invites another owner of an organization.
 *
 * Platform operators only. An owner administers the organization like any other administrator, and additionally cannot be deactivated, removed, or have their role changed by anybody — including the other owners and including themself. That is the only difference, and it is why this is the operator's act rather than the organization's.
 *
 * The first owner is created at provisioning from `adminEmail`; this adds the ones after. Answers `404` for an organization that does not exist or is not running.
 *
 * Refused when:
 *
 * - `already_invited`: that address already has an invitation waiting.
 * - `already_member`: that address belongs to somebody already in the organization. Promoting an existing member to owner is not this route.
 * - `rate_limited`: the same address was written to under a minute ago. The wait is in `details.retryAfterSeconds`.
 * - `invite_delivery_not_queued`: the message could not be handed over at all, and nothing is issued.
 */
export const v1BackofficeInviteOrganizationOwner = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeInviteOrganizationOwnerData, ThrowOnError>) => (options.client ?? client).post<V1BackofficeInviteOrganizationOwnerResponses, V1BackofficeInviteOrganizationOwnerErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/organizations/{id}/owners',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Organizations :id People
 *
 * Lists the people of one organization: its members and the invitations still waiting, in one list, newest first.
 *
 * Platform operators only. Read-only — nothing here deactivates, removes or re-roles one of a customer's people; those are the organization's own administrator's acts. Conferring ownership is the one exception, and it has its own route.
 *
 * Somebody invited and still waiting appears with status `invited`, carrying the date the invitation was sent and the date it stops working. That is the only reading that distinguishes an organization nobody ever reached from one that is simply quiet.
 *
 * Refused when:
 *
 * - `not_found`: no organization holds that id.
 * - `cursor_invalid`: the cursor is older than a day, was built by hand, or belongs to a different set of filters. Restart from the first page, silently when `details.reason` is `expired`.
 */
export const v1BackofficeListOrganizationPeople = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeListOrganizationPeopleData, ThrowOnError>) => (options.client ?? client).get<V1BackofficeListOrganizationPeopleResponses, V1BackofficeListOrganizationPeopleErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/organizations/{id}/people',
    ...options
});

/**
 * Organizations :id Owners :userId
 *
 * Takes ownership away from one of an organization's owners.
 *
 * Platform operators only, and theirs alone: nobody inside the organization can demote an owner, the other owners included and themself included. That is unchanged — this is the party that confers ownership taking it back.
 *
 * **An organization always has at least one owner.** Demoting the last one is refused.
 *
 * Their role is left as it is. An owner is also an `org_admin`, and they stay one: lowering it would be a second act, and on the wrong row it would leave the organization with nobody able to administer it.
 *
 * Naming somebody who is not an owner is not an error and changes nothing.
 *
 * Refused when:
 *
 * - `not_found`: no organization holds that id, or that person is not in it.
 * - `state_conflict`: they are the organization's only owner, or they have been removed from it.
 */
export const v1BackofficeRevokeOrganizationOwnership = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeRevokeOrganizationOwnershipData, ThrowOnError>) => (options.client ?? client).delete<V1BackofficeRevokeOrganizationOwnershipResponses, V1BackofficeRevokeOrganizationOwnershipErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/organizations/{id}/owners/{userId}',
    ...options
});

/**
 * Organizations :id Owners :userId
 *
 * Makes somebody already in an organization one of its owners.
 *
 * Platform operators only. An owner administers the organization like any other administrator, and additionally cannot be deactivated, removed, or have their role changed by anybody — including the other owners and including themself.
 *
 * **Their role moves with it.** An owner is always also an `org_admin`, so promoting a `member` raises their role in the same write; `previousRole` says what they held before.
 *
 * Naming somebody who already owns the organization is not an error and changes nothing: the answer carries `previousRole: null` and no record is written.
 *
 * Reversible by the operator alone, with `DELETE /organizations/{id}/owners/{userId}`, and never below one: an organization always has at least one owner. Nobody inside the organization can demote an owner, which is what the protection is for.
 *
 * Refused when:
 *
 * - `not_found`: no organization holds that id, or that person is not in it.
 * - `state_conflict`: the person has been removed from the organization, or is deactivated. A deactivated owner could never be reactivated by their own administrators, so they are reactivated first and promoted after.
 */
export const v1BackofficeGrantOrganizationOwnership = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeGrantOrganizationOwnershipData, ThrowOnError>) => (options.client ?? client).put<V1BackofficeGrantOrganizationOwnershipResponses, V1BackofficeGrantOrganizationOwnershipErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/organizations/{id}/owners/{userId}',
    ...options
});

/**
 * Organizations :id People :userId
 *
 * Takes one of an organization's owners out of it: their membership ends, they can no longer sign in, and every session and live connection they have open is closed.
 *
 * Platform operators only, and on owners only: nobody inside the organization can remove an owner, and anybody who is not one is the organization's own administrator's to remove.
 *
 * **An organization always keeps at least one owner who has accepted their invitation.** Removing the last one is refused.
 *
 * The record of them stays, reading `removed` in the people list, and so do the folders and files shared with them. Repeating the call on somebody already removed is not an error.
 *
 * Refused when:
 *
 * - `not_found`: no organization holds that id, or that person is not in it.
 * - `state_conflict`: they are not an owner, they have not accepted their invitation yet (take the ownership back with `DELETE /v1/backoffice/organizations/{id}/owners/{userId}` instead), or they are the organization's only owner who has.
 * - `last_owner_of_nodes`: they are the only owner of shared folders or files, listed in `details.nodeIds`. Nothing was changed.
 */
export const v1BackofficeRemoveOrganizationOwner = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeRemoveOrganizationOwnerData, ThrowOnError>) => (options.client ?? client).delete<V1BackofficeRemoveOrganizationOwnerResponses, V1BackofficeRemoveOrganizationOwnerErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/organizations/{id}/people/{userId}',
    ...options
});

/**
 * Audit Events
 *
 * Lists everything the platform operator's own console did, newest first, across every organization on the instance — organizations created, suspended, reactivated or destroyed, invitations resent from the operator's side, and broadcasts sent. Platform operators only.
 *
 * Narrow it with `from`/`to` for a date range, `actions` (repeated once per kind) for the kind of act, or `organizationId` for one organization — which excludes acts that are not about any single organization, such as a broadcast, rather than showing them with no organization. Page with `cursor` from the previous response; changing the filters means starting a new listing, and a cursor older than a day or built by hand is refused with `cursor_invalid` rather than answered — restart from the first page, silently when `details.reason` is `expired`.
 *
 * `operatorName` and `organization.name` are resolved as of now, not as of the event: neither is a snapshot, and a renamed organization or a renamed operator account reads under its current name on an old row.
 */
export const v1BackofficeListAuditEvents = <ThrowOnError extends boolean = true>(options?: Options<V1BackofficeListAuditEventsData, ThrowOnError>) => (options?.client ?? client).get<V1BackofficeListAuditEventsResponses, V1BackofficeListAuditEventsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/audit/events',
    ...options
});

/**
 * Operators
 *
 * Lists the console's operators — active, barred, and invited but not yet arrived — oldest first, in one page.
 *
 * Platform operators only.
 *
 * Each row carries its derived `status`, and the waiting invitation's id when there is one, which the invitation routes take.
 */
export const v1BackofficeListOperators = <ThrowOnError extends boolean = true>(options?: Options<V1BackofficeListOperatorsData, ThrowOnError>) => (options?.client ?? client).get<V1BackofficeListOperatorsResponses, V1BackofficeListOperatorsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/operators',
    ...options
});

/**
 * Operators Invitations
 *
 * Invites somebody to become an operator of this console, and mails them a link to set a password.
 *
 * Platform operators only. Every operator may invite.
 *
 * Success means the invitation was accepted for delivery, not that it arrived. The link works for seven days.
 *
 * Refused when:
 *
 * - `already_exists` (409): the address already belongs to an operator, has an invitation waiting, or is already known to the identity provider. A waiting invitation is sent again with `POST /backoffice/operators/invitations/{invitationId}/deliveries`.
 * - `invite_delivery_not_queued` (500): the message could not be handed over. Nothing was issued, so trying again is safe.
 * - `identity_provider_unavailable` (500): the identity provider gave no usable answer. Nothing was issued.
 */
export const v1BackofficeInviteOperator = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeInviteOperatorData, ThrowOnError>) => (options.client ?? client).post<V1BackofficeInviteOperatorResponses, V1BackofficeInviteOperatorErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/operators/invitations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Operators Invitations :invitationId Deliveries
 *
 * Sends a waiting invitation again, with a new link and seven new days. The previous link stops working at once. A lapsed invitation is resent the same way.
 *
 * Platform operators only.
 *
 * Refused when:
 *
 * - `not_found` (404): no invitation by that id is waiting.
 * - `invite_delivery_not_queued` (500): the message could not be handed over; the previous link still works.
 */
export const v1BackofficeResendOperatorInvitation = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeResendOperatorInvitationData, ThrowOnError>) => (options.client ?? client).post<V1BackofficeResendOperatorInvitationResponses, V1BackofficeResendOperatorInvitationErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/operators/invitations/{invitationId}/deliveries',
    ...options
});

/**
 * Operators Invitations :invitationId
 *
 * Takes back an invitation nobody has accepted: the link stops working and the person never becomes an operator. Repeating it answers the same way.
 *
 * Platform operators only.
 *
 * Refused when:
 *
 * - `not_found` (404): no such invitation.
 * - `state_conflict` (409): it was already accepted. Deactivate or remove the operator instead.
 */
export const v1BackofficeRevokeOperatorInvitation = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeRevokeOperatorInvitationData, ThrowOnError>) => (options.client ?? client).delete<V1BackofficeRevokeOperatorInvitationResponses, V1BackofficeRevokeOperatorInvitationErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/operators/invitations/{invitationId}',
    ...options
});

/**
 * Operators Invitations :invitationId
 *
 * Corrects the address a waiting invitation was sent to, and sends it again there with a new link. The old link stops working.
 *
 * Platform operators only.
 *
 * Refused when:
 *
 * - `not_found` (404): no invitation by that id is waiting.
 * - `already_exists` (409): the new address already belongs to an operator or is known to the identity provider.
 * - `invite_delivery_not_queued` (500): the message could not be handed over.
 */
export const v1BackofficeChangeOperatorInvitationEmail = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeChangeOperatorInvitationEmailData, ThrowOnError>) => (options.client ?? client).patch<V1BackofficeChangeOperatorInvitationEmailResponses, V1BackofficeChangeOperatorInvitationEmailErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/operators/invitations/{invitationId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Operators :operatorId Deactivation
 *
 * Lets a barred operator sign in to the console again. Repeating it answers the same way.
 *
 * Platform operators only.
 *
 * Refused when:
 *
 * - `not_found` (404): no such operator.
 * - `operator_self_action` (409): it is your own account.
 */
export const v1BackofficeReactivateOperator = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeReactivateOperatorData, ThrowOnError>) => (options.client ?? client).delete<V1BackofficeReactivateOperatorResponses, V1BackofficeReactivateOperatorErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/operators/{operatorId}/deactivation',
    ...options
});

/**
 * Operators :operatorId Deactivation
 *
 * Bars an operator from the console: their sessions end and they cannot sign in again until reactivated. Repeating it answers the same way.
 *
 * Platform operators only.
 *
 * Refused when:
 *
 * - `not_found` (404): no such operator.
 * - `operator_self_action` (409): it is your own account.
 * - `last_active_operator` (409): nobody else could sign in to the console afterwards.
 */
export const v1BackofficeDeactivateOperator = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeDeactivateOperatorData, ThrowOnError>) => (options.client ?? client).post<V1BackofficeDeactivateOperatorResponses, V1BackofficeDeactivateOperatorErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/operators/{operatorId}/deactivation',
    ...options
});

/**
 * Operators :operatorId
 *
 * Removes an operator for good: their sessions end, their account is deleted, and any invitation waiting for them stops working. Removing an operator already removed answers the same way.
 *
 * Platform operators only.
 *
 * Refused when:
 *
 * - `not_found` (404): no such operator.
 * - `operator_self_action` (409): it is your own account.
 * - `last_active_operator` (409): nobody else could sign in to the console afterwards.
 */
export const v1BackofficeRemoveOperator = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeRemoveOperatorData, ThrowOnError>) => (options.client ?? client).delete<V1BackofficeRemoveOperatorResponses, V1BackofficeRemoveOperatorErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/operators/{operatorId}',
    ...options
});

/**
 * Client Policy
 *
 * The minimum and the latest version of each native app, by platform, whether maintenance is on, and who changed it last.
 *
 * Platform operators only.
 *
 * The same values `GET /app-config/clients` serves every app. Below its platform's minimum an app may read and not write, and shows its update screen; below the latest it offers the update with a notice that can be dismissed. While maintenance is on, every request of a native app is refused with the message until it ends; the web is never refused.
 */
export const v1BackofficeGetClientPolicy = <ThrowOnError extends boolean = true>(options?: Options<V1BackofficeGetClientPolicyData, ThrowOnError>) => (options?.client ?? client).get<V1BackofficeGetClientPolicyResponses, V1BackofficeGetClientPolicyErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/client-policy',
    ...options
});

/**
 * Client Policy Platforms :platform
 *
 * Sets the minimum and the latest version of one native app, both at once.
 *
 * Platform operators only.
 *
 * From the moment it answers, `GET /app-config/clients` serves the new values; both servers refuse writes from an app below the new minimum within ten seconds. Changing one platform changes no other. Sending the same body again changes nothing.
 *
 * Refused when:
 *
 * - `validation_error` (400): a value is not a semantic version, or the minimum is above the latest.
 */
export const v1BackofficeSetClientPlatformVersions = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeSetClientPlatformVersionsData, ThrowOnError>) => (options.client ?? client).put<V1BackofficeSetClientPlatformVersionsResponses, V1BackofficeSetClientPlatformVersionsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/client-policy/platforms/{platform}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Client Policy Maintenance
 *
 * Turns maintenance for the native apps on or off.
 *
 * Platform operators only.
 *
 * While it is on, every request of a native app answers `503` with the message and the end, and the apps keep every change made on the device for when it ends. The web is never refused. Both servers apply a change within ten seconds. Sending the same body again changes nothing.
 *
 * Refused when:
 *
 * - `validation_error` (400): `until` is in the past while turning it on, or the message is empty or longer than 500 characters.
 */
export const v1BackofficeSetMaintenance = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeSetMaintenanceData, ThrowOnError>) => (options.client ?? client).put<V1BackofficeSetMaintenanceResponses, V1BackofficeSetMaintenanceErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/client-policy/maintenance',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Auth Oidc Authorizations
 *
 * Starts a Keycloak sign-in for the platform operator against the `master` realm and returns the authorization URL. The caller navigates the browser there; Keycloak sends it back to `GET /backoffice/auth/oidc-callback`, which finishes the sign-in.
 *
 * Public: this is how an operator with no session begins.
 *
 * Refused when:
 *
 * - `rate_limited`: too many attempts from this caller.
 */
export const v1BackofficeAuthStartOidcLogin = <ThrowOnError extends boolean = true>(options?: Options<V1BackofficeAuthStartOidcLoginData, ThrowOnError>) => (options?.client ?? client).post<V1BackofficeAuthStartOidcLoginResponses, V1BackofficeAuthStartOidcLoginErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/backoffice/auth/oidc/authorizations',
    ...options
});

/**
 * Auth Oidc Callback
 *
 * Finishes an operator sign-in: Keycloak redirects the browser here once the operator has authenticated.
 *
 * No client ever calls this. It is the `redirectUri` registered for the platform operator's isolated client in Keycloak's `master` realm, so the path is fixed from outside and cannot be renamed. It appears in this list because it is part of the contract, not because there is something to call: the call the console makes is `POST /backoffice/auth/oidc/authorizations`.
 *
 * On success it issues the backoffice session cookie and redirects the browser to the admin console. On any failure it redirects (302) to the console's login route instead of answering with a JSON body — nothing reads the response of a top-level browser navigation — carrying `error` (one of the codes below) and `requestId` in the query string.
 *
 * Only an operator who already exists can sign in, matched on the Keycloak subject or, on a first login, on an email address Keycloak has verified. There is no self-service provisioning: an unknown Keycloak account is refused rather than created.
 *
 * `error` is one of:
 *
 * - `backoffice_oidc_callback_state_invalid`: the attempt expired or was already completed. Start again.
 * - `backoffice_oidc_callback_exchange_failed`: the exchange with Keycloak did not complete.
 * - `backoffice_admin_deleted`: the operator account no longer exists.
 * - `backoffice_operator_not_provisioned`: this Keycloak account is not provisioned as a platform operator.
 * - `backoffice_admin_disabled`: the operator account is disabled.
 *
 * Refused with a JSON body only when the caller never reaches this handler: `rate_limited` (429), too many attempts from this caller.
 */
export const v1BackofficeAuthOidcCallback = <ThrowOnError extends boolean = true>(options?: Options<V1BackofficeAuthOidcCallbackData, ThrowOnError>) => (options?.client ?? client).get<unknown, V1BackofficeAuthOidcCallbackErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/backoffice/auth/oidc-callback',
    ...options
});

/**
 * Auth Sessions Current
 *
 * Ends the operator's backoffice session and clears the session cookie.
 *
 * Public and idempotent. Name the session either by putting its `token` in the body or by relying on the session cookie together with a valid `x-csrf-token` header; send at least an empty JSON body. With no recognised credentials it is a no-op, and it always answers success.
 *
 * This ends the local session and does not reach Keycloak. Call `POST /backoffice/auth/oidc/logouts` instead when the operator presses sign out in the console, so the identity provider session ends too.
 */
export const v1BackofficeAuthSignOut = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeAuthSignOutData, ThrowOnError>) => (options.client ?? client).delete<V1BackofficeAuthSignOutResponses, V1BackofficeAuthSignOutErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/backoffice/auth/sessions/current',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Auth Sessions Current
 *
 * Returns the operator's current auth context. `sessionType` is `anonymous` when no valid backoffice session is present and `authenticated` otherwise, with the `session` and `user` blocks filled in.
 *
 * Public: it works with or without credentials, which makes it the call to make on console start or after a page reload to recover the signed-in state.
 *
 * When authenticated it also returns a fresh `csrfToken` to attach to later mutating requests. It carries no organization and no role: an authenticated backoffice session already identifies the platform operator.
 */
export const v1BackofficeAuthGetSession = <ThrowOnError extends boolean = true>(options?: Options<V1BackofficeAuthGetSessionData, ThrowOnError>) => (options?.client ?? client).get<V1BackofficeAuthGetSessionResponses, V1BackofficeAuthGetSessionErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/backoffice/auth/sessions/current',
    ...options
});

/**
 * Auth Oidc Logouts
 *
 * Ends the current backoffice session and the operator's Keycloak session in the `master` realm with it. The propagation happens server-side, so there is nothing further for the client to navigate to.
 *
 * Authenticated operators only.
 *
 * This is the console's sign-out action. `DELETE /backoffice/auth/sessions/current` ends only the local session.
 */
export const v1BackofficeAuthOidcLogout = <ThrowOnError extends boolean = true>(options?: Options<V1BackofficeAuthOidcLogoutData, ThrowOnError>) => (options?.client ?? client).post<V1BackofficeAuthOidcLogoutResponses, V1BackofficeAuthOidcLogoutErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/backoffice/auth/oidc/logouts',
    ...options
});

/**
 * Auth Invitations Validation
 *
 * Checks an operator invitation code and returns what the activation page needs: the address it was sent to, its language and the password rules the chosen password must meet.
 *
 * Public: the person holding the link has no session yet. Attempts are limited per caller.
 *
 * Follow with `POST /backoffice/auth/invitations/activation`.
 *
 * Refused when:
 *
 * - `invite_code_invalid` (404): no such code.
 * - `invite_expired` (404): the invitation lapsed. Only an operator can send it again.
 * - `invite_already_used` (404): it was already activated or taken back.
 * - `rate_limited` (429): too many attempts from this caller.
 */
export const v1BackofficeValidateOperatorInvitation = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeValidateOperatorInvitationData, ThrowOnError>) => (options.client ?? client).post<V1BackofficeValidateOperatorInvitationResponses, V1BackofficeValidateOperatorInvitationErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/backoffice/auth/invitations/validation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Auth Invitations Activation
 *
 * Spends an operator invitation: sets the chosen password and name, makes the person an active operator, and signs them in with that password when the identity provider allows it. `signedIn` says which: the session cookie is already set, or the person goes through the console's ordinary sign-in.
 *
 * Public, and limited per caller.
 *
 * Refused when:
 *
 * - `invite_code_invalid`, `invite_expired`, `invite_already_used` (404): as for the validation call.
 * - `invite_password_rejected` (422): the password breaks the console's password policy.
 * - `rate_limited` (429): too many attempts from this caller.
 * - `invite_activation_failed` (503): the identity provider gave no usable answer. The invitation is not spent, so resubmitting the same form completes it.
 */
export const v1BackofficeActivateOperatorInvitation = <ThrowOnError extends boolean = true>(options: Options<V1BackofficeActivateOperatorInvitationData, ThrowOnError>) => (options.client ?? client).post<V1BackofficeActivateOperatorInvitationResponses, V1BackofficeActivateOperatorInvitationErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/backoffice/auth/invitations/activation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Health Check
 *
 * Returns the health check of the server
 */
export const healthCheck = <ThrowOnError extends boolean = true>(options?: Options<HealthCheckData, ThrowOnError>) => (options?.client ?? client).get<HealthCheckResponses, HealthCheckErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/health-check',
    ...options
});

/**
 * Live
 *
 * Answers while the process can serve a request, whatever its dependencies say. For a liveness probe; readiness reads /health-check.
 */
export const healthCheckLive = <ThrowOnError extends boolean = true>(options?: Options<HealthCheckLiveData, ThrowOnError>) => (options?.client ?? client).get<HealthCheckLiveResponses, HealthCheckLiveErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/health-check/live',
    ...options
});

/**
 * Services
 *
 * Returns the health check of the server services
 */
export const healthCheckServices = <ThrowOnError extends boolean = true>(options?: Options<HealthCheckServicesData, ThrowOnError>) => (options?.client ?? client).get<HealthCheckServicesResponses, HealthCheckServicesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/health-check/services',
    ...options
});

/**
 * `GET /v1/directory/changes`: one page of what changed after a cursor, as
 * the caller sees it.
 *
 * What changed in your drive after a cursor, one page at a time. Start from the cursor `GET /directory/changes/head` gave you, send the `cursor` of each page on the next call, and stop when `hasMore` is false: that page reached the newest change there was when it was read.
 *
 * Each entry is one node, at most once per page, in the order of its latest change, and says what the node is now rather than what happened to it:
 *
 * - `upsert`, with the node as it is now and your role on it, when you can see it. Its `parentId` is null when you cannot see the folder it is in.
 * - `removed`, with its id, when you could see it and no longer can: it was moved where you cannot see it, sent to the bin, deleted, or is no longer shared with you. Take it out of your tree with everything under it.
 *
 * A node you have never been able to see never appears. A folder that becomes visible to you is one `upsert` for the folder alone, and what it holds has to be listed. Apply a whole run of pages, up to `hasMore: false`, before trusting the tree: a node can arrive before the folder it is in.
 *
 * A cursor that is not one this server gave you, in this organization, answers 422 `cursor_invalid`. A cursor whose changes are older than the journal keeps answers 410 `changes_cursor_expired`: read the head again and enumerate the drive.
 */
export const v1DirectoryListChanges = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryListChangesData, ThrowOnError>) => (options.client ?? client).get<V1DirectoryListChangesResponses, V1DirectoryListChangesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/changes',
    ...options
});

/**
 * `GET /v1/directory/changes/head`: where the caller's organization's
 * journal stands now.
 *
 * Where your organization's change journal stands now, as an opaque cursor. Read it before enumerating the drive and store it; once the enumeration is done, read `GET /directory/changes` from it until `hasMore` is false, and every change made while you were enumerating is in what you read. The cursor is bound to you and to your organization, and does not expire with time: it stops working only when the changes after it are older than the journal keeps, which is answered 410 `changes_cursor_expired`.
 */
export const v1DirectoryGetChangesHead = <ThrowOnError extends boolean = true>(options?: Options<V1DirectoryGetChangesHeadData, ThrowOnError>) => (options?.client ?? client).get<V1DirectoryGetChangesHeadResponses, V1DirectoryGetChangesHeadErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/changes/head',
    ...options
});

/**
 * `POST /v1/directory/copies`: copies of up to fifty files, made by the store,
 * as new files in one folder the caller chooses (OPSSTD-10579).
 *
 * Make copies of up to fifty files, as new files in one folder you choose. The storage makes each copy itself, so the bytes never travel through your connection, and a copy is the file as it is now: its current version, without its history. Send the folder the files are already in to duplicate them.
 *
 * Anybody who can download a file may copy it into a folder they can write in. Each copy is yours, and you are its owner whoever owns the original. It takes the file's name, and a name already used in the folder becomes the next free one (`report (1).pdf`), as it does for an upload; the same file named twice is copied twice. The answer waits until the storage has finished every copy, which for large files can take minutes, and carries one outcome per file in the order sent: `copied` with the new file, or `refused` with the reason that file was not copied. A refused file does not stop the others.
 *
 * Several files together may weigh at most 5 GiB (5368709120 bytes); a selection over that is refused whole, before anything is copied, and is sent in smaller calls. A single file has no such bound.
 *
 * One call at a time per person: while one of yours is copying, another answers `copy_in_progress`, and is sent again once the first has answered.
 *
 * Send an `idempotency-key` header and a retry with the same key gives you the first answer instead of second copies. Send `X-Batch-Id` to count several calls as one summary in the audit trail; one call is always one summary.
 *
 * Refused whole when:
 *
 * - `validation_error` (400): `nodeIds` is empty or names more than 50 files.
 * - `not_found` (404): the folder is not visible to you.
 * - `insufficient_role` (403): you may only read the folder.
 * - `parent_not_folder` (422): the destination is a file.
 * - `copy_too_large` (422): several files weigh more than 5 GiB together. `details` carries `limitBytes` and `totalBytes`. Nothing was copied.
 * - `copy_in_progress` (409): another copy call of yours is still running. Nothing was copied.
 * - `idempotency_key_reused` (422) and `idempotency_in_flight` (409): the key was used for another request, or this one is still running.
 *
 * A file is refused alone with `not_found` (not visible to you), `node_not_a_file` (a folder), `state_conflict` (still being uploaded, or the storage refused or gave up on the copy), `storage_quota_exceeded` (the copy would take you past your quota, or the organization past its own: a copy counts whole against you), `invalid_name`, `path_too_long` or `max_depth_exceeded` (the place the copy would have does not fit the rules), `upload_verification_failed` (the storage wrote the wrong size, and it was thrown away) or `internal_error` (the storage could not be reached; trying again is the right thing to do).
 */
export const v1DirectoryCopyNodes = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryCopyNodesData, ThrowOnError>) => (options.client ?? client).post<V1DirectoryCopyNodesResponses, V1DirectoryCopyNodesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/copies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * `POST /v1/directory/download-authorizations` — signed links for up to fifty
 * files, each on the version the caller pinned.
 *
 * Get download links for up to 50 files in one call.
 *
 * Each item names a file and, optionally, the `versionId` the download plan returned for it: the link then reads that version even if the file has changed since, and an item whose pinned version no longer exists is refused with `not_found`. Without `versionId` the link reads the version that is current now. Links are signed, last `expiresInSeconds`, save the file under its name, and work for one file each. Treat them as secrets: whoever holds one can download the file until it expires.
 *
 * The answer has one entry per item, in the order sent. An entry is `authorized`, with the link, the file name, the version it reads (null for a file with no version history), that version's `size`, and the `checksum` its uploader declared (the SHA-256 in base64, null when none was declared; the storage does not verify it, so check the bytes against it), or `refused` with a `code`:
 *
 * - `not_found`: the file is not visible to you, or the pinned version no longer exists.
 * - `state_conflict`: its upload has not finished.
 * - `node_not_a_file`: the id is a folder.
 *
 * The call is recorded as one download summary, counting authorized and refused items and the bytes authorized. Send `X-Batch-Id` to fold several calls into one summary.
 */
export const v1DirectoryAuthorizeDownloads = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryAuthorizeDownloadsData, ThrowOnError>) => (options.client ?? client).post<V1DirectoryAuthorizeDownloadsResponses, V1DirectoryAuthorizeDownloadsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/download-authorizations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * `POST /v1/directory/download-plans` — the flat list of files a selection is
 * made of, each pinned to its current version.
 *
 * Plan the download of a selection of files and folders.
 *
 * Send the selected ids in `nodeIds`, in the order they were selected. The answer lists every file to fetch, with the path it takes below its root (folder names separated by `/`, empty when the file is the root itself), its size, and the version that is current now: pass `versionId` back when asking for the download authorization, so the bytes read are the ones this plan describes even if the file changes meanwhile. Folders that contain nothing to fetch are listed in `emptyFolders`, so an archive can keep them. A node selected together with a folder that contains it is planned once, under that folder.
 *
 * Left out without being counted or reported: ids the caller cannot see (they do not exist, are in another organization, are in the bin, or the caller holds no role on them), files whose upload has not finished, and everything below a folder in the bin inside the selection. The plan is therefore what can be downloaded, and may be smaller than what was selected.
 *
 * Nothing is signed and nothing is recorded in the audit trail: the links come from the download authorizations, which are recorded.
 *
 * When the selection holds more than 10000 files, or more than 25000 files and folders in all, the answer is `status: "too_large"` with `maxFiles`, still a 200.
 */
export const v1DirectoryCreateDownloadPlan = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryCreateDownloadPlanData, ThrowOnError>) => (options.client ?? client).post<V1DirectoryCreateDownloadPlanResponses, V1DirectoryCreateDownloadPlanErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/download-plans',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * `GET /v1/directory/favorites` — the nodes the caller starred (OPSSTD-10641).
 *
 * List the files and folders the caller marked as favorites, flat — each row a listing row with the role the caller really holds on it (a favorite is a bookmark, never a grant: a viewer stays a viewer) and `favoritedAt`, when it was marked. Takes the filters and sorts of a folder's listing, with folders above files in every order: `name`, `updatedAt` and `size`, defaulting as a folder's listing does. A favorite in the bin, or on a node the caller no longer reaches, is left out and comes back with the node or the access. Page with `cursor` from the previous response and never build one yourself; a cursor minted under another order or filter set is refused, and so is one older than a day. Returns an empty list when nothing is marked.
 */
export const v1DirectoryListFavorites = <ThrowOnError extends boolean = true>(options?: Options<V1DirectoryListFavoritesData, ThrowOnError>) => (options?.client ?? client).get<V1DirectoryListFavoritesResponses, V1DirectoryListFavoritesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/favorites',
    ...options
});

/**
 * `POST /v1/directory/favorites` — mark files and folders as favorites.
 *
 * Mark up to 100 files and folders as your favorites. A favorite is a bookmark of yours: it changes nothing about who may see or do what, so anything you can see can be marked, a viewer's read-only share included. The response has one entry per id, in the order sent: `applied` (now a favorite), `unchanged` (it already was) or `skipped` (you cannot see it, it does not exist, or it is in the bin). An id you cannot see never fails the call, and nothing tells it apart from one that does not exist.
 *
 * Refused as a whole:
 *
 * - `validation_error` (400): the body is not what this route takes.
 * - `too_many_nodes` (422): more than 100 ids.
 */
export const v1DirectoryAddFavorites = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryAddFavoritesData, ThrowOnError>) => (options.client ?? client).post<V1DirectoryAddFavoritesResponses, V1DirectoryAddFavoritesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/favorites',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * `POST /v1/directory/favorites/removal` — take files and folders off the
 * favorites.
 *
 * Take up to 100 files and folders off your favorites. Idempotent: an id that was not a favorite is answered `unchanged`. The response has one entry per id, in the order sent: `applied` (no longer a favorite) or `unchanged` (it was not one). Removal never asks whether you can still see the node: a bookmark confers nothing, so you can drop one on a node you lost access to, or that is in the bin.
 *
 * Refused as a whole:
 *
 * - `validation_error` (400): the body is not what this route takes.
 * - `too_many_nodes` (422): more than 100 ids.
 */
export const v1DirectoryRemoveFavorites = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryRemoveFavoritesData, ThrowOnError>) => (options.client ?? client).post<V1DirectoryRemoveFavoritesResponses, V1DirectoryRemoveFavoritesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/favorites/removal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * `POST /v1/directory/files` — announce a file and get what is needed to send
 * it.
 *
 * Announce a file you are about to upload and get back what you need to send it. Reserved to somebody who can write in the destination folder. The answer says which way to send it: `single` gives you one link to PUT the whole file to, `multipart` means the file is too big for one request and you call `POST /directory/files/{nodeId}/upload` next. Either way the file already appears in the folder, so a colleague sees it arriving. A name already held by a live file or folder you did not create, or by somebody else's transfer that has not finished, no longer refuses the announce: the file goes in under the next free name instead, and `meta.requestedName` carries what you actually typed — null when the file went in under the name you asked for. Your **own** unfinished transfer under this name, declared at the same size, is not a collision at all: you get that same transfer back, `meta.resumed: true`, with a freshly signed plan and nothing new created — a different size is another file and duplicates instead. Your own **complete** file under this name answers `409 own_file_exists` naming its id and the name "keep both" would produce, unless you send `onNameConflict`: `keepBoth` duplicates it, `replace` keeps that file's id and makes this upload a new version of it, `meta.replaced: true` — the completion is what actually publishes the new bytes over the old ones. `replace` against anything you did not create yourself answers `409 replace_not_allowed`. With `replace`, send `expectedVersion`, the version of the file your new bytes were made on, and the announce answers `409 version_conflict` while the file is at another one: the completion of a replace is guarded on the version it was opened on, not on its own `expectedVersion`. Send `checksum`, the whole file's SHA-256 in base64, and it is recorded on the version this upload becomes and returned by every download authorization of that version: the storage does not check the bytes against it, so the client that downloads them does. Your own unfinished transfer opened with a different `checksum` is another file and answers `409 pending_upload_differs`, as one opened with a different `originalModifiedAt` does. Send an `idempotency-key` header and a retry with the same key gives you the first answer instead of doing the work twice, with the link signed again so it is usable even a day later and everything else unchanged; a key reused for a different request answers 422 `idempotency_key_reused`, and one still running elsewhere answers 409 `idempotency_in_flight` with `Retry-After`. Answers 404 when the folder is not visible, 403 when you may only read it, 409 when your own complete file holds the name with no `onNameConflict`, when `replace` names something you may not replace or a file at another version than `expectedVersion`, or when a request with this key is running, and 422 when the name or the size is not usable, or when `checksum` is not a SHA-256 digest in base64 (`invalid_checksum`). Answers 429 `storage_quota_exceeded` when the declared size would take somebody past a storage quota, the file's owner past their own or the organization past its quota: a new file counts whole against you, a `replace` counts only by how much larger it is than the file it replaces, against that file's owner. `details.scope` says which limit (`person` or `organization`), with `limitBytes` and `usedBytes`. Nothing is created and nothing is signed; waiting does not change the answer, freeing space does.
 */
export const v1DirectoryOpenUpload = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryOpenUploadData, ThrowOnError>) => (options.client ?? client).post<V1DirectoryOpenUploadResponses, V1DirectoryOpenUploadErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/files',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * `POST /v1/directory/files/{nodeId}/upload` — open the multipart and get the
 * first batch of part links.
 *
 * Start sending a file too big for one request, and get the first batch of part links. Call it after `POST /directory/files` answered `multipart`, on the file it created. You get back an `uploadId` to use for everything that follows, the size and number of the parts, and links for the first batch of them: up to a hundred, fewer when the parts are large. Ask for the next batch with `POST /directory/uploads/{uploadId}/part-urls`, from `nextPartNumber`, as you go. Calling this twice for the same file is safe: you get the upload that is already open, not a second one, and an `idempotency-key` header makes a retry return the first answer verbatim. Answers 404 when the file is not visible or its transfer is not yours, 403 when you may only read it, and 409 when it is not waiting for an upload or is small enough to send in a single request.
 */
export const v1DirectoryOpenMultipart = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryOpenMultipartData, ThrowOnError>) => (options.client ?? client).post<V1DirectoryOpenMultipartResponses, V1DirectoryOpenMultipartErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/files/{nodeId}/upload',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * `POST /v1/directory/files/{nodeId}/upload/completion` — finish an upload, and
 * refuse to call anything finished that is not.
 *
 * Finish an upload and make the file live. Call it after the single PUT has gone through, or after every part has been confirmed. The server checks with the storage that the file is really there and really the size you declared before marking it live — a file that arrives the wrong size is treated as corrupt rather than published. Send `md5` for a single PUT and a file whose bytes are not the ones it names is treated the same way. If parts are still missing nothing is lost: the file stays exactly as it was and you can send the rest. Send an `idempotency-key` header and a retry after a lost response gives you the first answer instead of running the completion twice. Send `expectedVersion` and a `409 version_conflict` tells you somebody replaced the file first, with their version, the time and enough to write the dialog; finishing a replace opened by `POST /directory/files`'s `onNameConflict: "replace"` checks the same thing automatically, against the version that replace was opened with, whether or not you send one. A `409 upload_target_deleted` tells you the file was removed while you were sending, and the only way forward is to upload it as a new one. Answers 404 when the file is not visible or its transfer is not yours, 403 when you may only read it, and 409 in the other cases where the upload is not finishable. If the storage cannot be reached the answer is a fault rather than a conflict, so retrying it later is the right thing to do and nothing you have already sent is lost.
 */
export const v1DirectoryCompleteUpload = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryCompleteUploadData, ThrowOnError>) => (options.client ?? client).post<V1DirectoryCompleteUploadResponses, V1DirectoryCompleteUploadErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/files/{nodeId}/upload/completion',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * `POST /v1/directory/folders` — create a folder inside another one, or
 * merge into one that is already there.
 *
 * Create a folder inside another one. Open to anyone who can write in the parent — `editor` or `owner`, held on it or on a folder above it. The new folder inherits nothing of its own: whoever reaches the parent reaches it. A name already held by a **live folder** is not a conflict: without `onNameConflict` you get that folder back, `200`, with `meta.created: false` (OPSSTD-8263) — the caller already needs editor on the parent to reach here, and grants flow down, so nothing is exposed that a listing of the parent would not show. Send `onNameConflict: "keepBoth"` and a new folder is created beside it under the next free name instead, `201`, with `meta.requestedName` carrying the name you asked for. A name held by a file, or by somebody's transfer that has not finished, is not what you meant to collide with either: the folder is created under the next free name instead of being refused, `201`, with `meta.requestedName` carrying what you actually typed and `meta.created: true`; an ordinary create with nothing in the way answers the same `201` with `requestedName` absent. Answers 404 when the parent is not visible to the caller, 403 when they can see it and may only read, 409 when the parent is in the bin, and 422 on a name the rules reject, a path too long for a client to write, a depth past the limit, or a parent that is a file. Send an `idempotency-key` header and a repeat with the same key gets the first answer, marked `Idempotent-Replayed: true`, instead of doing the work again; the same key on a different request answers 422 `idempotency_key_reused`, and a repeat that arrives while the first request is still running answers 409 `idempotency_in_flight` with `Retry-After`.
 */
export const v1DirectoryCreateFolder = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryCreateFolderData, ThrowOnError>) => (options.client ?? client).post<V1DirectoryCreateFolderResponses, V1DirectoryCreateFolderErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/folders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * `GET /v1/directory/folders/{nodeId}/uploads` — what other people are
 * uploading in here.
 *
 * List the files other people are uploading into one folder, so that a folder which looks emptier than it is can say why. Each row carries the name the file will have and who is sending it.
 *
 * Your own uploads are **not** here: they are in `GET /directory/uploads`, with the progress and the resume link this list cannot offer, and repeating them would count one transfer twice on one screen.
 *
 * No percentage. It would be a number frozen at the moment the page was read, and a progress bar that never moves says 'stuck' rather than 'arriving'.
 *
 * A folder you cannot reach answers 404, exactly as it does everywhere else in this module.
 */
export const v1DirectoryListFolderUploads = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryListFolderUploadsData, ThrowOnError>) => (options.client ?? client).get<V1DirectoryListFolderUploadsResponses, V1DirectoryListFolderUploadsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/directory/folders/{nodeId}/uploads',
    ...options
});

/**
 * `GET /v1/directory/nodes` — read specific nodes by id.
 *
 * Read specific nodes by id, each with the role the caller holds on it. Name them in `ids`, repeating the parameter for more than one, at most a hundred at a time. Ids the caller cannot see are omitted from the response rather than reported, so a caller cannot learn whether an id exists by asking about it. `parentId` comes back null on a node whose containing folder the caller cannot see, for the same reason. An empty array means none of the requested ids are visible. Repeated ids are collapsed: each node appears at most once, in the position of its first occurrence, so a client that built its list by concatenating two others gets a count it can trust.
 */
export const v1DirectoryGetNodes = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryGetNodesData, ThrowOnError>) => (options.client ?? client).get<V1DirectoryGetNodesResponses, V1DirectoryGetNodesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/nodes',
    ...options
});

/**
 * The read half of a resource that has had writes since MS25 and never a read.
 *
 * Reads one node: the folder or file itself, the role the caller holds on it, who created it, who last changed it, and — on a folder — how many items it directly contains.
 *
 * This is the read a details panel makes. It is enough on its own: nothing here has to be paired with a row from a listing to be drawn, which is what lets a client open the panel on a node that is not currently in a list.
 *
 * `createdBy` is also who owns the node — ownership is a property of the node rather than a grant. `modifiedBy` is whoever last renamed, moved or replaced the contents of the node, or whoever created it if nobody has done any of those. Both people are null under the same two conditions and no third: nobody was recorded, or their account is gone. Show the date without a name rather than an identifier.
 *
 * `parentId` comes back null when the caller cannot see the containing folder, so a folder shared deep in somebody else's tree never names what sits above it.
 *
 * Answers 404 when the node does not exist or the caller cannot see it. The two are deliberately the same answer, so nobody learns that an id is real by asking about it — with one named exception: a caller who held at least `viewer` on the node before it was sent to the bin gets the same 404 with `details.reason` set to `trashed`, alongside `trashedAt`, `trashedBy` and `canRestore`, which is true when they hold `editor`. Opening a stale link or a bookmark is the case this exists for.
 */
export const v1DirectoryGetNode = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryGetNodeData, ThrowOnError>) => (options.client ?? client).get<V1DirectoryGetNodeResponses, V1DirectoryGetNodeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/nodes/{nodeId}',
    ...options
});

/**
 * `PATCH /v1/directory/nodes/{nodeId}` — rename a folder or a file.
 *
 * Rename a folder or a file. Open to anyone who can write it — `editor` or `owner`, held on it or on a folder above it. Nothing inside it moves and nothing is copied: the rename touches the one row. Moving it somewhere else is a different call, `PUT /directory/nodes/{nodeId}/parent`. Two people renaming the same thing at once is not an error, and the later write wins, unless the call carries `If-Match`: then a rename that finds the node changed since is refused with 412 `precondition_failed` and the node as it is now in `details.node`, and nothing is renamed. A name already used among its neighbours comes back with a free alternative in `details.suggestedName`. Answers 400 on a body or an `If-Match` it cannot read, 404 when the node is not visible to the caller, 403 when they can see it and may only read, 409 on a taken name, 412 as above, and 422 on a name the rules reject, a path too long for a client to write, or the caller's own personal folder (`personal_folder_fixed_name`). That folder's name is fixed because clients label it from their own translations, so a stored name would never reach the screen; a personal folder a colleague shared is renamed like any other. Send an `idempotency-key` header and a repeat with the same key gets the first answer, marked `Idempotent-Replayed: true`, instead of doing the work again; the same key on a different request answers 422 `idempotency_key_reused`, and a repeat that arrives while the first request is still running answers 409 `idempotency_in_flight` with `Retry-After`.
 */
export const v1DirectoryRenameNode = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryRenameNodeData, ThrowOnError>) => (options.client ?? client).patch<V1DirectoryRenameNodeResponses, V1DirectoryRenameNodeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/nodes/{nodeId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * `GET /v1/directory/nodes/{nodeId}/ancestors` — the breadcrumb.
 *
 * The path to a folder or a file, for a breadcrumb. Starts at the topmost folder the caller can reach and ends at the node they asked about, both included. It never goes higher: someone given a folder deep in somebody else's tree sees that folder as the start of their path, and learns nothing about what sits above it — no name, no identifier, no placeholder standing in for one. Use it when opening a node from a link or after a page reload, where the client holds no parents in memory. Answers 404 when the node is not visible to the caller, the same as one that does not exist. Every step carries the `role` the caller holds there, the same value `GET /directory/nodes/{nodeId}/children` puts on every row and resolved the same way, so an action aimed at a step of the path — dropping something onto a breadcrumb, above all — can be offered or refused before it is attempted rather than after. `meta.origin` says how that first step came to be reachable — the role the caller was given on it, when, and by whom — so a shared-by badge can be drawn straight from this call. It answers one of three cases. Null when the chain starts in the caller's own personal folder, because nothing was shared to reach it. `via: grant` when somebody gave the caller access — always, whenever the caller holds any grant on the path, even if a folder on it is also open to the organization, and the path then starts where that grant does. `via: organization` when the only reason the caller sees the node is that a folder on its path is open to everyone in the organization with the link: the path starts at that folder, never above it, `sharedBy` and `sharedAt` say who opened it and when, and `role` is what the opening confers under the organization's link policy.
 */
export const v1DirectoryListAncestors = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryListAncestorsData, ThrowOnError>) => (options.client ?? client).get<V1DirectoryListAncestorsResponses, V1DirectoryListAncestorsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/nodes/{nodeId}/ancestors',
    ...options
});

/**
 * `GET /v1/directory/nodes/{nodeId}/children` — one page of a folder.
 *
 * List the contents of a folder, newest cursor first. Returns each node with the role the caller holds on it, which is their strongest grant on the node or on any folder above it. Order with `sortBy` — `name`, `updatedAt`, `size` or `lastViewed` — and `sortDirection`. `lastViewed` orders the page for the caller alone: folders by name, then the files the caller has opened (most recent first), then the files the caller has never opened, by name; a client who sends `sortBy=lastViewed` and no `sortDirection` gets `desc`, newest view first, where every other key defaults to `asc` — send `sortDirection` explicitly to ask for the oldest view first instead, which reorders only the viewed files. Page with `cursor` from the previous response and never build one yourself; a cursor older than a day is refused, and the client restarts from the first page. A folder the caller cannot see answers 404, the same as one that does not exist.
 */
export const v1DirectoryListChildren = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryListChildrenData, ThrowOnError>) => (options.client ?? client).get<V1DirectoryListChildrenResponses, V1DirectoryListChildrenErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/nodes/{nodeId}/children',
    ...options
});

/**
 * `POST /v1/directory/nodes/{nodeId}/download-authorizations` — permission to
 * download one file, and never the file itself.
 *
 * Get a link to download a file, or to show it. Anyone who can see the file may ask; the link is signed, lasts `expiresInSeconds`, works for that one file only, and gives the file back under its current name. Send `disposition: "inline"` to get a link a viewer can point at directly — the browser shows the file instead of saving it, and nothing has to hold the bytes in memory first. Omit the body entirely and the link saves, which is what it has always done.
 *
 * **An `inline` URL also pins the media type, from the file's extension.** The signature carries the type this server holds for that extension, not the one recorded on the stored object, because that one is whatever the client that uploaded it declared and nothing has ever checked it against the name. For an extension this server names no type for — anything the viewer cannot preview, and `.svg`, which it draws but a browser would run as a document — the request is still answered and the URL saves instead of showing. Either way the count is a preview, because that is what was asked. A viewer loses nothing: it fetches the bytes and draws them itself rather than sending the browser to the URL.
 *
 * The two are counted separately, into a `preview` batch and a `download` one, so a report of who took a file away does not count who only looked at it. Send `X-Batch-Id` to fold several of these into one summary — a multi-selection download shares one id. Treat the link as a secret — whoever holds it can download the file until it expires, which is also why revoking someone's access cannot cut a download already authorized. Answers 404 when the file is not visible to the caller, 409 when it is still being uploaded, and 422 when the id belongs to a folder.
 */
export const v1DirectoryAuthorizeDownload = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryAuthorizeDownloadData, ThrowOnError>) => (options.client ?? client).post<V1DirectoryAuthorizeDownloadResponses, V1DirectoryAuthorizeDownloadErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/nodes/{nodeId}/download-authorizations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * `GET /v1/directory/nodes/{nodeId}/grants` — who has access.
 *
 * Reads who has access to a folder or a file. Reserved to somebody who can edit it — an owner can too, a viewer cannot.
 *
 * `owner` is who the node belongs to. It is read from the node itself rather than from the access list, so show it first and without controls: it cannot be changed or removed here, and no entry in `direct` repeats it.
 *
 * `direct` is the access given on this node, which the caller can change or remove. Oldest first, in an order that is stable across calls.
 *
 * `inherited` is the access that reaches the node from a folder above, and is read-only. Each entry names the folder it comes from, so a client can send the caller there. Only folders the caller can see are named: somebody given a folder deep in a tree learns nothing about what sits above it, not a name, not an identifier, not a count.
 *
 * `sharingVersion` is what the sharing of this node stood at when the list was read. `PUT /directory/nodes/{nodeId}/grants` sends it back to prove nobody changed the access in between. It moves only when access changes, never when the file is uploaded.
 *
 * The list is not paginated.
 *
 * Refused when:
 *
 * - `not_found` (404): the node is not visible to the caller
 * - `insufficient_role` (403): the caller can see it and cannot edit it
 */
export const v1DirectoryListGrants = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryListGrantsData, ThrowOnError>) => (options.client ?? client).get<V1DirectoryListGrantsResponses, V1DirectoryListGrantsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/nodes/{nodeId}/grants',
    ...options
});

/**
 * `PUT /v1/directory/nodes/{nodeId}/grants` — set who has direct access, in
 * one call.
 *
 * Sets who has direct access to a folder or a file, in one call.
 *
 * Send the whole list you want to end up with: people missing from it lose their access, people new to it gain it, and people whose role differs have it changed. It applies completely or not at all, so a refusal leaves the access exactly as it was.
 *
 * A line can name a group with `subjectType: "group"`: everyone in it gets the role, alongside whatever they reach another way. A private group can be named by its members and by the organization's administrators.
 *
 * Reserved to whoever the organization's sharing policy lets share: somebody who owns the node — owning it through a folder above counts — and, when `sharing.who_can_share` is `everyone`, somebody who can edit it too. The policy is read on every call, so a change applies to the very next save. A viewer is always refused.
 *
 * Send back the `sharingVersion` that came with the list you composed against. If somebody else saved in between, the call is refused and you reload before retrying, so nobody's change is silently overwritten. Uploading a file does not cause that conflict.
 *
 * `owner` cannot be assigned: the owner of a node is whoever created it, a fact about the node rather than a role anybody hands out. Access inherited from a folder above is changed at that folder and never belongs in this list.
 *
 * Refused when:
 *
 * - `not_found` (404): the node is not visible to the caller, somebody named is not in their organization, or a group named is one the caller cannot see
 * - `insufficient_role` (403): the caller can see the node and the sharing policy does not let their role share it
 * - `cannot_grant_to_self` (403): an entry names the caller with a role they do not already hold on this node
 * - `sharing_version_conflict` (409): somebody else changed the access in between
 * - `last_owner` (409): the change would leave the node with no owner
 * - `owner_not_assignable` (422): `owner` was sent as a role
 * - `validation_error` (422): the same person appears more than once
 */
export const v1DirectorySetGrants = <ThrowOnError extends boolean = true>(options: Options<V1DirectorySetGrantsData, ThrowOnError>) => (options.client ?? client).put<V1DirectorySetGrantsResponses, V1DirectorySetGrantsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/nodes/{nodeId}/grants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * `GET /v1/directory/nodes/{nodeId}/move-preview` — what a move would expose.
 *
 * Asks what a move would change about who can reach a node, before making it. Changes nothing.
 *
 * `peopleGainingAccess` is how many would be able to reach the moved items and cannot today, so a confirmation can say it instead of the person finding out afterwards.
 *
 * `peopleLosingAccess` is the other direction: how many reach them today through the folder they sit in and would not at the destination. The move keeps every one of them in by writing a direct grant, so this reports what will be preserved rather than what will be lost. They are usually the people left behind rather than whoever is moving.
 *
 * Name the destination in `newParentId`. `PUT /directory/nodes/{nodeId}/parent` returns the same counts once the move has happened.
 *
 * Requires the same permission the move itself does, `editor` or `owner` on both ends and on the folder the item leaves, and refuses the same way, so it cannot be used to count the people in a folder the caller may not write:
 *
 * - `not_found` (404): either end is not visible to the caller
 * - `insufficient_role` (403): the caller can see an end and may only read it, or may not write the folder the item leaves
 */
export const v1DirectoryPreviewMove = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryPreviewMoveData, ThrowOnError>) => (options.client ?? client).get<V1DirectoryPreviewMoveResponses, V1DirectoryPreviewMoveErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/nodes/{nodeId}/move-preview',
    ...options
});

/**
 * `PUT /v1/directory/nodes/{nodeId}/org-link` — open a node to everyone in
 * the organization who has its link, change the role it opens with, or close
 * it (OPSSTD-9029).
 *
 * Opens a folder or a file to everyone in the organization who has its link, changes the role it opens with, or closes it.
 *
 * Send `role: "viewer"` or `role: "editor"` to open it, and `role: null` to close it. Nothing is granted: the setting is read on every request, so closing it takes the access back from everybody who came through it, and opening it again makes the old link work again. People given access by name are never affected.
 *
 * Everything inside an open folder is open too. A file or folder inside can be opened further — `viewer` to `editor` — but never less than the folder above it, and never closed while it is open: that is changed on the folder `orgLink.inheritedFrom` names.
 *
 * Reserved to whoever may share the node, exactly as `PUT /directory/nodes/{nodeId}/grants` is — somebody who owns it and, when `sharing.who_can_share` is `everyone`, somebody who can edit it, including through an opening to the organization.
 *
 * Answers the setting as it is now in force, the same shape `GET /directory/nodes/{nodeId}` carries as `orgLink`.
 *
 * Refused when:
 *
 * - `not_found` (404): the node is not visible to the caller
 * - `insufficient_role` (403): the caller can see the node and the sharing policy does not let their role share it
 * - `org_link_disabled` (403): the organization's `link.internal` turns openings off, or allows less than the role sent
 * - `org_link_on_personal_root` (409): the node is somebody's personal folder, which is never opened as a whole
 * - `org_link_inherited` (409): a folder above is already open with a stronger role, or at all when `null` was sent
 * - `owner_not_assignable` (422): `owner` was sent as the role
 */
export const v1DirectorySetOrgLink = <ThrowOnError extends boolean = true>(options: Options<V1DirectorySetOrgLinkData, ThrowOnError>) => (options.client ?? client).put<V1DirectorySetOrgLinkResponses, V1DirectorySetOrgLinkErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/nodes/{nodeId}/org-link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * `PUT /v1/directory/nodes/{nodeId}/parent` — move a node into another folder.
 *
 * Move a folder or a file into another folder. Open to anyone who can write **both** ends — `editor` or `owner` on the thing being moved and on the destination — and the folder it leaves, since taking something out of a folder is a write on it too. Nothing is copied and no stored bytes change place. Access follows the destination: whoever can reach the destination folder can reach the moved items, and `meta.peopleGainingAccess` counts the people for whom that is new, so a client can say it before the move rather than after — ask `GET /directory/nodes/{nodeId}/move-preview` for the same count without moving anything. The body also takes an optional `name`: leave it out and the item keeps the name it has, which is the ordinary move; send it and the item enters the destination under that name, moved and renamed in one write. After a `name_taken` refusal, send `details.suggestedName` back here as `name` — that is the whole of «keep both», and there is no moment in between where the item has been renamed but not moved. A name you send that is itself taken is refused the same way with the next free one, so the button works a second time without you counting. Answers 404 when either end is not visible to the caller, 403 when they can see an end and may only read it or may not write the folder the item leaves, 409 when the destination already holds the name — the one sent in `name`, or the one the item carries when none was sent — with a free alternative in `details.suggestedName`, or when the destination is in the bin, and 422 when `name` breaks a naming rule (`details.reason` says which), when the destination is inside the folder being moved, is a file, or the move would push a branch past the depth or path limits, or when the thing being moved is somebody's personal folder (`personal_folder_cannot_move`). Personal folders are roots and stay roots whoever asks, the colleague one was shared with included: a root that acquires a parent is reachable by everybody who can read its new home, and the whole personal subtree travels with it. Send `If-Match` with the node's `metaRevision` and a move that finds the node renamed, moved, binned or restored since is refused with 412 `precondition_failed`, the node as it is now in `details.node`, and nothing moves; without it the later write wins. A body or an `If-Match` it cannot read answers 400. Send an `idempotency-key` header and a repeat with the same key gets the first answer, marked `Idempotent-Replayed: true`, instead of doing the work again; the same key on a different request answers 422 `idempotency_key_reused`, and a repeat that arrives while the first request is still running answers 409 `idempotency_in_flight` with `Retry-After`.
 */
export const v1DirectoryMoveNode = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryMoveNodeData, ThrowOnError>) => (options.client ?? client).put<V1DirectoryMoveNodeResponses, V1DirectoryMoveNodeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/nodes/{nodeId}/parent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * `GET /v1/directory/nodes/{nodeId}/versions` — a file's history, newest
 * first.
 *
 * List the versions of a file, newest first. Anyone who can see the file may read its history. Every upload that replaced the file's content is a version, and so is every restore; the one marked `current` is what a download of the file serves. A version whose content was deleted for good is not listed. A file uploaded before version history existed starts its history at its next upload, so it may list nothing. Page with `cursor` from the previous response and never build one yourself.
 *
 * Refused when:
 *
 * - `not_found` (404): the file is not visible to the caller.
 * - `node_not_a_file` (422): the id belongs to a folder.
 * - `cursor_invalid` (422): the cursor was minted for another file, tampered with, or is older than a day. Start again from the first page.
 */
export const v1DirectoryListVersions = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryListVersionsData, ThrowOnError>) => (options.client ?? client).get<V1DirectoryListVersionsResponses, V1DirectoryListVersionsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/nodes/{nodeId}/versions',
    ...options
});

/**
 * `DELETE /v1/directory/nodes/{nodeId}/versions/{versionId}` — an earlier
 * version's content removed for good, its place in the history kept
 * (OPSSTD-9034).
 *
 * Delete an earlier version of a file. Its content is removed for good and cannot be opened, downloaded or restored again; the version stays in the file's history, in its place and with its date and author, with `state` `purged`. Only an earlier version can be deleted, never the current one. The caller must be able to edit the file. Deleting a version already deleted answers success again.
 *
 * Refused when:
 *
 * - `not_found` (404): the file is not visible to the caller, or the version is not one of its versions.
 * - `insufficient_role` (403): the caller may only read the file.
 * - `state_conflict` (409): the version is the file's current one. Restore another version first if this one has to go.
 * - `node_not_a_file` (422): the id belongs to a folder.
 */
export const v1DirectoryDeleteVersion = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryDeleteVersionData, ThrowOnError>) => (options.client ?? client).delete<V1DirectoryDeleteVersionResponses, V1DirectoryDeleteVersionErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/nodes/{nodeId}/versions/{versionId}',
    ...options
});

/**
 * `POST /v1/directory/nodes/{nodeId}/versions/{versionId}/download-authorizations`
 * — permission to download one version of a file.
 *
 * Get a link to download one version of a file, or to show it. Anyone who can see the file may ask, for any version its history lists. The link behaves exactly like a download of the file itself — signed, valid for `expiresInSeconds`, for this one version only — and `disposition` works the same way. An earlier version is saved under the file's name with its version number added, as in `Report (v2).pdf`; the current version keeps the plain name. Treat the link as a secret.
 *
 * **An `inline` URL also pins the media type, from the file's extension.** The signature carries the type this server holds for that extension, not the one recorded on the stored object, because that one is whatever the client that uploaded it declared and nothing has ever checked it against the name. For an extension this server names no type for — anything the viewer cannot preview, and `.svg`, which it draws but a browser would run as a document — the request is still answered and the URL saves instead of showing. Either way the count is a preview, because that is what was asked. A viewer loses nothing: it fetches the bytes and draws them itself rather than sending the browser to the URL.
 *
 * Refused when:
 *
 * - `not_found` (404): the file is not visible to the caller, or the version is not one of this file's listed versions.
 * - `conflict` (409): the file is still being uploaded.
 * - `node_not_a_file` (422): the id belongs to a folder.
 */
export const v1DirectoryAuthorizeVersionDownload = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryAuthorizeVersionDownloadData, ThrowOnError>) => (options.client ?? client).post<V1DirectoryAuthorizeVersionDownloadResponses, V1DirectoryAuthorizeVersionDownloadErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/nodes/{nodeId}/versions/{versionId}/download-authorizations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * `POST /v1/directory/nodes/{nodeId}/versions/{versionId}/restoration` —
 * make an earlier version current again, as a new version.
 *
 * Make an earlier version of a file current again, as a new version. Reserved to somebody who can edit the file. The file gets the chosen version's content under a new version number at the top of its history, and every version before stays exactly as it was: a restore adds to the history and never rewrites it, so the version that was current a moment ago can itself be restored later. Nothing is copied and there is no size limit. Send `expectedVersion` — the file's `version` as you last read it — to be told rather than overwrite when somebody changed the file first. Send an `idempotency-key` header and a retry gives you the first answer instead of creating a second version. Send `X-Batch-Id` to fold several restores into one summary; this route never restores more than one file per call, so it always opens a batch of one.
 *
 * Refused when:
 *
 * - `not_found` (404): the file is not visible to the caller, or the version is not one of its listed versions.
 * - `insufficient_role` (403): the caller may only read the file.
 * - `version_conflict` (409): somebody changed the file after the version you sent, or is uploading a new version of it right now. `details` names who and when.
 * - `conflict` (409): the file's first upload has not finished.
 * - `node_not_a_file` (422): the id belongs to a folder.
 */
export const v1DirectoryRestoreVersion = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryRestoreVersionData, ThrowOnError>) => (options.client ?? client).post<V1DirectoryRestoreVersionResponses, V1DirectoryRestoreVersionErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/nodes/{nodeId}/versions/{versionId}/restoration',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * `GET /v1/directory/recent` — the caller's files, newest content first.
 *
 * List the files the caller can reach, newest content first: ordered by `contentChangedAt`, the moment the content each file serves was recorded — its upload, its latest new version, or the restore of an earlier version — then by id. Renaming, moving, or taking a file through the bin and back does not change it. Only active files: never a folder, never anything in the bin or still uploading. `scope` narrows where to look exactly as on the search: `everything` (the default) is every root the caller can reach plus their own personal folder, `shared-with-me` the same set without it, and `folder` one folder's whole subtree, named by `folderId`. The bin is not a scope here. Each row is a listing row with the role the caller holds on the file and `contentChangedAt`. One page, at most `limit` files and never more than fifty; there is no cursor. Returns an empty list for a caller with nothing to reach.
 */
export const v1DirectoryListRecent = <ThrowOnError extends boolean = true>(options?: Options<V1DirectoryListRecentData, ThrowOnError>) => (options?.client ?? client).get<V1DirectoryListRecentResponses, V1DirectoryListRecentErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/recent',
    ...options
});

/**
 * `GET /v1/directory/search` — nodes found by name inside the roots the
 * caller can reach, most relevant first.
 *
 * Find nodes by name inside the roots the caller can reach. Matches node names only — never file content, which the Sync Server never touches — with a declared, deterministic relevance: exact match, then prefix, then substring; inside each tier, trigram similarity, then last-modified descending, then id. Under three characters the match falls back to a prefix and the similarity term disappears from the order, which retires any cursor minted the other way. `scope` narrows where the search looks: `everything` (the default) is every root the caller can reach plus their own personal folder, `shared-with-me` is the same set without it, `folder` is one folder's whole subtree, named by `folderId`, and `trash` is exactly the set the bin's own listing shows — the trashed nodes on which the caller holds `editor` or better, evaluated as if each were still live — matched by name instead of paged by when it was binned. `trash` never looks inside a trashed folder: only the bin's own tops are searched, the same as its listing. `categories` and `people` compose on top of the scope exactly as they do on the two listings. Page with `cursor` from the previous response and never build one yourself; a cursor minted under another text, scope or filter set is refused, and so is one older than a day. Returns an empty list for a caller with nothing to search. Every row also carries `rootId`, `rootType` and `path`: which accessible root the hit came from, whether that root is the caller's own tree, one shared with them, or a top of the bin, and the folders strictly between the root and the hit — relative to that root and never above it. Under `scope=trash` a hit is always its own root: `rootType` is `trash`, `rootId` is the hit's own id and `path` is always empty.
 */
export const v1DirectorySearch = <ThrowOnError extends boolean = true>(options: Options<V1DirectorySearchData, ThrowOnError>) => (options.client ?? client).get<V1DirectorySearchResponses, V1DirectorySearchErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/search',
    ...options
});

/**
 * `GET /v1/directory/shared-with-me` — the caller's navigation roots.
 *
 * List the folders and files shared with the caller — the roots of what they can navigate. Each row is a listing row with two more fields: who opened the access and when, so the list can be read as a history rather than as a pile of folders; `sharedBy` is null when nobody is on record or that account is gone. The caller's own personal folder is **not** here even though they own it — it is nobody's share, and its id comes from `GET /users/me` as `personalFolderId`; a colleague's personal folder shared with the caller is. A node whose parent is already reachable is not returned either: it is something the caller reaches by opening its folder, and listing it separately would show the same thing twice; a node whose only reachable ancestor is in the bin *is* returned, because there is nothing left to reach it through. Order with `sortBy` — `name`, `updatedAt`, `size` or `lastViewed` — and `sortDirection`, with folders above files in every order. `lastViewed` orders the page for the caller alone: folders by name, then the roots the caller has opened (most recent first), then the roots the caller has never opened, by name; a client who sends `sortBy=lastViewed` and no `sortDirection` gets `desc`, newest view first, where every other key defaults to `asc` — send `sortDirection` explicitly to ask for the oldest view first instead, which reorders only the viewed roots. Page with `cursor` from the previous response and never build one yourself; a cursor older than a day is refused, and the client restarts from the first page. Returns an empty list when nothing has been shared.
 */
export const v1DirectoryListSharedWithMe = <ThrowOnError extends boolean = true>(options?: Options<V1DirectoryListSharedWithMeData, ThrowOnError>) => (options?.client ?? client).get<V1DirectoryListSharedWithMeResponses, V1DirectoryListSharedWithMeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/shared-with-me',
    ...options
});

/**
 * `POST /v1/directory/thumbnails` — the thumbnails of up to a hundred files.
 *
 * Get the thumbnails of up to a hundred files, and, for people who can edit them, what is needed to make the ones that are missing.
 *
 * **A thumbnail is supplied by a client with write access. The server does not derive it**: no byte of a file's content ever passes through this service, so it cannot decode one. It signs links, checks with the storage that a picture arrived, and remembers that it did. The picture is made by the client that uploaded the file, or by the first person with `editor` or `owner` access to open it in a client that can.
 *
 * **The rendition every client produces:** the longest edge 512 px, aspect ratio kept, never scaled up; lossy WebP at about 0.75 quality; the EXIF orientation applied so the picture is the right way up, and all metadata dropped; at most 256 KiB (262144 bytes). An animated image is rendered from its first frame. An image larger than 25 MiB or over 50 megapixels is not rendered.
 *
 * **What the client can draw.** `renderers` names the families of files the client can make a thumbnail of: `image`, `pdf`, `office`, `video` and `text` (the field lists the extensions in each). A request without it is answered as a browser's, which draws images, and that is what the web sends. With it, a file in a family the client did not declare is `unsupported` to this client unless a thumbnail is already there, and a file in a declared family is `missing` until one is. A client that declares `image` is also asked for `heic`, `heif`, `tiff` and `tif`. Outside the image family there is no size limit and no `sourceUrl`: the client draws the file from a copy it already holds.
 *
 * Each file in `nodeIds` comes back with one status. `ready` carries a signed `url` to the WebP and `expiresAt`. `missing` means there is none yet: someone with write access also gets `storageVersionId` and, for `jpg`, `jpeg`, `png`, `gif`, `webp`, `avif` and `bmp` up to 25 MiB, a signed `sourceUrl` to download the original from; a viewer gets nothing more. `unsupported` means this version has none and this client should not try: it is in no family the client draws (`svg`, `psd`, `ai`, audio and archives are in none), it is an image over 25 MiB, it is a `heic`, `heif`, `tiff` or `tif` nobody has uploaded one for and the request has no `renderers`, or a person with write access reported that it cannot be drawn and this client declares no family that person's client did not. `not_found` is the answer for a file that does not exist, is in the bin, is a folder, or that the caller cannot see, and there is no way to tell those apart.
 *
 * To supply a thumbnail: render it, send its exact byte length in `uploads` with the `storageVersionId` from the `missing` answer, and PUT the WebP to the `uploadUrl` that comes back, with exactly the `uploadHeaders`. The link refuses any other length and refuses to overwrite a thumbnail that is already there. Then ask again: the server checks the storage, records the thumbnail, and every client with the folder open is told with a `node.thumbnail_ready` event. Clients that upload a file can do this straight after the upload for the formats above and also for `heic`, `heif`, `tiff` and `tif`, which the server never asks a browser to render from a download.
 *
 * Report a file that cannot be drawn in `failed` so no client like yours tries again; only for failures that are the file's, since the answer is kept for every client that declares no family yours did not. The call is safe to repeat.
 */
export const v1DirectoryGetThumbnails = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryGetThumbnailsData, ThrowOnError>) => (options.client ?? client).post<V1DirectoryGetThumbnailsResponses, V1DirectoryGetThumbnailsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/thumbnails',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * `GET /v1/directory/trash` — the caller's bin, newest first.
 *
 * List what is in your bin, most recently binned first. Your bin holds what you could restore: every file and folder in the bin on which you can edit, wherever it was. A folder in the bin is listed once, with what was inside it — the files inside come back with it and are not listed on their own. Each item says when it was binned, by whom, and which folder it came from; that folder is null when you can no longer see it. Items whose permanent deletion has begun are not listed. Each item also says whether you may delete it permanently, `canPurge` — the same rule `POST /directory/trash/permanent-deletion` enforces — and, only where that is false, `owner`: who owns the space it is in, the person to ask or who can destroy it themselves. Page with `cursor` from the previous response and never build one yourself.
 *
 * Refused when:
 *
 * - `cursor_invalid` (422): the cursor was minted for somebody else's bin, by another route or under another category filter, tampered with, or is older than a day. Start again from the first page.
 */
export const v1DirectoryListTrash = <ThrowOnError extends boolean = true>(options?: Options<V1DirectoryListTrashData, ThrowOnError>) => (options?.client ?? client).get<V1DirectoryListTrashResponses, V1DirectoryListTrashErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/trash',
    ...options
});

/**
 * `POST /v1/directory/trash` — send one or more files and folders to the bin.
 *
 * Send one or more files and folders to the bin. Open to anyone who holds `editor` on a node, or on a folder above it. Applies to what it can and reports the rest: the response names every node that was actually trashed and, separately, every node the caller can see but this call could not trash, with the code that explains why (`insufficient_role`, or `upload_in_progress` for a node still receiving a transfer). A node the caller cannot see at all — another organization's, one that does not exist, or one already in the bin — is left out of both lists rather than reported, the same way a batch read of nodes omits one it cannot show. A folder's contents are not walked: sending a folder here hides everything inside it without touching a single one of those rows, and costs the same whether the folder is empty or has ten thousand files in it. The same id sent twice counts once. Send `X-Batch-Id` to fold several sends into one summary — a multi-selection send shares one id. Send `If-Match` with the node's `metaRevision` when the call names one node, and a node renamed, moved, binned or restored since is not trashed: the whole call answers 412 `precondition_failed` with the node as it is now in `details.node`. Send an `idempotency-key` header and a repeat with the same key gets the first answer, marked `Idempotent-Replayed: true`, instead of doing the work again; the same key on a different request answers 422 `idempotency_key_reused`, and a repeat that arrives while the first request is still running answers 409 `idempotency_in_flight` with `Retry-After`.
 */
export const v1DirectoryTrash = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryTrashData, ThrowOnError>) => (options.client ?? client).post<V1DirectoryTrashResponses, V1DirectoryTrashErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/directory/trash',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * `POST /v1/directory/trash/emptying` — destroy for good everything in the
 * bin that the caller owns.
 *
 * Empty your bin: every item in it that you own is deleted permanently, with every version of every file inside, and none of it can be recovered. What is somebody else's to destroy stays in the bin. Send the `purgeableCount` that `GET /v1/directory/trash/emptying-preview` gave and the person confirmed, as `expectedCount`: when the bin changed since, nothing is deleted and the answer is 409. From the moment of the answer the items are gone from the bin and from every read; their storage is emptied shortly after.
 *
 * Refused when:
 *
 * - `state_conflict` (409): the number of items the emptying would destroy is no longer `expectedCount`. Count again and ask again.
 */
export const v1DirectoryEmptyTrash = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryEmptyTrashData, ThrowOnError>) => (options.client ?? client).post<V1DirectoryEmptyTrashResponses, V1DirectoryEmptyTrashErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/trash/emptying',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * `GET /v1/directory/trash/emptying-preview` — what emptying the bin would
 * destroy, said before it is asked for.
 *
 * Say what emptying your bin would destroy, before anybody confirms it: how many items, how many bytes they hold with every version of every file inside them, and how many items would stay because they are somebody else's to destroy. Emptying destroys only what you own — the items in spaces you own, and the ones whose every file you created yourself — never what you can merely restore. Send `purgeableCount` back as `expectedCount` when confirming.
 */
export const v1DirectoryPreviewTrashEmptying = <ThrowOnError extends boolean = true>(options?: Options<V1DirectoryPreviewTrashEmptyingData, ThrowOnError>) => (options?.client ?? client).get<V1DirectoryPreviewTrashEmptyingResponses, V1DirectoryPreviewTrashEmptyingErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/trash/emptying-preview',
    ...options
});

/**
 * `POST /v1/directory/trash/permanent-deletion` — destroy items in the bin,
 * for good.
 *
 * Delete items in the bin permanently: every version of every file inside them is destroyed, and none of it can be recovered. Only the owner of what is being destroyed may do it — the owner of the space it is in, or somebody who created every item inside it themselves; being able to edit is not enough. From the moment of the answer the items are gone from the bin and from every other read, contents included; their storage is emptied shortly after. The response names what was accepted and, separately, what was not and why. An item you cannot see at all is left out of both lists.
 *
 * Refused per item, in `refused`:
 *
 * - `purge_not_allowed`: it is not yours to destroy. `details.ownerId` and `details.ownerName` name the owner of the space to ask; `details.createdByOthers` counts the items inside somebody else created.
 * - `node_purged`: its permanent deletion has already begun.
 * - `state_conflict`: it is not in the bin. Send it there first.
 *
 * Refused as a whole:
 *
 * - `precondition_failed` (412): the call named one item with `If-Match`, and the item was renamed, moved, binned or restored since. Nothing was destroyed; `details.node` is the item as it is now.
 * - `validation_error` (400): `If-Match` came with more than one item, or is not one quoted revision.
 * - `too_many_nodes` (422): more than 100 items.
 * - `idempotency_key_reused` (422) and `idempotency_in_flight` (409): the `idempotency-key` was used for a different request, or the first request with it is still running.
 *
 * Send an `idempotency-key` header and a repeat with the same key gets the first answer, marked `Idempotent-Replayed: true`, instead of doing the work again.
 */
export const v1DirectoryDeletePermanently = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryDeletePermanentlyData, ThrowOnError>) => (options.client ?? client).post<V1DirectoryDeletePermanentlyResponses, V1DirectoryDeletePermanentlyErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/trash/permanent-deletion',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * `GET /v1/directory/trash/preview` — how many items a send to the bin would
 * take with it.
 *
 * Count how many items of a node's subtree would move to the bin if it were sent there now, the node itself included: 1 for a file, and the node plus every descendant for a folder — a descendant already in the bin included, since sending an ancestor to the bin does not touch its descendants' own rows. Name up to 100 nodes in `nodeIds`, repeating the parameter for more than one. Requires the same `editor` role `POST /directory/trash` requires. A node the caller can see but cannot edit is named in `refused` with the code the actual send would answer for it; a node the caller cannot see at all is left out of the response entirely, the same way a batch read of nodes omits one it cannot show. Changes nothing.
 *
 * Refused per item, in `refused`:
 *
 * - `insufficient_role`: you can see the node and hold less than `editor` on it.
 */
export const v1DirectoryPreviewTrash = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryPreviewTrashData, ThrowOnError>) => (options.client ?? client).get<V1DirectoryPreviewTrashResponses, V1DirectoryPreviewTrashErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/trash/preview',
    ...options
});

/**
 * `POST /v1/directory/trash/restoration` — bring items back from the bin.
 *
 * Bring one or more items back from the bin, into the folder each came from. You need to be able to edit an item to restore it. A folder comes back with everything that was in it. A restore never overwrites and never renames by itself: when the name is taken where an item is going, that item is refused with `name_taken` and the free name it would get, and restored under that name only if you send `onNameConflict: "rename"`. When the folder an item came from is itself in the bin, the item is refused with `parent_trashed` and that folder's id; restore the folder first, or send `destinationId` to put the items of this call somewhere else, which needs `editor` there. The response names what came back and, separately, what did not and why. An item you cannot see at all is left out of both lists. Send `X-Batch-Id` to fold several restores into one summary — a multi-selection restore shares one id.
 *
 * Refused per item, in `refused`:
 *
 * - `name_taken`: the name is taken where the item is going. `details.suggestedName` is the free one.
 * - `parent_trashed`: the folder it came from is in the bin. `details.originalParentId` names it.
 * - `node_purged`: its permanent deletion has begun, and it can no longer come back.
 * - `insufficient_role`: you can see it but not edit it.
 * - `state_conflict`: it is not in the bin.
 *
 * Refused as a whole:
 *
 * - `not_found` (404) or `insufficient_role` (403): `destinationId` is a folder you cannot see, or cannot edit.
 * - `precondition_failed` (412): the call named one item with `If-Match`, and the item was renamed, moved, binned or restored since. Nothing came back; `details.node` is the item as it is now.
 * - `validation_error` (400): `If-Match` came with more than one item, or is not one quoted revision.
 * - `too_many_nodes` (422): more than 100 items.
 * - `idempotency_key_reused` (422) and `idempotency_in_flight` (409): the `idempotency-key` was used for a different request, or the first request with it is still running.
 *
 * Send an `idempotency-key` header and a repeat with the same key gets the first answer, marked `Idempotent-Replayed: true`, instead of doing the work again.
 */
export const v1DirectoryRestoreFromTrash = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryRestoreFromTrashData, ThrowOnError>) => (options.client ?? client).post<V1DirectoryRestoreFromTrashResponses, V1DirectoryRestoreFromTrashErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/trash/restoration',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Your folder uploads that still have files on their way, newest first, at most 50 — what to offer to resume after a reload, or to give up whole. Only your own, and only those whose root folder is still live. Each one says how many of its files are still pending and how many are already live; announcing its paths again resumes it.
 */
export const v1DirectoryListUploadBatches = <ThrowOnError extends boolean = true>(options?: Options<V1DirectoryListUploadBatchesData, ThrowOnError>) => (options?.client ?? client).get<V1DirectoryListUploadBatchesResponses, V1DirectoryListUploadBatchesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/upload-batches',
    ...options
});

/**
 * Give up a whole folder upload: up to fifty of its files you are still sending are abandoned per call, exactly as `POST /directory/uploads/abandonment` abandons them, and their names are freed. What already arrived stays. `remaining` is `1` while the batch still has transfers left — call again until it is `0`. Another person's batch under the same id is untouched (`abandoned: 0`). Answers 400 when `batchId` is not a UUID.
 */
export const v1DirectoryAbandonUploadBatch = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryAbandonUploadBatchData, ThrowOnError>) => (options.client ?? client).post<V1DirectoryAbandonUploadBatchResponses, V1DirectoryAbandonUploadBatchErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/upload-batches/{batchId}/abandonment',
    ...options
});

/**
 * Confirm up to fifty files of a folder upload in one call, once their bytes are in the storage. Each file is confirmed exactly as `POST /directory/files/{nodeId}/upload/completion` confirms it, and its outcome is folded into one upload summary under `batchId`. The answer carries one outcome per file in the order sent: `completed` with the live file, or `refused` with the code the single confirmation would have answered — `retry_later` when the storage or the database did not answer, so only that file needs confirming again. Confirming a file this batch already confirmed answers `completed` again and changes nothing, so a repeated call is harmless. Answers 400 when `batchId` is not a UUID or `items` is empty or holds more than 50 files.
 */
export const v1DirectoryCompleteBatchFiles = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryCompleteBatchFilesData, ThrowOnError>) => (options.client ?? client).post<V1DirectoryCompleteBatchFilesResponses, V1DirectoryCompleteBatchFilesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/upload-batches/{batchId}/completions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Announce up to fifty files of a folder upload in one call. `batchId` is a UUID you make up for the whole folder upload and send on every call of it; `rootId` is the folder it goes into, and each `relativePath` is a file's path below it — the folders on the way are created as needed, or merged into when a live folder already holds the name. Each file is decided exactly as `POST /directory/files` decides it, and the answer carries one outcome per file in the order sent: `opened` with that route's answer in `result` (the signed PUT or the multipart plan), `completed` when this path of this batch is already one of your live files, `conflict` when your own file holds the name — send it again with `onNameConflict` once the person has chosen — or `refused` with the code the single route would have answered. Announcing the same paths again is safe: a completed file answers `completed`, an unfinished one is resumed (`meta.resumed: true`), and nothing is created twice. Answers 400 when `batchId` is not a UUID or `items` is empty or holds more than 50 files, 404 when the root is not visible, 403 when you may only read it, and 409 when it is in the bin.
 */
export const v1DirectoryAnnounceBatchFiles = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryAnnounceBatchFilesData, ThrowOnError>) => (options.client ?? client).post<V1DirectoryAnnounceBatchFilesResponses, V1DirectoryAnnounceBatchFilesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/upload-batches/{batchId}/files',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * `GET /v1/directory/uploads` — the uploads the caller left running.
 *
 * List the uploads you left unfinished, so a closed tab or a reloaded page does not mean starting over. Each row carries the file name and size the upload was opened with, how many parts have landed, and when the chance to continue runs out. Only your own uploads appear — a colleague's is absent rather than refused, so nothing here tells you what other people are doing. Takes no filters: the list is always the caller's own and always the whole of it. Ask the person to pick the same file again, then send its name and size to `POST /directory/uploads/{uploadId}/resumption`.
 */
export const v1DirectoryListUploadsInProgress = <ThrowOnError extends boolean = true>(options?: Options<V1DirectoryListUploadsInProgressData, ThrowOnError>) => (options?.client ?? client).get<V1DirectoryListUploadsInProgressResponses, V1DirectoryListUploadsInProgressErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/uploads',
    ...options
});

/**
 * `POST /v1/directory/uploads/abandonment` — give up on transfers.
 *
 * Give up on one or more transfers that are still open. The parts already sent are thrown away, the object is removed from the store, and the name comes free in the folder straight away — a transfer nobody is going to finish otherwise holds its name for the whole seven-day window. An open replace (`onNameConflict: "replace"` on `POST /directory/files`) is named by the same node id and abandons the same way, except that the node itself is untouched: it was never changed to begin with, so giving up on the replace leaves it exactly as it was, current version and all.
 *
 * Takes node ids rather than upload ids, because a file under the multipart threshold goes up as a single PUT and has no upload id to name.
 *
 * Only whoever opened a transfer can abandon it; for anybody else it answers as though it were not there. A transfer that has already finished or already been abandoned is not an error: it is simply absent from `abandoned`.
 */
export const v1DirectoryAbandonUploads = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryAbandonUploadsData, ThrowOnError>) => (options.client ?? client).post<V1DirectoryAbandonUploadsResponses, V1DirectoryAbandonUploadsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/directory/uploads/abandonment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * `POST /v1/directory/uploads/{uploadId}/part-urls` — the next batch of part
 * links, or named ones re-issued.
 *
 * Get links for the parts of an upload you have not sent yet. Pass back the `nextPartNumber` you were given to continue where the last batch ended, or name `partNumbers` to replace links that expired while you were sending. Parts already acquired are never handed out again — that is what makes resuming cheap. An empty `parts` array means everything has landed and the upload is ready to be finished. Answers 404 when the upload is not yours or does not exist, 403 when you may only read the file, and 409 when the upload is finished, given up, or past the moment it could be resumed.
 */
export const v1DirectoryIssuePartUrls = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryIssuePartUrlsData, ThrowOnError>) => (options.client ?? client).post<V1DirectoryIssuePartUrlsResponses, V1DirectoryIssuePartUrlsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/uploads/{uploadId}/part-urls',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * `PUT /v1/directory/uploads/{uploadId}/parts/{partNumber}` — one part landed.
 *
 * Tell the server a part landed, with the `ETag` the storage gave you for it. Do this as each part finishes, not at the end: it is what lets an interrupted upload pick up where it stopped instead of starting over. Sending the same part twice with the same `ETag` is safe and does nothing. Answers 404 when the upload is not yours, 403 when you may only read the file, 409 when the upload is closed, the part is outside the plan, or the same part was already confirmed with different bytes.
 */
export const v1DirectoryConfirmPart = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryConfirmPartData, ThrowOnError>) => (options.client ?? client).put<V1DirectoryConfirmPartResponses, V1DirectoryConfirmPartErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/uploads/{uploadId}/parts/{partNumber}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * `POST /v1/directory/uploads/{uploadId}/resumption` — pick an interrupted
 * upload back up, on the same file it was opened with.
 *
 * Continue an upload that was interrupted, after the person picks the same file again. Send the `name` and `sizeInBytes` of the file they picked: the server checks them against what the upload was opened with — picking a different file would build a broken file out of two, with nothing downstream able to tell — and then hands out links for the parts that are still missing, and only those. Resuming does not extend the deadline: the window runs from when the upload was opened. Answers 409 when the file does not match or the upload has expired, 403 when access to the folder was taken away meanwhile, and 404 when the upload or its file is gone; in all three the parts already sent are thrown away, so nothing keeps costing anybody money — which is also why this is not a call anything may repeat on its own.
 */
export const v1DirectoryResumeUpload = <ThrowOnError extends boolean = true>(options: Options<V1DirectoryResumeUploadData, ThrowOnError>) => (options.client ?? client).post<V1DirectoryResumeUploadResponses, V1DirectoryResumeUploadErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/v1/directory/uploads/{uploadId}/resumption',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * `GET /v1/public/links/{token}`
 *
 * What a public link points to, for the page a recipient opens. Needs no session: the token in the path is the whole credential. A link with a password answers `{ "locked": true }` and nothing else until it is unlocked — not the name, not the size, not who shared it. An unknown token, an expired or revoked link, and one whose organization has turned links off all answer the same 404, so the page cannot tell them apart and neither can anyone guessing tokens.
 *
 * `link.kind` says which page to draw. A `download` link is a file or a folder to view and download. An `upload` link asks for files: `node` is the folder they go into, `sharedBy` who is asking, `upload.maxFileSizeBytes` the largest file it takes, and nothing about what the folder holds is ever answered. An upload link whose creator can no longer write in that folder answers the same 404.
 */
export const v1PublicLinksGetLink = <ThrowOnError extends boolean = true>(options: Options<V1PublicLinksGetLinkData, ThrowOnError>) => (options.client ?? client).get<V1PublicLinksGetLinkResponses, V1PublicLinksGetLinkErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/public/links/{token}',
    ...options
});

/**
 * `POST /v1/public/links/{token}/files/{nodeId}/url`
 *
 * A short-lived URL to show or save one file reached through a link. Needs no session; a link with a password needs to have been unlocked on this browser. The bytes come straight from storage, never through this server. `inline` shows the file in the page and is answered only for formats the page can preview; `attachment` saves it.
 *
 * **An `inline` URL also pins the media type, from the file's extension.** The signature carries the type this server holds for that extension, not the one recorded on the stored object, because that one is whatever the client that uploaded it declared and nothing has ever checked it against the name. So a file called `.png` is served as `image/png` whatever its bytes are: renaming an SVG does not make a browser render it as a document.
 *
 * **An `.svg` asked for `inline` is answered, and the URL saves instead.** The signature carries `attachment` for that extension whatever was asked, because an SVG is a document rather than a picture and a browser sent to that URL would run the scripts inside the file on the storage's own origin. Both of these cost a viewer nothing: a viewer fetches the bytes and draws them in an `<img>`, where scripting is off, instead of sending the browser to the URL.
 *
 * Refused when:
 *
 * - `not_found` (404): the link is not available, or the file is outside it, in the bin, a folder, still uploading — or `inline` was asked for a format the page cannot preview. All the same answer, so a guessed id learns nothing.
 * - `link_password_required` (422): the link has a password and has not been unlocked here.
 */
export const v1PublicLinksGetFileUrl = <ThrowOnError extends boolean = true>(options: Options<V1PublicLinksGetFileUrlData, ThrowOnError>) => (options.client ?? client).post<V1PublicLinksGetFileUrlResponses, V1PublicLinksGetFileUrlErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/public/links/{token}/files/{nodeId}/url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * `GET /v1/public/links/{token}/folders/{nodeId}/children`
 *
 * One page of a folder inside a folder link: the link's own folder, or any folder below it. Needs no session. Folders come first, then files, by name. Page with `cursor` from the previous response. A folder above the link's folder, beside it, in the bin or in another link answers the same 404 as an unknown link, and so does a file link, which has nothing to list. A locked link answers `link_password_required` until it is unlocked.
 */
export const v1PublicLinksListFolder = <ThrowOnError extends boolean = true>(options: Options<V1PublicLinksListFolderData, ThrowOnError>) => (options.client ?? client).get<V1PublicLinksListFolderResponses, V1PublicLinksListFolderErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/public/links/{token}/folders/{nodeId}/children',
    ...options
});

/**
 * `POST /v1/public/links/{token}/thumbnails`
 *
 * The thumbnails of up to a hundred files reached through a link, for the grid of a shared folder. Needs no session; a link with a password needs to have been unlocked on this browser.
 *
 * **A thumbnail is supplied by a client with write access; the server does not derive it.** This route only reads what is on record. A file that has one comes back `ready` with a signed `url` to a lossy WebP whose longest edge is 512 px (aspect ratio kept, never scaled up, EXIF orientation applied, all metadata removed, at most 256 KiB); a file that has none comes back `missing` and the page shows its icon. Nothing is generated because of this call, and it never asks the storage anything.
 *
 * An id that is outside the link, in the bin, a folder, or does not exist comes back `not_found`, and there is no way to tell those apart. A locked link answers `link_password_required` (422); an unknown token or an unavailable link answers the same 404 as every other link route.
 */
export const v1PublicLinksGetThumbnails = <ThrowOnError extends boolean = true>(options: Options<V1PublicLinksGetThumbnailsData, ThrowOnError>) => (options.client ?? client).post<V1PublicLinksGetThumbnailsResponses, V1PublicLinksGetThumbnailsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/public/links/{token}/thumbnails',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * `POST /v1/public/links/{token}/unlock`
 *
 * Enter a link's password. Needs no session. On the right password the answer carries a cookie that keeps the link open on this browser: every request to the link renews it, and ten minutes with no request close it again, as does the link's own expiry. The cookie opens this link and no other, and a link revoked or expired stops answering at once, cookie or not.
 *
 * Refused when:
 *
 * - `link_password_incorrect` (422): the password is not the link's. The same answer whatever was wrong with it.
 * - `not_found` (404): the link is not available — the same answer `GET /v1/public/links/{token}` gives. A link with no password answers `204` without setting anything.
 * - `rate_limited` (429): five wrong passwords from this address in fifteen minutes, or twenty for this link from anywhere in an hour. The right password is refused too until `Retry-After` has passed.
 */
export const v1PublicLinksUnlock = <ThrowOnError extends boolean = true>(options: Options<V1PublicLinksUnlockData, ThrowOnError>) => (options.client ?? client).post<V1PublicLinksUnlockResponses, V1PublicLinksUnlockErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/public/links/{token}/unlock',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * `POST /v1/public/links/{token}/uploads`
 *
 * Start sending one file through an upload link. Needs no session; a link with a password needs to have been unlocked on this browser. The file goes straight to storage in parts, never through this server: PUT each part to its link, confirm it with the `ETag` the storage answered, then finish. A file the folder already has a name for goes in under the next free name, and nothing in any answer says which — the sender learns nothing about what the folder holds. Send an `idempotency-key` header and a retry gets the first answer instead of a second file.
 *
 * Refused when:
 *
 * - `not_found` (404): the link is not available, or is not an upload link — the same answer every link route gives.
 * - `link_password_required` (422): the link has a password and has not been unlocked here.
 * - `object_too_large` (422): the file is larger than this link takes in a whole day, which `GET /v1/public/links/{token}` reports as `upload.maxFileSizeBytes`.
 * - `invalid_name` (422): the name is not one a file can have.
 * - `storage_quota_exceeded` (429): the folder has no room for the file, because it would take the link's creator or the organization past a storage quota. Nothing says whose limit or how much is left; waiting does not change the answer.
 * - `rate_limited` (429): too many requests from this address, or this link has taken as many files or bytes as it takes in a day. `Retry-After` says when to try again.
 */
export const v1PublicLinksOpenUpload = <ThrowOnError extends boolean = true>(options: Options<V1PublicLinksOpenUploadData, ThrowOnError>) => (options.client ?? client).post<V1PublicLinksOpenUploadResponses, V1PublicLinksOpenUploadErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/public/links/{token}/uploads',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * `DELETE /v1/public/links/{token}/uploads/{uploadId}`
 *
 * Give up on a transfer through an upload link that has not finished: the parts already sent are thrown away, and nothing reaches the folder. Giving up on one that already finished or was already given up answers the same, and changes nothing. Needs no session.
 *
 * Refused when:
 *
 * - `not_found` (404): the link is not available, or the transfer is not this link's.
 * - `link_password_required` (422): the link has a password and has not been unlocked here.
 */
export const v1PublicLinksAbandonUpload = <ThrowOnError extends boolean = true>(options: Options<V1PublicLinksAbandonUploadData, ThrowOnError>) => (options.client ?? client).delete<V1PublicLinksAbandonUploadResponses, V1PublicLinksAbandonUploadErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/public/links/{token}/uploads/{uploadId}',
    ...options
});

/**
 * `POST /v1/public/links/{token}/uploads/{uploadId}/completion`
 *
 * Finish a transfer through an upload link, once every part has been confirmed: the delivery confirmation. The server checks with the storage that the file is there and the size declared before it puts the file in the folder; one that arrived any other size is refused and thrown away. Needs no session. Send an `idempotency-key` header and a retry after a lost answer gets the first one. A link revoked while the file was on its way delivers nothing, even if every part landed.
 *
 * Refused when:
 *
 * - `not_found` (404): the link is not available, or the transfer is not this link's.
 * - `link_password_required` (422): the link has a password and has not been unlocked here.
 * - `state_conflict` (409): parts are still missing — nothing is lost, send them and finish again — or the transfer was given up.
 * - `upload_verification_failed` (409): the storage holds a different size than was declared. Send the file again.
 * - `upload_target_deleted` (409): the file was removed from the folder while it was on its way.
 */
export const v1PublicLinksCompleteUpload = <ThrowOnError extends boolean = true>(options: Options<V1PublicLinksCompleteUploadData, ThrowOnError>) => (options.client ?? client).post<V1PublicLinksCompleteUploadResponses, V1PublicLinksCompleteUploadErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/public/links/{token}/uploads/{uploadId}/completion',
    ...options
});

/**
 * `POST /v1/public/links/{token}/uploads/{uploadId}/part-urls`
 *
 * Links for the parts of a transfer through an upload link that have not been sent yet. Pass back `nextPartNumber` to continue where the last batch ended, or name `partNumbers` to replace links that expired while sending. Needs no session.
 *
 * Refused when:
 *
 * - `not_found` (404): the link is not available, or the transfer is not this link's.
 * - `link_password_required` (422): the link has a password and has not been unlocked here.
 * - `state_conflict` (409): the transfer was finished, given up, or left open longer than a day.
 */
export const v1PublicLinksIssuePartUrls = <ThrowOnError extends boolean = true>(options: Options<V1PublicLinksIssuePartUrlsData, ThrowOnError>) => (options.client ?? client).post<V1PublicLinksIssuePartUrlsResponses, V1PublicLinksIssuePartUrlsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/public/links/{token}/uploads/{uploadId}/part-urls',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * `PUT /v1/public/links/{token}/uploads/{uploadId}/parts/{partNumber}`
 *
 * Say one part of a transfer through an upload link landed, with the `ETag` the storage answered for it. Sending the same part twice with the same `ETag` is safe. Needs no session.
 *
 * Refused when:
 *
 * - `not_found` (404): the link is not available, or the transfer is not this link's.
 * - `link_password_required` (422): the link has a password and has not been unlocked here.
 * - `state_conflict` (409): the transfer is closed, the part is not one of its parts, or the same part was already confirmed with different bytes.
 */
export const v1PublicLinksConfirmPart = <ThrowOnError extends boolean = true>(options: Options<V1PublicLinksConfirmPartData, ThrowOnError>) => (options.client ?? client).put<V1PublicLinksConfirmPartResponses, V1PublicLinksConfirmPartErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v1/public/links/{token}/uploads/{uploadId}/parts/{partNumber}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
